<template>
  <div v-if="$can('read','candidates')">
    <!-- Alert: No item found -->
    <!--<b-alert
      variant="danger"
      :show="candidateData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching candidate data
      </h4>
      <div class="alert-body">
        No candidate found with this candidate id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-candidates-list'}"
        >
          Candidate List
        </b-link>
        for other candidates.
      </div>
    </b-alert>-->
    <ul class="breadcrumb" v-if="jobId">
      <li class="breadcrumb-item bitem"><a @click="$router.push({ name: 'dashboard-admin' })">Home</a></li>
      <li class="breadcrumb-item bitem"><a @click="$router.go(-2)">Jobs</a></li>
      <li class="breadcrumb-item bitem"><a @click="$router.push({ path: '/apps/view-job/' + jobId + '?savedPosition=' + savedPosition })">View Job</a></li>
      <li class="breadcrumb-item">Candidate View</li>
    </ul>
    <ul class="breadcrumb" v-else>
      <li class="breadcrumb-item bitem"><a @click="$router.push({name: 'dashboard-admin'})">Home</a></li>
      <li class="breadcrumb-item bitem"><a @click="$router.go(-1)">Candidates</a></li>
      <li class="breadcrumb-item">Candidate View</li>
    </ul>
    <div v-if="candidateData">
      <!-- <div v-if="error"> {{ error }}</div> -->
      <b-card>
        <b-row>
          <b-col cols="4" xl="4" md="4">
            <span class="text-danger" style="font-weight: 600; font-size: 14px">{{ error }}</span>
            <h4 style="padding-top: 12px">
            {{ candidateData.candidate_id }} - {{ candidateData.first_name}}  {{ candidateData.last_name}} <span v-if="candidateData.curr_position">    - ({{ candidateData.curr_position }})</span>
            </h4>
          </b-col>
          <b-col cols="8" xl="8" md="8" style="text-align: right;" >
              <!--{{ candidateData.jobs.filter(item => item.id == jobId)[0].candidate_jobs.candidateStatus }}-->
            <div class="demo-inline-spacing" style="float: right;" v-if="$can('update','candidate_status')">
                <div v-if="!isAssignMode && intNotIntNotRelVisible">
                    <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    :to="{
                              name: 'apps-candidates-edit', 
                              params: { id: candidateData.id, jobId: jobId },
                              query: {  position_name: position_name,
                                        client: client,
                                        attachments: attachments,
                                        rec_name: rec_name,
                                        locations: locations,
                                        position_type: positionType,
                                        vertical: vertical,
                                        category: category,
                                        payroll: payroll,
                                        // min_ctc: jobData.min_ctc,
                                        // max_ctc: jobData.max_ctc,
                                        // min_exp: jobData.min_exp,
                                        // max_exp: jobData.max_exp,
                                        // notice_period: jobData.notice_period,
                                        interested: 'YES',
                                        candidateStatus: prevStatus
                                }
                            }"
                  >
                    Interested
                  </b-button>
                </div>
                <div v-if="!isAssignMode && intNotIntNotRelVisible">
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    @click="showNINRModal('ni')"
                  >
                    Not Interested
                  </b-button>
                </div>
                <div v-if="!isAssignMode && intNotIntNotRelVisible">  
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-danger"
                    @click="showNINRModal('nr')"
                  >
                    Not Relevant
                  </b-button>
                </div>
                <div v-if="!isAssignMode && intNotIntNotRelVisible">  
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    @click="showDupModal()"
                  >
                    Duplicate
                  </b-button>
                </div>
                <div v-if="!isAssignMode && intNotIntNotRelVisible">  
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-secondary"
                    @click="showNotAnsweredModal()"
                  >
                    Call Related
                  </b-button>
                </div>
                <!-- <div>
                  <h6 class="mb-0 text-info"  v-if=" positionType === 'Contractual' && category === 'Blue Collar' && vertical === 'Infra Industry' && payroll === 'Sattva Payroll' && (prevStatus === 'Shortlisted' || prevStatus === 'Document Submitted' || prevStatus === 'Offered'  || prevStatus === 'Joined' || prevStatus === 'Attrition' )">
                    <button @click="showGenerateOfferModal(candidateData.id)" class="btn btn-outline-info">Generate Offer Letter </button> 
                  </h6>
                </div> -->
                <div>
                  <h6 class="mb-0 text-info"  v-if="!isAssignMode && positionType === 'Contractual' && vertical === 'Infra Industry' && payroll === 'Sattva Payroll' && (prevStatus === 'Confirmed' || prevStatus === 'ProfileShared' || prevStatus === 'Document Submitted'  || prevStatus === 'Interview' || prevStatus === 'Shortlisted' || prevStatus === 'Offered' || prevStatus === 'Drop' || prevStatus === 'Joined' || prevStatus === 'Attrition')">
                    <button @click="showDocuploadModal(candidateData.id)" class="btn btn-outline-info">Upload/View Documents  </button> 
                  </h6>
                </div>
                <div  v-if="jobId && candidateJobs && candidateData.curr_position && candidateData.qualification">
                  <!-- BGV: {{ isBGVCompleted }}
                  KPMG Offer Process: {{ isKPMGOfferProcessInProgress }}
                  KPMG Offer Process Completed: {{ isKPMGOfferProcessCompleted }} -->
                  
                  <!-- Update Status Button with conditional text -->
                  <!-- Reliance RPO: do not hide this button by offer-process completion; next-status choices from Selected are limited in computeStatusOption. -->
                   <!-- Hi there {{ candidateJobData.candidateStatus }} -->
                  <div v-if="!isAssignMode && !intNotIntNotRelVisible && updateButtonVisible && isRecruiterForCandidate && $can('update','candidate_status') && isDuplicate === false && candidateJobData && candidateJobData.candidateStatus !== undefined">
                    <button :disabled="pausedFor7Seconds"
                      id="update-can" class="btn btn-outline-primary" style="color: green !important" 
                        @click="candidateJobData.candidateStatus === 'Offer Accepted' ? goToPOFUTracker() : showCModal(candidateData.id, candidateData.status)"
                      >
                        <span v-if="candidateJobData.candidateStatus === 'Offer Accepted'">Update POFU</span>
                        <span v-else>Update Status</span>
                    </button>
                  </div>
                  
                  <!-- KPMG RPO Offer Process Button - Visible on Shortlisted, OnHold, Offer Accepted, Offered (edit mode) and read-only on Joined, NotOffered, OfferDrop, Attrition, Duplicate, Early Attrition -->
                  <button 
                    class="btn btn-outline-info ml-2" 
                    @click="openKPMGOfferProcessModal"
                    v-if="!isAssignMode && isKPMGRPOEnabled && isPOCAssigned && 
                          (candidateJobData.candidateStatus === 'Shortlisted' || 
                           candidateJobData.candidateStatus === 'OnHold' || 
                           candidateJobData.candidateStatus === 'Offer Accepted' || 
                           candidateJobData.candidateStatus === 'Offered' ||
                           candidateJobData.candidateStatus === 'Joined' ||
                           candidateJobData.candidateStatus === 'NotOffered' ||
                           candidateJobData.candidateStatus === 'OfferDrop' ||
                           candidateJobData.candidateStatus === 'Attrition' ||
                           candidateJobData.candidateStatus === 'Duplicate' ||
                           candidateJobData.candidateStatus === 'Early Attrition') && 
                          ((updateButtonVisible && $can('update','candidate_status') && $can('read','post_selection_process')) || 
                           isPOCForKPMGOfferProcess || 
                           $can('manage','post_selection_process') ||
                           $can('read','post_selection_process'))"
                    >
                    KPMG RPO Offer Process
                  </button>
                  
                  <button 
                    class="btn btn-outline-info ml-2" 
                    @click="openRelianceRPOOfferProcessModal"
                    v-if="!isAssignMode && isRelianceRPOEnabled &&
                          (candidateJobData.candidateStatus === 'Selected' || 
                           candidateJobData.candidateStatus === 'Draft Offer' ||
                           candidateJobData.candidateStatus === 'Offered' || 
                           candidateJobData.candidateStatus === 'NotOffered' || 
                           candidateJobData.candidateStatus === 'OfferDrop' || 
                           candidateJobData.candidateStatus === 'Offered' ||
                           candidateJobData.candidateStatus === 'Joined' ||
                           candidateJobData.candidateStatus === 'Early Attrition' ||
                           candidateJobData.candidateStatus === 'Attrition') && 
                          ((updateButtonVisible && $can('update','candidate_status')) || $can('manage','reliance_dashboard'))"
                    >
                    Reliance RPO Offer Process
                  </button>
                  

                  <!--<button :disabled="pausedFor7Seconds" 
                    id="update-can" class="btn btn-outline-primary" style="color: green !important" 
                    @click="showCModal(candidateData.id, candidateData.status )"
                    v-if="userRole === 'ACCOUNT-MANAGER' || userRole === 'ADMIN' || userRole === 'MASTER'"
                    >
                    Update Status
                  </button>
                  <button :disabled="pausedFor7Seconds" 
                    id="update-can" class="btn btn-outline-primary" style="color: green !important" 
                    @click="showCModal(candidateData.id, candidateData.status )"
                    v-else-if="userRole === 'TALENT-ADVISOR' && (candidateData.jobs[0].candidate_jobs.candidateStatus !== 'Initiated' && candidateData.jobs.filter(item => item.id === jobId && item.candidate_jobs.job_id === jobId && JSON.parse(item.candidate_jobs.addedBy)[0].emp_id === emp_id)).length > 0"
                    >
                    Update Status
                  </button>-->
                </div>
              <!--<li style="display: inline-flex; margin: 5px; padding: 2px" @click="downloadFile(candidateData.cv_path)">-->
              <!-- Commented CV Download Button  -->
                <!-- <div>
                  <h6 class="mb-0" style="color: #00AC99" v-if="cvPresent">
                    <a href="javascript:void(0)" @click="downloadCV">Download CV <feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></a>
                  </h6>
                  <h6 class="mb-0" style="color: red" v-else>
                    CV NA!
                  </h6>
                </div> -->
                
                <div v-if="!isAssignMode && payroll === 'Sattva Payroll' && prevStatus === 'Joined'">
                  <b-button variant="outline-info" @click="downloadCandidateMetadata">Payroll Data <feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50"/></b-button>
                  <!-- <b-button variant="outline-info" @click="openPayrollModal">{{ payrollButtonText }} <feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50"/></b-button> -->
                </div>
            </div>
          </b-col>
        </b-row>
        
      </b-card>
      <!--<b-card-actions  action-collapse>-->
      <b-row v-if="showCandidateDetails">
        <b-col cols="8" xl="8">
          <b-card>
            <b-row>
                  
                  <b-col md="4" xl="4" xs="6" class="mb-1">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Email </span>
                        <h6 class="mb-0">
                          <span>{{ candidateData.email }} <img :src="require('@/assets/images/icons/copy.png')" width="18px" height="18px" @click="doCopy(candidateData.email)"></span>
                        </h6>
                        
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Contact No </span>
                        <div class="d-flex align-items-center">
                          <h6 class="mb-0 mr-2">
                            {{ candidateData.contact_no }}
                          </h6>
                          <!-- Calling in progress: replace button with spinner pill -->
                          <template v-if="!isAssignMode">
                          <span v-if="isCallInProgress" class="d-inline-flex align-items-center px-75 py-25 rounded border border-success text-success small">
                            <b-spinner small style="width:12px;height:12px;" class="mr-50" />Calling…
                          </span>
                          <!-- Post-call status: show result + re-dial button -->
                          <template v-else-if="callStatus === 'initiated' || callStatus === 'failed'">
                            <span :class="callStatus === 'initiated' ? 'text-success' : 'text-danger'" class="small font-weight-bold mr-50">
                              <feather-icon :icon="callStatus === 'initiated' ? 'CheckCircleIcon' : 'XCircleIcon'" class="mr-25" />
                              {{ callStatus === 'initiated' ? 'Call initiated' : 'Call failed' }}
                            </span>
                            <b-button
                              v-if="candidateData.contact_no && canMakeCall && (isEarlyStatus || isRecruiterForCandidate)"
                              size="sm"
                              variant="outline-secondary"
                              @click="initiateCall(candidateData.contact_no)"
                              class="call-btn"
                            >
                              <feather-icon icon="RefreshCwIcon" class="mr-25" />Retry
                            </b-button>
                          </template>
                          <!-- Default: show Call button -->
                          <b-button
                            v-else-if="candidateData.contact_no && canMakeCall && (isEarlyStatus || isRecruiterForCandidate)"
                            size="sm"
                            variant="outline-success"
                            @click="initiateCall(candidateData.contact_no)"
                            class="call-btn"
                          >
                            <feather-icon icon="PhoneIcon" class="mr-25" />Call
                          </b-button>
                          </template>
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.curr_location">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Location </span>
                        <h6 class="mb-0">
                          {{ candidateData.curr_location }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.pref_location">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Preferred Location </span>
                        <h6 class="mb-0">
                          {{ candidateData.pref_location }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.curr_company">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Company </span>
                        <h6 class="mb-0">
                          {{ candidateData.curr_company }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  
                  <b-col md="4" xl="4" xs="6" class="mb-1">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Skills </span>
                        <h6 class="mb-0">
                          {{ candidateData.skills }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Sourced From </span>
                        <h6 class="mb-0">
                          {{ candidateData.source }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.qualification">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Qualification </span>
                        <h6 class="mb-0">
                          {{ candidateData.qualification }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.exp">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Experience </span>
                        <h6 class="mb-0">{{ candidateData.exp }} <span v-if="candidateData.relevant_exp"> ( Relevant: {{ candidateData.relevant_exp }}) </span> Years</h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.ctc">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> CTC </span>
                        <h6 class="mb-0">₹ {{ candidateData.ctc }} <span v-if="!blueCollar">Lacs</span></h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.exp_ctc">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Expected CTC </span>
                        <h6 class="mb-0">₹ {{ candidateData.exp_ctc }} <span v-if="!blueCollar">Lacs</span></h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.notice_period">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Notice Period </span>
                        <h6 class="mb-0">
                          {{ candidateData.notice_period }} Days
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.gender">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Gender </span>
                        <h6 class="mb-0">
                          {{ candidateData.gender }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.dob">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> DOB </span>
                        <h6 class="mb-0">
                          {{ candidateData.dob === "1900-01-01" ? '-    ' : candidateData.dob }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <!--<b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.status">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Status </span>
                        <h6 class="mb-0">
                          {{ prevStatus }}
                        </h6>
                      </div>
                    </div>
                  </b-col>-->
                  <b-col md="4" xl="4" xs="6" class="mb-1">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Added on </span>
                        <h6 class="mb-0">
                          {{ formatDate }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Added by </span>
                        <h6 class="mb-0" v-if="
                                candidateData.created_by &&
                                isValidJson(candidateData.created_by) &&
                                JSON.parse(candidateData.created_by).length > 0
                              ">
                          <!-- {{ JSON.parse(candidateData.created_by)[0].title }} -->
                          {{ JSON.parse(candidateData.created_by)[0].title }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Updated by </span>
                        <h6 class="mb-0" v-if="candidateData.updated_by">
                          {{ JSON.parse(candidateData.updated_by)[0].title }}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" xl="4" xs="6" class="mb-1" v-if="candidateData.remarks">
                    <div class="d-flex flex-column ml-1">
                      <div class="mb-1">
                        <span class="text-muted"> Remarks </span>
                        <h6 class="mb-0">
                          {{ candidateData.remarks}}
                        </h6>
                      </div>
                    </div>
                  </b-col>
                  
            </b-row>
        <b-row class="mt-2" v-if="isKPMGRPOEnabled">
          <b-col cols="12" class="mb-2">
            <h5>KPMG RPO Details</h5>
          </b-col>
          <b-row v-if="candidateJobData.extra_details" class="mr-1 ml-1">
            <b-col
              v-for="(value, key) in candidateJobData.extra_details"
              :key="key"
              cols="4"
              class="mb-1"
              
            >
              <strong>{{ formatKey(key) }}:</strong> {{ value }}
            </b-col>
          </b-row>
          <!-- Timeline for transition key -->
          <!-- <b-col cols="12" v-if="candidateJobData.extra_details.transition && candidateJobData.extra_details.transition.length">
            <h6 class="mt-2 mb-1">Transition Timeline</h6>
            <ul class="timeline pl-2">
              <li v-for="(t, idx) in candidateJobData.extra_details.transition" :key="idx" class="mb-2">
                <div>
                  <span v-if="t.businessFrom || t.businessTo">
                    <b>Business:</b>
                    <span v-if="t.businessFrom"> {{ t.businessFrom }} </span>
                    <span v-if="t.businessFrom && t.businessTo">→</span>
                    <span v-if="t.businessTo"> {{ t.businessTo }} </span>
                    <br>
                  </span>
                  <span v-if="t.levelFrom || t.levelTo">
                    <b>Level:</b>
                    <span v-if="t.levelFrom"> {{ t.levelFrom }} </span>
                    <span v-if="t.levelFrom && t.levelTo">→</span>
                    <span v-if="t.levelTo"> {{ t.levelTo }} </span>
                    <br>
                  </span>
                  <span v-if="t.transitionOn"><b>Date:</b> {{ t.transitionOn | formatDate }}</span>
                  <span v-if="t.transitionBy"><b> By:</b> {{ t.transitionBy }}</span>
                </div>
              </li>
            </ul>
          </b-col> -->
          

        </b-row>
          </b-card>
        </b-col>
        <b-col cols="4" xl="4"> 
          <b-row v-if=" positionType === 'Contractual' && vertical === 'Infra Industry' && payroll === 'Sattva Payroll' && (prevStatus === 'Confirmed' || prevStatus === 'ProfileShared' || prevStatus === 'Document Submitted'  || prevStatus === 'Interview' || prevStatus === 'Shortlisted' || prevStatus === 'Offered' || prevStatus === 'Drop' || prevStatus === 'Joined' || prevStatus === 'Attrition')">
            <b-col cols="12">
              <app-collapse class="mb-1" style="border-radius: 50px !important">
          
                <app-collapse-item title="Upload/View Documents" class="text-primary">
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="downloadingAllDocuments"
                      @click="downloadAllDocuments"
                    >
                      <b-spinner
                        v-if="downloadingAllDocuments"
                        small
                        class="align-middle mr-50"
                      />
                      <span>{{ downloadingAllDocuments ? 'Preparing zip…' : 'Download All Documents' }}</span>
                      <feather-icon
                        v-if="!downloadingAllDocuments"
                        icon="DownloadIcon"
                        size="16"
                        class="ml-50 align-middle"
                      />
                    </b-button>
                  <b-form @submit.prevent>
                    <b-row>
                      <!-- Aadhaar Front Upload -->
                      <b-col md="6" v-if="showAadhaarFrontUpload">
                          <b-form-group label="Aadhaar Card - Front" class="text-primary">
                            <b-form-file
                              v-model="documents.aadhaarCardFront"
                              placeholder="Choose or drop file"
                              drop-placeholder="Drop file here"
                              browse-text=""
                              id="aadhaar-front-file"
                              name="aadhaar-front-file"
                              accept="image/png,image/jpeg,image/jpg"
                              
                            />
                            <b-card-text class="my-1">
                              Selected file: <strong>{{ documents.aadhaarCardFront ? documents.aadhaarCardFront.name : '' }}</strong>
                              <div v-if="loadingAadhaarFront">
                                <div class="text-center">
                                  <b-spinner variant="primary" label="Text Centered" />
                                </div>
                              </div>
                            </b-card-text>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-else-if="!showAadhaarFrontUpload && !aadhaarFrontUploaded">
                        <h4 class="my-1 mt-2 pt-1 text-primary">
                        <strong><u>Aadhaar Front</u></strong>
                        </h4>
                      </b-col>
                      <b-col col class="mt-2 pt-1" v-if="showAadhaarFrontUpload">
                        <span class="text-primary" @click="uploadAadhaarFront"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        
                      </b-col>
                      
                      <b-col col class="mt-2 pt-1" v-if="aadhaarFrontUploaded">
                        <span class="text-primary" @click="previewFile('aadhaar_front')" v-b-tooltip.hover title="Preview Front"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
                        <span class="text-primary" @click="downloadFile('aadhaar_front')" v-b-tooltip.hover title="Download Front"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
                      <br>
                      <span class="text-muted">Front</span>
                      </b-col>
                    
                      <b-col col class="mt-2 pt-1" v-if="aadhaarFrontUploaded">
                        <span class="text-warning" @click="reUploadAadhaarFront" v-if="!showAadhaarFrontUpload" v-b-tooltip.hover title="Re-Upload Front"> <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        <span class="text-warning" @click="reUploadAadhaarFront" v-if="showAadhaarFrontUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                      
                      <!-- Separator between Aadhaar Front and Back -->
                      <b-col cols="12">
                        <hr style="border: 1px solid lightgreen;">
                      </b-col>
                      
                      <!-- Aadhaar Back Upload -->
                      <b-col md="6" v-if="showAadhaarBackUpload">
                          <b-form-group label="Aadhaar Card - Back" class="text-primary">
                            <b-form-file
                              v-model="documents.aadhaarCardBack"
                              placeholder="Choose or drop file"
                              drop-placeholder="Drop file here"
                              browse-text=""
                              id="aadhaar-back-file"
                              name="aadhaar-back-file"
                              accept="image/png,image/jpeg,image/jpg"
                              
                            />
                            <b-card-text class="my-1">
                              Selected file: <strong>{{ documents.aadhaarCardBack ? documents.aadhaarCardBack.name : '' }}</strong>
                              <div v-if="loadingAadhaarBack">
                                <div class="text-center">
                                  <b-spinner variant="primary" label="Text Centered" />
                                </div>
                              </div>
                            </b-card-text>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-else-if="!showAadhaarBackUpload && !aadhaarBackUploaded">
                        <h4 class="my-1 mt-2 pt-1 text-primary">
                        <strong><u>Aadhaar Back</u></strong>
                        </h4>
                      </b-col>
                      <b-col col class="mt-2 pt-1" v-if="showAadhaarBackUpload">
                        <span class="text-primary" @click="uploadAadhaarBack"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        
                      </b-col>
                      
                      <b-col col class="mt-2 pt-1" v-if="aadhaarBackUploaded">
                        <span class="text-primary" @click="previewFile('aadhaar_back')" v-b-tooltip.hover title="Preview Back"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
                        <span class="text-primary" @click="downloadFile('aadhaar_back')" v-b-tooltip.hover title="Download Back"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
                      <br>
                      <span class="text-muted">Back</span>
                      </b-col>
                    
                      <b-col col class="mt-2 pt-1" v-if="aadhaarBackUploaded">
                        <span class="text-warning" @click="reUploadAadhaarBack" v-if="!showAadhaarBackUpload" v-b-tooltip.hover title="Re-Upload Back"> <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        <span class="text-warning" @click="reUploadAadhaarBack" v-if="showAadhaarBackUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                      
                      <!-- Aadhaar Number Display -->
                      <b-col cols="12" v-if="(aadhaarFrontUploaded || aadhaarBackUploaded) && candidateMetadata && candidateMetadata.hasOwnProperty('aadhaarNumber')">
                        <b-card-text class="mt-2">
                          <strong>Aadhaar Number:</strong> {{ candidateMetadata.aadhaarNumber }}
                        </b-card-text>
                      </b-col>
                      
                    </b-row>
                    <hr style="border: 1px solid lightgreen;">
                  </b-form> 
                  <b-form @submit.prevent>
                    <b-row>
                      <b-col md="6" v-if="showPanUpload">
                          <b-form-group label="Pan Card" class="text-primary">
                            <b-form-file
                              v-model="documents.panCard"
                              placeholder="Choose or drop file"
                              drop-placeholder="Drop file here"
                              browse-text=""
                              id="pan-file"
                              name="pan-file"
                              accept="application/pdf,image/png,image/jpeg,image/jpg"
                            />
                            <b-card-text class="my-1">
                              Selected file: <strong>{{ documents.panCard ? documents.panCard.name : '' }}</strong>
                              <div v-if="loadingPan">
                                <div class="text-center">
                                  <b-spinner variant="primary" label="Text Centered" />
                                </div>
                              </div>
                            </b-card-text>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-else>
                        <h4 class="my-1 mt-2 pt-1 text-primary">
                        <strong><u>Pan Card</u></strong>
                        </h4>
                      </b-col>
                      <b-col col class="mt-2 pt-1" v-if="showPanUpload">
                        
                        <span class="text-primary" @click="uploadPan"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                      
                      <b-col col class="mt-2 pt-1" v-if="panUploaded">
                        <span class="text-primary" @click="previewFile('pan')" v-b-tooltip.hover title="Preview"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
                        <span class="text-primary" @click="downloadFile('pan')" v-b-tooltip.hover title="Download"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
                        <br>

                      <span v-if="candidateMetadata && candidateMetadata.hasOwnProperty('aadhaarNumber')">{{ candidateMetadata.panNumber }}</span>
                        
                      </b-col>
                    
                      <b-col col class="mt-2 pt-1" v-if="panUploaded">
                        <span class="text-warning" @click="reUploadPan" v-if="!showPanUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        <span class="text-warning" @click="reUploadPan" v-if="showPanUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                    </b-row>
                    <hr style="border: 1px solid lightgreen;">
                  </b-form>
                  <b-form @submit.prevent>
                    <b-row>
                      <b-col md="6" v-if="showPhotoUpload">
                          <b-form-group label="Photo" class="text-primary">
                            <b-form-file
                              v-model="documents.passportPhoto"
                              placeholder="Choose or drop file"
                              drop-placeholder="Drop file here"
                              browse-text=""
                              id="photo-file"
                              name="photo-file"
                              accept="application/pdf,image/png,image/jpeg,image/jpg"
                            />
                            <b-card-text class="my-1">
                              Selected file: <strong>{{ documents.passportPhoto ? documents.passportPhoto.name : '' }}</strong>
                              <div v-if="loadingPhoto">
                                <div class="text-center">
                                  <b-spinner variant="primary" label="Text Centered" />
                                </div>
                              </div>
                            </b-card-text>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-else>
                        <h4 class="my-1 mt-2 pt-1 text-primary">
                        <strong><u>Passport Size Photo</u></strong>
                        </h4>
                      </b-col>
                      <b-col col class="mt-2 pt-1" v-if="showPhotoUpload">
                        
                        <span class="text-primary" @click="uploadPhoto"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                      
                      <b-col col class="mt-2 pt-1" v-if="photoUploaded">
                        <span class="text-primary" @click="previewFile('photo')" v-b-tooltip.hover title="Preview"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
                        <span class="text-primary" @click="downloadFile('photo')" v-b-tooltip.hover title="Download"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
                        
                      </b-col>
                    
                      <b-col col class="mt-2 pt-1" v-if="photoUploaded">
                        <span class="text-warning" @click="reUploadPhoto" v-if="!showPhotoUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        <span class="text-warning" @click="reUploadPhoto" v-if="showPhotoUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                    </b-row>
                    <hr style="border: 1px solid lightgreen;">
                  </b-form>
                  
                  <b-form @submit.prevent v-if="prevStatus === 'Interview' || prevStatus === 'Shortlisted' || prevStatus === 'Offered' || prevStatus === 'Joined' || prevStatus === 'LOI Issued' || prevStatus === 'Attrition' || prevStatus === 'Early Attrition' || prevStatus === 'Drop'">
                    <b-row>
                      <b-col md="6" v-if="showBankUpload">
                          <b-form-group label="Bank Details Proof Document" class="text-primary">
                            <b-form-file
                              v-model="documents.bankProof"
                              placeholder="Choose or drop file"
                              drop-placeholder="Drop file here"
                              browse-text=""
                              id="bank-file"
                              name="bank-file"
                              accept="application/pdf,image/png,image/jpeg,image/jpg"
                            />
                            <b-card-text class="my-1">
                              Selected file: <strong>{{ documents.bankProof ? documents.bankProof.name : '' }}</strong>
                              <div v-if="loadingBankDoc">
                                <div class="text-center">
                                  <b-spinner variant="primary" label="Text Centered" />
                                </div>
                              </div>
                            </b-card-text>
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-else>
                        <h4 class="my-1 mt-2 pt-1 text-primary">
                        <strong><u>Bank Details Proof Document</u></strong>
                        </h4>
                      </b-col>
                      <b-col col class="mt-2 pt-1" v-if="showBankUpload">
                        
                        <span class="text-primary" @click="uploadBank"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                      <b-col col class="mt-2 pt-1" v-if="bankUploaded">
                        <span class="text-primary" @click="previewFile('bankProof')" v-b-tooltip.hover title="Preview"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
                        <span class="text-primary" @click="downloadFile('bankProof')" v-b-tooltip.hover title="Download"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
                        
                      </b-col>
                    
                      <b-col col class="mt-2 pt-1" v-if="bankUploaded">
                        <span class="text-warning" @click="reUploadBank" v-if="!showBankUpload" v-b-tooltip.hover title="Re-Upload"> <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        <span class="text-warning" @click="reUploadBank" v-if="showBankUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                    </b-row>
                    <hr style="border: 1px solid lightgreen;">
                  </b-form>
                  <b-form @submit.prevent>
                    
                    <b-row>
                      
                      <b-col md="6" v-if="showCertificateUpload && skillCertificateAvailable">
                          <b-form-group label="Skill Certificate" class="text-primary">
                            
                            <b-form-file
                              v-model="documents.skillCertificate"
                              placeholder="Choose or drop file"
                              drop-placeholder="Drop file here"
                              browse-text=""
                              id="certificate-file"
                              name="certificate-file"
                              accept="application/pdf,image/png,image/jpeg,image/jpg"
                            />
                            <span></span>
                            <b-card-text class="my-1">
                              Selected file: <strong>{{ documents.skillCertificate ? documents.skillCertificate.name : '' }}</strong>
                              <div v-if="loadingCertificate">
                                <div class="text-center">
                                  <b-spinner variant="primary" label="Text Centered" />
                                </div>
                              </div>
                            </b-card-text>
                          </b-form-group>
                      </b-col>
                      <b-col md="4" v-else>
                        <h4 class="my-1 mt-2 pt-1 text-primary">
                        <strong><u>Skill Certificate</u></strong>
                        </h4>
                      </b-col>
                      <b-col col class="mt-2 pt-1" v-if="showCertificateUpload && skillCertificateAvailable">
                        
                        <span class="text-primary" @click="uploadCertificate"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                      
                      <b-col col class="mt-2 pt-1" v-if="certificateUploaded">
                        <span class="text-primary" @click="previewFile('skillCertificate')" v-b-tooltip.hover title="Preview"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
                        <span class="text-primary" @click="downloadFile('skillCertificate')" v-b-tooltip.hover title="Download"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
                        
                      </b-col>
                    
                      <b-col col class="mt-2 pt-1" v-if="certificateUploaded">
                        <span class="text-warning" @click="reUploadCertificate" v-if="!showCertificateUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                        <span class="text-warning" @click="reUploadCertificate" v-if="showCertificateUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
                      </b-col>
                    
                    
                      <b-col col class="mt-2 pt-1" v-if="!certificateUploaded">
                        <div style="float:left" >
                          <b-card-text class="mb-1">
                            Is Skill Certificate Available?
                          </b-card-text>
                            <b-form-checkbox v-model="skillCertificateAvailable" name="check-button" switch></b-form-checkbox>
                        </div>
                      </b-col>
                    
                    </b-row>
                    <hr style="border: 1px solid lightgreen;">
                  </b-form> 
                
                </app-collapse-item>

              </app-collapse>
            </b-col>  
          </b-row>
        
          <b-row>
            <b-col cols="12">
              <b-card title="Candidate Timeline">
                <p v-if="!displayedCandidateTimeline.length" class="text-muted mb-0">No candidate timeline activity yet.</p>
                <div v-else class="candidate-timeline-panel">
                  <div
                    ref="candidateTimelineScroll"
                    class="candidate-timeline-scroll"
                    :class="{ 'is-expanded': timelineExpanded }"
                  >
                    <app-timeline class="candidate-app-timeline">
                  <app-timeline-item
                    v-for="item in displayedCandidateTimeline"
                    :key="item.key"
                    :variant="item.variant || 'primary'"
                  >
                    <div class="timeline-card">
                      <template v-if="item.showJobHeader">
                        <div class="timeline-card-head">
                          <h6 class="timeline-card-title">{{ item.title }}</h6>
                          <span v-if="item.time" class="timeline-card-time">{{ item.time }}</span>
                        </div>
                        <div class="timeline-card-grid">
                          <div v-if="item.sourcerName || item.recruiterName" class="timeline-card-col">
                            <span class="timeline-card-label">S/R</span>
                            <div class="timeline-card-avatars">
                              <b-avatar
                                v-if="item.sourcerName"
                                v-b-tooltip.hover
                                :title="timelinePersonTooltip('Sourcer', item.sourcerName)"
                                class="mr-50"
                                size="24"
                                :text="timelineInitials(item.sourcerName)"
                                variant="light-info"
                              />
                              <b-avatar
                                v-if="item.recruiterName"
                                v-b-tooltip.hover
                                :title="timelinePersonTooltip('Recruiter', item.recruiterName)"
                                class="mr-50"
                                size="24"
                                :text="timelineInitials(item.recruiterName)"
                                variant="light-success"
                              />
                            </div>
                          </div>
                          <div class="timeline-card-col">
                            <span class="timeline-card-label">Current status</span>
                            <span class="timeline-card-value">{{ item.status }}</span>
                          </div>
                          <div v-if="item.source" class="timeline-card-col">
                            <span class="timeline-card-label">Source</span>
                            <span class="timeline-card-value">{{ item.source }}</span>
                          </div>
                        </div>
                        <div
                          v-if="item.isCurrent && item.keyDates && item.keyDates.length"
                          class="timeline-card-grid timeline-card-dates"
                        >
                          <div
                            v-for="date in item.keyDates"
                            :key="date.label"
                            class="timeline-card-col"
                          >
                            <span class="timeline-card-label">{{ date.label }}</span>
                            <span class="timeline-card-value">{{ date.value }}</span>
                          </div>
                        </div>
                        <div
                          v-if="item.comment || item.reason"
                          class="timeline-followup-meta timeline-heading-update mb-0"
                        >
                          <div class="timeline-heading-update-main">
                            <p class="timeline-compact-extra mb-0" v-if="item.reason">{{ item.reason }}</p>
                            <p class="timeline-compact-comment mb-0" v-if="item.comment">Comment: {{ item.comment }}</p>
                          </div>
                          <span v-if="item.time" class="timeline-card-time timeline-event-time">{{ item.time }}</span>
                        </div>
                      </template>
                      <p v-else class="timeline-followup-meta mb-0">
                        <span class="timeline-status">{{ item.status }}</span>
                        <span v-if="item.time" class="timeline-card-time timeline-event-time">{{ item.time }}</span>
                      </p>
                      <p class="timeline-compact-extra mb-0" v-if="!item.showJobHeader && item.reason">{{ item.reason }}</p>
                      <p class="timeline-compact-comment mb-0" v-if="!item.showJobHeader && item.comment">Comment: {{ item.comment }}</p>
                      <p
                        v-if="item.isCurrent && timelineJobExtras(item).length"
                        class="timeline-compact-extra mb-0"
                      >
                        <span v-for="(extra, extraIndex) in timelineJobExtras(item)" :key="extra.label">
                          <template v-if="extraIndex"> · </template>{{ extra.label }}: {{ extra.value }}
                        </span>
                      </p>
                      <button
                        v-if="item.updateCount > 1"
                        type="button"
                        class="timeline-run-toggle"
                        @click="toggleTimelineRun(item.runKey)"
                      >
                        <feather-icon
                          :icon="expandedTimelineRuns[item.runKey] ? 'ChevronDownIcon' : 'ChevronRightIcon'"
                          size="14"
                        />
                        Updated {{ item.updateCount }} times
                      </button>
                      <div
                        v-if="item.updateCount > 1 && expandedTimelineRuns[item.runKey]"
                        class="timeline-run-updates"
                      >
                        <div
                          v-for="update in visibleTimelineUpdates(item)"
                          :key="update.key"
                          class="timeline-run-update"
                        >
                          <p class="timeline-compact-meta mb-0">
                            <span class="timeline-compact-meta-main">
                              <span class="timeline-prior-label">{{ timelinePriorStatusLabel(item, update) }}</span>
                              <span v-if="update.reason">{{ update.reason }}</span>
                              <span v-if="timelineUpdateHasPeople(update)" class="timeline-card-avatars">
                                <b-avatar
                                  v-if="update.sourcerName"
                                  v-b-tooltip.hover
                                  :title="timelinePersonTooltip('Sourcer', update.sourcerName)"
                                  class="mr-50"
                                  size="24"
                                  :text="timelineInitials(update.sourcerName)"
                                  variant="light-info"
                                />
                                <b-avatar
                                  v-if="update.recruiterName"
                                  v-b-tooltip.hover
                                  :title="timelinePersonTooltip('Recruiter', update.recruiterName)"
                                  class="mr-50"
                                  size="24"
                                  :text="timelineInitials(update.recruiterName)"
                                  variant="light-success"
                                />
                                <span
                                  v-if="timelineShowUpdateActor(update)"
                                  class="timeline-actor"
                                  v-b-tooltip.hover
                                  :title="update.actorName"
                                >
                                  <b-avatar
                                    class="timeline-initials timeline-initials-actor"
                                    size="24"
                                    :text="timelineInitials(update.actorName)"
                                    variant="light-secondary"
                                  />
                                </span>
                              </span>
                            </span>
                            <span v-if="update.time" class="timeline-card-time timeline-event-time">{{ update.time }}</span>
                          </p>
                          <p class="timeline-compact-comment mb-0" v-if="update.comment">Comment: {{ update.comment }}</p>
                        </div>
                        <button
                          v-if="item.updates.length > timelineRunPreviewLimit && !showAllTimelineUpdates[item.runKey]"
                          type="button"
                          class="timeline-run-show-all"
                          @click="toggleShowAllTimelineUpdates(item.runKey)"
                        >
                          Show all updates
                        </button>
                      </div>
                      <div v-if="item.isCurrent && item.status === 'Offer Accepted' && updateButtonVisible && $can('update','candidate_status') && $can('read','post_selection_process') && isDuplicate === false" class="mt-1">
                        <small class="text-warning">
                          To update status to "Offered", use the "Update POFU" button above or
                          <router-link
                            :to="`/apps/pofu-tracker?filter=${candidateData.candidate_id}`"
                            class="text-warning font-weight-bold"
                          >
                            go to POFU Tracker
                          </router-link>
                        </small>
                      </div>
                    </div>
                  </app-timeline-item>
                    </app-timeline>
                  </div>
                  <button
                    v-if="timelineOverflows || timelineExpanded"
                    type="button"
                    class="candidate-timeline-view-all"
                    @click="toggleCandidateTimelineExpand"
                  >
                    {{ timelineExpanded ? 'Show less' : 'View all' }}
                  </button>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-card class="w-100">
              
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h3 class="mb-0">Recruiter Notes</h3>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="toggleNoteInput"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" size="16"/>
                  Add Note
                </b-button>
              </div>
              
              
              <div v-if="showNoteInput">
                <b-card class="mb-2 border">
                  <b-form @submit.prevent="addNote">
                    <b-form-group>
                      <b-form-textarea
                        v-model="newNote"
                        placeholder="Enter your note here..."
                        rows="3"
                        :state="newNote.length > 0"
                        class="border-danger"
                      ></b-form-textarea>
                    </b-form-group>
                    <div class="d-flex justify-content-end">
                      <b-button
                        variant="primary"
                        type="submit"
                        :disabled="!newNote.trim()"
                        class="rounded-pill"
                        style="background-color: #7367F0"
                      >
                        Add Note
                      </b-button>
                    </div>
                  </b-form>
                </b-card>
              </div>

              
              <div class="timeline-custom">
                <div v-for="(note, index) in displayedNotes" :key="index" class="timeline-item">
                  
                  <div class="timeline-dot" :class="index % 2 ? 'bg-warning' : 'bg-info'"></div>
                  
                  
                  <div class="timeline-content">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="font-weight-bold">{{ note.addedBy }}</span>
                      <small class="text-muted">{{ formatNoteDate(note.addedOn) }}</small>
                    </div>
                    <p class="mb-0 mt-1">{{ note.content }}</p>
                  </div>
                </div>
              </div>

              
              <div class="text-center mt-2" v-if="notes.length > 3">
                <b-button
                  variant="flat-primary"
                  class="text-primary font-weight-bold"
                  @click="showAllNotes = !showAllNotes"
                >
                  Show {{ notes.length - 3 }} More Notes
                </b-button>
              </div>
            </b-card>
          </b-row> -->
        </b-col>

            
      </b-row>
        
      <!--</b-card-actions>-->
      <b-modal
        id="modal-cupdate-status"
        ref="modal-cupdate-status"
        title="Update Candidate Status"
        ok-title="submit"
        size="lg"
        no-close-on-backdrop
        cancel-variant="outline-secondary"
        @ok="updateCandidateStatus"
      >
        <b-form @submit.prevent>
          
          <!-- <b-form-group label="Choose the Status" label-for="vue-select" v-if="jobBySourcer === 'sourcer'"> -->
          <b-form-group label="Choose the Status" label-for="vue-select">
            <li 
              style="display: inline-flex; margin: 5px; padding: 2px"
              v-for="status in cStatusOption"
              :key="status.text"
            >
              <b-badge
                style="color: black !important"
                variant="light"
                :id="status.text"
                @click="selectCStatus(status.text)"
                >{{ status.value }}</b-badge
              >
            </li>
          </b-form-group>
          
          <!-- Interview Rounds Configuration for Reliance RPO - When moving TO Interview status -->
          <b-form-group 
            v-if="statusCSelected === 'Interview' && client === 'Reliance RPO'"
            label="Number of Interview Rounds *"
            label-for="interviewRounds"
          >
            <v-select
              v-model="interviewRounds" 
              :options="interviewRoundOptions"
              label="text"
              :reduce="option => option.value"
              id="interviewRounds"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
            <small class="text-muted">Configure the total number of interview rounds for this candidate</small>
          </b-form-group>

          <!-- Update Interview Round Results - When candidate is already in Interview status -->
          <div v-if="(prevStatus === 'Interview' || (candidateJobData && candidateJobData.candidateStatus === 'Interview')) && client === 'Reliance RPO' && hasInterviewProcess">
            <h6 class="mb-2 text-primary">Interview Process Details</h6>
            
            <!-- Compact summary + editable rounds count -->
            <div class="reliance-rpo-interview-summary mb-2">
              <div class="d-flex flex-wrap align-items-center mb-1">
                <span class="reliance-rpo-summary-line mr-2 mb-1">
                  <span class="text-muted small">Total</span>
                  <b-badge variant="info" class="ml-1">{{ getTotalInterviewRounds() }}</b-badge>
                </span>
                <span class="reliance-rpo-summary-line mr-2 mb-1">
                  <span class="text-muted small">Done</span>
                  <b-badge variant="success" class="ml-1">{{ getCompletedRoundsCount() }}</b-badge>
                </span>
                <span class="reliance-rpo-summary-line mr-2 mb-1">
                  <span class="text-muted small">Pending</span>
                  <b-badge variant="warning" class="ml-1">{{ getPendingRoundsCount() }}</b-badge>
                </span>
                <span class="ml-auto mb-1 d-flex flex-wrap align-items-center">
                  <label class="small text-muted mb-0 mr-1">Number of rounds:</label>
                  <v-select
                    v-model="interviewRounds"
                    :options="interviewRoundOptions"
                    label="text"
                    :reduce="option => option.value"
                    class="reliance-rpo-rounds-select d-inline-block mr-1"
                    style="min-width: 100px;"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  />
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="reliance-rpo-add-round-btn mr-1"
                    :disabled="interviewRounds >= 5"
                    @click="interviewRounds = Math.min(5, interviewRounds + 1)"
                  >
                    Add round
                  </b-button>
                  <small class="text-muted">(Submit to save)</small>
                </span>
              </div>
              <div class="d-flex flex-wrap align-items-center">
                <span class="text-muted small mr-1">Round status:</span>
                <span
                  v-for="round in getInterviewRoundsToUpdate()"
                  :key="'summary-round-' + round"
                  class="mr-1 mb-1"
                >
                  <b-badge
                    :variant="getRoundStatusBadgeVariant(round)"
                    class="reliance-rpo-round-badge"
                  >
                    R{{ round }}: <span v-if="getInterviewRoundStatus(round)">{{ getInterviewRoundStatus(round) === 'final_select' ? 'Final' : getInterviewRoundStatus(round) === 'select' ? 'Select' : 'Reject' }}</span><span v-else>Pending</span>
                  </b-badge>
                </span>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="ml-2 mb-1 reliance-rpo-clear-all-btn"
                  @click="clearAllInterviewRoundStatuses"
                >
                  Clear all
                </b-button>
              </div>
            </div>
            
            <h6 class="mb-1 mt-2 text-primary">Update Interview Round Results</h6>
            <div class="interview-rounds-container reliance-rpo-rounds-compact">
              <div
                v-for="round in getInterviewRoundsToUpdate()"
                :key="'round-' + round"
                class="reliance-rpo-round-row"
              >
                <div class="d-flex flex-wrap align-items-center mb-1">
                  <span class="reliance-rpo-round-num font-weight-bold mr-2">Round {{ round }}</span>
                  <span class="mr-2">
                    <flat-pickr
                      :ref="'round-date-' + round"
                      class="form-control form-control-sm reliance-rpo-round-date-inline"
                      :value="getInterviewRoundDate(round)"
                      @input="setInterviewRoundDate(round, $event)"
                      placeholder="Date"
                      :config="flatpickrConfig"
                    />
                  </span>
                  <b-badge
                    :variant="getRoundStatusBadgeVariant(round)"
                    class="reliance-rpo-round-status-badge mr-2"
                  >
                    {{ getInterviewRoundStatus(round) ? (getInterviewRoundStatus(round) === 'final_select' ? 'Final' : getInterviewRoundStatus(round) === 'select' ? 'Select' : 'Reject') : 'Pending' }}
                  </b-badge>
                  <b-form-radio-group
                    :value="getInterviewRoundStatus(round)"
                    @input="setInterviewRoundStatus(round, $event)"
                    :name="'round-' + round + '-result'"
                    class="reliance-rpo-radios-inline"
                  >
                    <b-form-radio value="select"><span class="text-success small">Select</span></b-form-radio>
                    <b-form-radio value="final_select"><span class="text-primary small font-weight-bold">Final Select</span></b-form-radio>
                    <b-form-radio value="reject"><span class="text-danger small">Reject</span></b-form-radio>
                  </b-form-radio-group>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="ml-auto reliance-rpo-clear-round-btn"
                    @click="clearInterviewRoundStatus(round)"
                  >
                    Clear
                  </b-button>
                </div>
                <div v-if="getInterviewRoundStatus(round) === 'reject'" class="mt-1 mb-1">
                  <label class="small mb-0 text-danger">Comment for this round *</label>
                  <b-form-input
                    size="sm"
                    class="reliance-rpo-round-comment"
                    :value="getInterviewRoundComment(round)"
                    @input="setInterviewRoundComment(round, $event)"
                    placeholder="Reason for rejection"
                    max-rows="2"
                  />
                </div>
              </div>
            </div>
            <b-alert v-if="isLastInterviewRoundSelect" variant="success" show class="mt-2">
              <small><strong>All rounds completed with Select!</strong> You can now move this candidate to "Selected" status.</small>
            </b-alert>
            <b-alert v-if="hasFinalSelect" variant="primary" show class="mt-2">
              <small><strong>Final Select chosen!</strong> Status will automatically change to "Selected" and selection date will be set.</small>
            </b-alert>
          </div>

          <!-- Selection Date for Selected status (Reliance RPO): when last round has select/final_select, or any round has final_select, or no interview process -->
          <b-form-group v-if="(statusCSelected === 'Selected' || hasFinalSelect) && client === 'Reliance RPO' && !this.isRelianceRPOEnabled && (!hasInterviewProcess || isCurrentLastRoundSelectOrFinalSelect || hasFinalSelect)"
            label="Selection Date *"
            label-for="selectionDateReliance"
          >
            <flat-pickr
              class="form-control"
              id="selectionDateReliance" 
              v-model="selectionDate" 
              placeholder="YYYY-MM-DD"
              :config="flatpickrConfig"
            />
          </b-form-group>

          <b-form-group v-if="statusCSelected === 'Shortlisted'"
            label="Selection Date *"
            label-for="selectedDate"
          >
            <flat-pickr
              class="form-control"
              id="selDate" 
              v-model="selectionDate" 
              placeholder="YYYY-MM-DD"
              :config="flatpickrConfig"
              
            />
          </b-form-group>

          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Role Hired for *"
            label-for="role"
          >     
          <b-form-input
              class="form-control"
              id="role" 
              v-model="candidateMetadata.title" 
              placeholder="Enter the Role Candidate is Hired for"
              
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Aadhaar Number *"
            label-for="aadhaarNumber"
          >     
            <b-form-input
              class="form-control aadhaar-masked"
              id="aadhaarNumber" 
              v-model="candidateMetadata.aadhaarNumber" 
              type="text"
              autocomplete="off"
              placeholder="Enter Aadhaar Number"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Name as per Aadhaar Card *"
            label-for="aadhaarName"
          >     
            <b-form-input
              class="form-control"
              v-model="candidateMetadata.aadhaarName"
              placeholder="Enter Name as per Aadhaar Card"
              
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="PAN Number *"
            label-for="role"
          >     
          <b-form-input
              class="form-control pan-masked"
              id="role" 
              v-model="candidateMetadata.panNumber" 
              type="text"
              autocomplete="off"
              placeholder="Enter the PAN Number"
              :class="{ 'is-invalid': panNumberFormatError }"
              @input="validatePanNumber"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="panNumberFormatError" class="invalid-feedback">
              Please enter a valid PAN number (e.g., ABCDE1234F)
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Re-enter PAN Number *"
            label-for="reenterPan"
          >     
          <b-form-input
              class="form-control"
              id="reenterPan" 
              v-model="reenterPanNumber" 
              type="text"
              placeholder="Re-enter the PAN Number"
              :class="{ 'is-invalid': panNumberMismatchError || reenterPanNumberFormatError }"
              @input="validateReenterPanNumber"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="reenterPanNumberFormatError" class="invalid-feedback">
              Please enter a valid PAN number (e.g., ABCDE1234F)
            </div>
            <div v-if="panNumberMismatchError" class="invalid-feedback">
              PAN numbers do not match
            </div>
            <div v-if="panNumbersMatch && !panNumberFormatError && !reenterPanNumberFormatError" class="valid-feedback">
              PAN numbers match ✓
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="UAN Number *"
            label-for="uanNumber"
          >     
            <b-form-input
              class="form-control uan-masked"
              id="uanNumber" 
              v-model="candidateMetadata.uanNumber" 
              type="text"
              autocomplete="off"
              placeholder="Enter UAN Number"
              :class="{ 'is-invalid': uanNumberFormatError }"
              @input="validateUanNumber"
              @keypress="allowOnlyNumbers"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="uanNumberFormatError" class="invalid-feedback">
              Please enter a valid UAN number (12 digits)
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Re-enter UAN Number *"
            label-for="reenterUan"
          >     
            <b-form-input
              class="form-control"
              id="reenterUan" 
              v-model="reenterUanNumber" 
              type="text"
              placeholder="Re-enter the UAN Number"
              :class="{ 'is-invalid': uanNumberMismatchError || reenterUanNumberFormatError }"
              @input="validateReenterUanNumber"
              @keypress="allowOnlyNumbers"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="reenterUanNumberFormatError" class="invalid-feedback">
              Please enter a valid UAN number (12 digits)
            </div>
            <div v-if="uanNumberMismatchError" class="invalid-feedback">
              UAN numbers do not match
            </div>
            <div v-if="uanNumbersMatch && !uanNumberFormatError && !reenterUanNumberFormatError" class="valid-feedback">
              UAN numbers match ✓
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Offered'"
            label="Offered Date *"
            label-for="offeredDate"
          >
            <flat-pickr
              class="form-control"
              id="offerDate" 
              v-model="offeredDate" 
              placeholder="YYYY-MM-DD"
              :config="flatpickrConfig"
              
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered'"
            label="Joining Date *"
            label-for="joiningDate"
          >     
            <flat-pickr
              class="form-control"
              id="joinDate" 
              v-model="joiningDate" 
              placeholder="YYYY-MM-DD"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && client !== 'Sattva Human Pvt Ltd' && !blueCollar"
            label="Variable CTC"
            label-for="variableCTC"
          >     
            <b-form-input
              class="form-control"
              id="variableCTC" 
              v-model="variableCTC" 
              placeholder="Enter Variable CTC in Rupees(complete amount like 10000.00)"
              type="number"
              step=".01"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && client !== 'Sattva Human Pvt Ltd'"
            label="Fixed CTC *"
            label-for="offeredCTC"
          >     
            <b-form-input
              class="form-control"
              id="offeredCTC" 
              v-model="offeredCTC" 
              placeholder="Enter Fixed Annual CTC in Rupees(complete amount like 10000.00)"
              type="number"
              step=".01"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Project Name *"
            label-for="projectName"
          >     
            <v-select
              v-model="candidateMetadata.projectName"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="projectOptions"
              placeholder="Select Project Name"
              ref="drop-reason"
              :reduce="(option) => option.title"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Project State *"
            label-for="state"
          >     
            <v-select
              v-model="candidateMetadata.projectState"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="projectStateOptions"
              placeholder="Select Project State"
              ref="drop-reason"
              :reduce="(option) => option.title"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            label="Project Location *"
            label-for="projectLocation"
          >     
            <v-select
              v-model="candidateMetadata.projectLocation"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="projectLocationOptions"
              placeholder="Select Project Location"
              ref="drop-reason"
              :reduce="(option) => option.title"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            :label="client !== 'Intellismart' ? 'Bank Account Number *' : 'Bank Account Number'"
            label-for="accountNumber"
          >     
            <b-form-input
              class="form-control account-number-masked"
              id="accountNumber" 
              v-model="candidateMetadata.accountNumber" 
              type="text"
              autocomplete="off"
              placeholder="Enter Bank Account Number"
              :class="{ 'is-invalid': accountNumberFormatError }"
              @input="validateAccountNumber"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="accountNumberFormatError" class="invalid-feedback">
              Please enter a valid bank account number (numbers only)
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            :label="client !== 'Intellismart' ? 'Re-enter Bank Account Number *' : 'Re-enter Bank Account Number'"
            label-for="reenterAccountNumber"
          >     
            <b-form-input
              class="form-control"
              id="reenterAccountNumber" 
              v-model="reenterAccountNumber" 
              type="text"
              placeholder="Re-enter Bank Account Number"
              :class="{ 'is-invalid': accountNumberMismatchError || reenterAccountNumberFormatError }"
              @input="validateReenterAccountNumber"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="reenterAccountNumberFormatError" class="invalid-feedback">
              Please enter a valid bank account number (numbers only)
            </div>
            <div v-if="accountNumberMismatchError" class="invalid-feedback">
              Account numbers do not match
            </div>
            <div v-if="accountNumbersMatch && !accountNumberFormatError && !reenterAccountNumberFormatError" class="valid-feedback">
              Account numbers match ✓
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            :label="client !== 'Intellismart' ? 'Bank IFSC Code *' : 'Bank IFSC Code'"
            label-for="ifscCode"
          >     
            <b-form-input
              class="form-control ifsc-masked"
              id="ifscCode" 
              v-model="candidateMetadata.ifscCode" 
              type="text"
              autocomplete="off"
              placeholder="Enter Bank IFSC Code"
              :class="{ 'is-invalid': ifscCodeFormatError }"
              @input="validateIfscCode"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="ifscCodeFormatError" class="invalid-feedback">
              Please enter a valid IFSC code (e.g., SBIN0001234)
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Offered' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && vertical === 'Infra Industry'"
            :label="client !== 'Intellismart' ? 'Re-enter Bank IFSC Code *' : 'Re-enter Bank IFSC Code'"
            label-for="reenterIfscCode"
          >     
            <b-form-input
              class="form-control"
              id="reenterIfscCode" 
              v-model="reenterIfscCode" 
              type="text"
              placeholder="Re-enter Bank IFSC Code"
              :class="{ 'is-invalid': ifscCodeMismatchError || reenterIfscCodeFormatError }"
              @input="validateReenterIfscCode"
              @paste="preventPaste"
              @copy="preventCopy"
              @cut="preventCut"
              @contextmenu="preventContextMenu"
            />
            <div v-if="reenterIfscCodeFormatError" class="invalid-feedback">
              Please enter a valid IFSC code (e.g., SBIN0001234)
            </div>
            <div v-if="ifscCodeMismatchError" class="invalid-feedback">
              IFSC codes do not match
            </div>
            <div v-if="ifscCodesMatch && !ifscCodeFormatError && !reenterIfscCodeFormatError" class="valid-feedback">
              IFSC codes match ✓
            </div>
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'Joined'"
            label="Joining Date *"
            label-for="joiningDate"
          >     
            <flat-pickr
              class="form-control"
              id="joinDate" 
              v-model="joiningDate" 
              placeholder="YYYY-MM-DD"
              @input="setContractStartDate"
            />
          </b-form-group>
          
          
          <b-form-group v-if="statusCSelected === 'Joined' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && category === 'White Collar'"
            label="Contract Start Date *"
            label-for="contractStartDate"
          >     
            <flat-pickr
              class="form-control"
              id="contractStartDate" 
              v-model="contractStartDate" 
              placeholder="YYYY-MM-DD"
              
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Joined' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && category === 'White Collar'"
            label="Contract End Date *"
            label-for="contractStartDate"
          >     
            <flat-pickr
              class="form-control"
              id="contractEndDate" 
              v-model="contractEndDate" 
              placeholder="YYYY-MM-DD"
              
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Joined' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && category === 'White Collar'"
            label="Rate Card Without GST*"
            label-for="rateCard"
          >     
            <b-form-input
              class="form-control"
              id="rateCard" 
              v-model="rateCard" 
              placeholder="Enter Rate Card of employee"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Joined' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && category === 'White Collar'"
            label="Gross Monthly Salary *"
            label-for="monthlyCTC"
          >     
            <b-form-input
              class="form-control"
              id="monthlyCTC" 
              v-model="monthlyCTC" 
              placeholder="Enter Gross Monthly Salary of employee"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Joined' && (positionType === 'Contractual' || positionType === 'Cost Plus') && payroll === 'Sattva Payroll' && category === 'White Collar'"
            label="Probation Days *"
            label-for="probationDays"
          >     
            <b-form-input
              class="form-control"
              id="probationDays" 
              v-model="probationDays" 
              placeholder="Enter Probation Days of employee"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'NotOffered'"
            label="Drop Reason *"
            label-for="drop-reason"
          >
            <v-select
                      v-model="dropReason"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="notOfferedOptions"
                      ref="drop-reason"
                      :reduce="(option) => option.title"
                    />
                    <!-- taggable
                      push-tags -->
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Early Attrition' || statusCSelected === 'Attrition'"
            label="Attrition Date *"
            label-for="attritionDate"
          >     
            <flat-pickr
              class="form-control"
              id="attritionDate" 
              v-model="attritionDate" 
              placeholder="YYYY-MM-DD"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'OfferDrop'"
            label="Drop Reason *"
            label-for="drop-reason"
          >
            <v-select
                      v-model="dropReason"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="offerDropOptions"
                      ref="drop-reason"
                      :reduce="(option) => option.title"
                      taggable
                      push-tags
                    />
          </b-form-group>                    
          <small v-if="!statusCSelected" class="text-danger"> {{ error_status }}</small>
          
        </b-form>
        <b-form v-if="statusCSelected === 'Duplicate'">
          <b-form-group label="Choose the Reason *" label-for="vue-select"  v-if="NI">
            
            <v-select
                      v-model="dupReasonSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="DuplicateOptions"
                      ref="dup-reaon"
                    />
          </b-form-group>
          <b-form-group label="Add Cooling Period if avaiable *" label-for="vue-select">
            <v-select
                      v-model="coolingTimeline"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="coolingTimelineOptions"
                      ref="cooling-option"
                    />
                <small v-if="!NI_NR_comment" class="text-danger"> {{ error_NI_NR_comment }}</small>
              </b-form-group>
        </b-form>
      </b-modal>
      <b-modal
        id="modal-ni-nr-reason"
        ref="modal-ni-nr-reason"
        no-close-on-backdrop
        :title="NI === true ? 'Select Reason & Add Comment for Not Interested Candidate': 'Add Comment for Not Relevant Candidate'"
        ok-title="submit"
        cancel-variant="outline-secondary"
        @ok="updateCandidateNINRReason"
      >
        <b-form>
          <b-form-group label="Choose the Reason *" label-for="vue-select"  v-if="NI">
            
            <v-select
                      v-model="NI_Reason_Selected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="NotInterestedReason"
                      ref="ni-reaon"
                    />
          </b-form-group>
          <b-form-group label="Add Comment *" label-for="vue-select">
                <b-form-textarea
                  id="textarea-default"
                  v-model="NI_NR_comment"
                  placeholder="add comment for not interested, not relevant candidate"
                  rows="3"
                />
                <small v-if="!NI_NR_comment" class="text-danger"> {{ error_NI_NR_comment }}</small>
              </b-form-group>
        </b-form>
      </b-modal>
      <b-modal
        id="modal-dup-status"
        ref="modal-dup-status"
        no-close-on-backdrop
        title="Select Reason & Add Timeline for Duplicate Candidate"
        ok-title="submit"
        cancel-variant="outline-secondary"
        @ok="updateDuplicate"
      >
        <b-form>
          <b-form-group label="Choose the Reason *" label-for="vue-select"  >
            
            <v-select
                      v-model="dupReasonSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="DuplicateOptions"
                      ref="dup-reaon"
                    />
          </b-form-group>
          <b-form-group label="Add Cooling Period if avaiable *" label-for="vue-select">
            <v-select
                      v-model="coolingTimeline"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="coolingTimelineOptions"
                      ref="cooling-option"
                    />
                <small v-if="!NI_NR_comment" class="text-danger"> {{ error_NI_NR_comment }}</small>
              </b-form-group>
        </b-form>
      </b-modal>
      <b-modal
        id="modal-na-status"
        ref="modal-na-status"
        no-close-on-backdrop
        title="Select Proper Status for Candidate"
        ok-title="submit"
        cancel-variant="outline-secondary"
        @ok="updateNotAnswered"
      >
        <b-form>
          <b-form-group label="Choose the Reason *" label-for="vue-select">
            
            <v-select
                      v-model="NA_Reason_Selected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="NotAnsweredOptions"
                      ref="na-reason"
                    />
          </b-form-group>
          <b-form-group label="Add Comment" label-for="vue-select">
                <b-form-textarea
                  id="textarea-default"
                  v-model="NA_comment"
                  placeholder="add comment for Call Back Candidates"
                  rows="3"
                />
                <small v-if="!NA_comment" class="text-danger"> {{ error_NA_comment }}</small>
              </b-form-group>
        </b-form>
      </b-modal>
      <b-modal
        id="modal-doc-upload"
        ref="modal-doc-upload"
        title="Upload Documents"
        size="lg"
        ok-only
        ok-title="OK"
      >
      
        <b-form @submit.prevent>
          <b-row>
            <!-- Aadhaar Front Upload -->
            <b-col md="6" v-if="showAadhaarFrontUpload">
                <b-form-group label="Aadhaar Card - Front" class="text-primary">
                  <b-form-file
                    v-model="documents.aadhaarCardFront"
                    placeholder="Choose or drop file"
                    drop-placeholder="Drop file here"
                    browse-text=""
                    id="aadhaar-front-file-modal"
                    name="aadhaar-front-file-modal"
                    accept="image/png,image/jpeg,image/jpg"
                    
                  />
                  <b-card-text class="my-1">
                    Selected file: <strong>{{ documents.aadhaarCardFront ? documents.aadhaarCardFront.name : '' }}</strong>
                    <div v-if="loadingAadhaarFront">
                      <div class="text-center">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                    </div>
                  </b-card-text>
              </b-form-group>
            </b-col>
            <b-col md="4" v-else-if="!showAadhaarFrontUpload && !aadhaarFrontUploaded">
              <h4 class="my-1 mt-2 pt-1 text-primary">
              <strong><u>Aadhaar Front</u></strong>
              </h4>
            </b-col>
            <b-col col class="mt-2 pt-1" v-if="showAadhaarFrontUpload">
              <span class="text-primary" @click="uploadAadhaarFront"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              
            </b-col>
            
            <b-col col class="mt-2 pt-1" v-if="aadhaarFrontUploaded">
              <span class="text-primary" @click="previewFile('aadhaar_front')"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
              <span class="text-primary" @click="downloadFile('aadhaar_front')"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
            <br>
            <span class="text-muted">Front</span>
            </b-col>
          
            <b-col col class="mt-2 pt-1" v-if="aadhaarFrontUploaded">
              <span class="text-warning" @click="reUploadAadhaarFront" v-if="!showAadhaarFrontUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              <span class="text-warning" @click="reUploadAadhaarFront" v-if="showAadhaarFrontUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
            
            <!-- Aadhaar Back Upload -->
            <b-col md="6" v-if="showAadhaarBackUpload">
                <b-form-group label="Aadhaar Card - Back" class="text-primary">
                  <b-form-file
                    v-model="documents.aadhaarCardBack"
                    placeholder="Choose or drop file"
                    drop-placeholder="Drop file here"
                    browse-text=""
                    id="aadhaar-back-file-modal"
                    name="aadhaar-back-file-modal"
                    accept="image/png,image/jpeg,image/jpg"
                    
                  />
                  <b-card-text class="my-1">
                    Selected file: <strong>{{ documents.aadhaarCardBack ? documents.aadhaarCardBack.name : '' }}</strong>
                    <div v-if="loadingAadhaarBack">
                      <div class="text-center">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                    </div>
                  </b-card-text>
              </b-form-group>
            </b-col>
            <b-col md="4" v-else-if="!showAadhaarBackUpload && !aadhaarBackUploaded">
              <h4 class="my-1 mt-2 pt-1 text-primary">
              <strong><u>Aadhaar Back</u></strong>
              </h4>
            </b-col>
            <b-col col class="mt-2 pt-1" v-if="showAadhaarBackUpload">
              <span class="text-primary" @click="uploadAadhaarBack"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              
            </b-col>
            
            <b-col col class="mt-2 pt-1" v-if="aadhaarBackUploaded">
              <span class="text-primary" @click="previewFile('aadhaar_back')"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
              <span class="text-primary" @click="downloadFile('aadhaar_back')"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
            <br>
            <span class="text-muted">Back</span>
            </b-col>
          
            <b-col col class="mt-2 pt-1" v-if="aadhaarBackUploaded">
              <span class="text-warning" @click="reUploadAadhaarBack" v-if="!showAadhaarBackUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              <span class="text-warning" @click="reUploadAadhaarBack" v-if="showAadhaarBackUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
            
            <!-- Aadhaar Number Display -->
            <b-col cols="12" v-if="(aadhaarFrontUploaded || aadhaarBackUploaded) && candidateMetadata && candidateMetadata.hasOwnProperty('aadhaarNumber')">
              <b-card-text class="mt-2">
                <strong>Aadhaar Number:</strong> {{ candidateMetadata.aadhaarNumber }}
              </b-card-text>
            </b-col>
            
          </b-row>
          <hr style="border: 1px solid lightgreen;">
        </b-form> 
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6" v-if="showPanUpload">
                <b-form-group label="Pan Card" class="text-primary">
                  <b-form-file
                    v-model="documents.panCard"
                    placeholder="Choose or drop file"
                    drop-placeholder="Drop file here"
                    browse-text=""
                    id="pan-file"
                    name="pan-file"
                    accept="application/pdf,image/png,image/jpeg,image/jpg"
                  />
                  <b-card-text class="my-1">
                    Selected file: <strong>{{ documents.panCard ? documents.panCard.name : '' }}</strong>
                    <div v-if="loadingPan">
                      <div class="text-center">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                    </div>
                  </b-card-text>
              </b-form-group>
            </b-col>
            <b-col md="4" v-else>
              <h4 class="my-1 mt-2 pt-1 text-primary">
              <strong><u>Pan Card File</u></strong>
              </h4>
            </b-col>
            <b-col col class="mt-2 pt-1" v-if="showPanUpload">
              
              <span class="text-primary" @click="uploadPan"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
            
            <b-col col class="mt-2 pt-1" v-if="panUploaded">
              <span class="text-primary" @click="previewFile('pan')"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
              <span class="text-primary" @click="downloadFile('pan')"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
              <br>

            <span v-if="candidateMetadata && candidateMetadata.hasOwnProperty('aadhaarNumber')">{{ candidateMetadata.panNumber }}</span>
              <!-- <span v-if="candidateMetadata.hasOwnProperty('panNumber')">{{ candidateMetadata.panNumber }}</span> -->
              <!-- <a :href="docDownloadlink" @click="downloadFile('pan')"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></a> -->
            </b-col>
          
            <b-col col class="mt-2 pt-1" v-if="panUploaded">
              <span class="text-warning" @click="reUploadPan" v-if="!showPanUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              <span class="text-warning" @click="reUploadPan" v-if="showPanUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
          </b-row>
          <hr style="border: 1px solid lightgreen;">
        </b-form>
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6" v-if="showPhotoUpload">
                <b-form-group label="Passport Size Photo" class="text-primary">
                  <b-form-file
                    v-model="documents.passportPhoto"
                    placeholder="Choose or drop file"
                    drop-placeholder="Drop file here"
                    browse-text=""
                    id="photo-file"
                    name="photo-file"
                    accept="application/pdf,image/png,image/jpeg,image/jpg"
                  />
                  <b-card-text class="my-1">
                    Selected file: <strong>{{ documents.passportPhoto ? documents.passportPhoto.name : '' }}</strong>
                    <div v-if="loadingPhoto">
                      <div class="text-center">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                    </div>
                  </b-card-text>
              </b-form-group>
            </b-col>
            <b-col md="4" v-else>
              <h4 class="my-1 mt-2 pt-1 text-primary">
              <strong><u>Photo</u></strong>
              </h4>
            </b-col>
            <b-col col class="mt-2 pt-1" v-if="showPhotoUpload">
              
              <span class="text-primary" @click="uploadPhoto"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
            
            <b-col col class="mt-2 pt-1" v-if="photoUploaded">
              <span class="text-primary" @click="previewFile('photo')"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
              <span class="text-primary" @click="downloadFile('photo')"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
              <!-- <a :href="docDownloadlink" @click="downloadFile('photo')"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></a> -->
            </b-col>
          
            <b-col col class="mt-2 pt-1" v-if="photoUploaded">
              <span class="text-warning" @click="reUploadPhoto" v-if="!showPhotoUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              <span class="text-warning" @click="reUploadPhoto" v-if="showPhotoUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
          </b-row>
          <hr style="border: 1px solid lightgreen;">
        </b-form>
        
        <b-form @submit.prevent v-if="prevStatus === 'Interview' || prevStatus === 'Shortlisted' || prevStatus === 'Offered' || prevStatus === 'Joined' || prevStatus === 'LOI Issued' || prevStatus === 'Attrition' || prevStatus === 'Early Attrition' || prevStatus === 'Drop'">
          <b-row>
            <b-col md="6" v-if="showBankUpload">
                <b-form-group label="Bank Proof" class="text-primary">
                  <b-form-file
                    v-model="documents.bankProof"
                    placeholder="Choose or drop file"
                    drop-placeholder="Drop file here"
                    browse-text=""
                    id="bank-file"
                    name="bank-file"
                    accept="application/pdf,image/png,image/jpeg,image/jpg"
                  />
                  <b-card-text class="my-1">
                    Selected file: <strong>{{ documents.bankProof ? documents.bankProof.name : '' }}</strong>
                    <div v-if="loadingBankDoc">
                      <div class="text-center">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                    </div>
                  </b-card-text>
              </b-form-group>
            </b-col>
            <b-col md="4" v-else>
              <h4 class="my-1 mt-2 pt-1 text-primary">
              <strong><u>Bank Proof</u></strong>
              </h4>
            </b-col>
            <b-col col class="mt-2 pt-1" v-if="showBankUpload">
              
              <span class="text-primary" @click="uploadBank"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
            <b-col col class="mt-2 pt-1" v-if="bankUploaded">
              <span class="text-primary" @click="previewFile('bankProof')" v-b-tooltip.hover title="Preview"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
              <span class="text-primary" @click="downloadFile('bankProof')" v-b-tooltip.hover title="Download"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
              
            </b-col>
          
            <b-col col class="mt-2 pt-1" v-if="bankUploaded">
              <span class="text-warning" @click="reUploadBank" v-if="!showBankUpload" v-b-tooltip.hover title="Re-Upload"> <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              <span class="text-warning" @click="reUploadBank" v-if="showBankUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
          </b-row>
          <hr style="border: 1px solid lightgreen;">
        </b-form>
        <b-form @submit.prevent>
          
          <b-row>
            
            <b-col md="6" v-if="showCertificateUpload && skillCertificateAvailable">
                <b-form-group label="Skill Certificate" class="text-primary">
                  
                  <b-form-file
                    v-model="documents.skillCertificate"
                    placeholder="Choose or drop file"
                    drop-placeholder="Drop file here"
                    browse-text=""
                    id="certificate-file"
                    name="certificate-file"
                    accept="application/pdf,image/png,image/jpeg,image/jpg"
                  />
                  <span></span>
                  <b-card-text class="my-1">
                    Selected file: <strong>{{ documents.skillCertificate ? documents.skillCertificate.name : '' }}</strong>
                    <div v-if="loadingCertificate">
                      <div class="text-center">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                    </div>
                  </b-card-text>
                </b-form-group>
            </b-col>
            <b-col md="4" v-else>
              <h4 class="my-1 mt-2 pt-1 text-primary">
              <strong><u>Skill Certificate</u></strong>
              </h4>
            </b-col>
            <b-col col class="mt-2 pt-1" v-if="showCertificateUpload && skillCertificateAvailable">
              
              <span class="text-primary" @click="uploadCertificate"> Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
            
            <b-col col class="mt-2 pt-1" v-if="certificateUploaded">
              <span class="text-primary" @click="previewFile('skillCertificate')" v-b-tooltip.hover title="Preview"> <feather-icon icon="EyeIcon" size="20" class="mr-50" /></span>
              <span class="text-primary" @click="downloadFile('skillCertificate')" v-b-tooltip.hover title="Download"><feather-icon icon="ArrowDownCircleIcon" size="20" class="mr-50" /></span>
              
            </b-col>
          
            <b-col col class="mt-2 pt-1" v-if="certificateUploaded">
              <span class="text-warning" @click="reUploadCertificate" v-if="!showCertificateUpload"> Re-Upload <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
              <span class="text-warning" @click="reUploadCertificate" v-if="showCertificateUpload"> Cancel <feather-icon icon="ArrowUpCircleIcon" size="20" class="mr-50" /></span>
            </b-col>
          
          
            <b-col col class="mt-2 pt-1" v-if="!certificateUploaded">
              <div style="float:left" >
                <b-card-text class="mb-1">
                  Is Skill Certificate Available?
                </b-card-text>
                  <b-form-checkbox v-model="skillCertificateAvailable" name="check-button" switch></b-form-checkbox>
              </div>
            </b-col>
          
          </b-row>
          <hr style="border: 1px solid lightgreen;">
        </b-form> 
          
      </b-modal>
      <!-- <b-modal
        id="modal-generate-offer-letter"
        ref="modal-generate-offer-letter"
        @ok="previewOfferLetter"
        size="xl"
        title="Offer Letter"
        
      >
      <b-form>
        <b-row>
            <b-col
                cols="12"
                class="mb-2"
              >
                <quill-editor
                  v-model="offerLetterContent"
                  :options="snowOption"
                  ref="jd"

                />
                <small class="text-danger">{{ error.jd }}</small>
            </b-col>
        </b-row>
      </b-form>
      
      </b-modal> -->
      <b-modal
            id="doc-preview-modal"
            ref="doc-preview-modal"
            ok-only
            ok-title="Accept"
            centered
            size="xl"
            title="CV Preview"
        >
            
            <div>
                <div>
                    <iframe :src="canDocLink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
            </div>
        </b-modal>

      <!-- Payroll Modal -->
      <b-modal
        id="payroll-modal"
        ref="payroll-modal"
        :title="payrollButtonText"
        size="xl"
        @ok="submitPayrollData"
        @hidden="resetPayrollForm"
      >
        <b-form @submit.prevent>
          <!-- Basic Information - Left Column -->
          <b-row>
            <b-col md="6">
              <b-card title="Basic Information" class="mb-3">
                <b-form-group label="Project Select" label-for="project-select">
                  <v-select
                    v-model="payrollForm.project"
                    :options="projectOptions"
                    label="title"
                    placeholder="Select Project"
                    :reduce="option => option.title"
                  />
                </b-form-group>
                
                <b-form-group label="Location Select" label-for="location-select">
                  <v-select
                    v-model="payrollForm.location"
                    :options="locationOptions"
                    label="title"
                    placeholder="Select Location"
                    :reduce="option => option.title"
                  />
                </b-form-group>
                
                <b-form-group label="Joining Date" label-for="joining-date">
                  <flat-pickr
                    v-model="payrollForm.joiningDate"
                    class="form-control"
                    placeholder="Select Joining Date"
                    :config="flatpickrConfig"
                  />
                </b-form-group>
                
                <b-form-group label="Offered Gross" label-for="offered-gross">
                  <b-form-input
                    id="offered-gross"
                    v-model="payrollForm.offeredGross"
                    type="number"
                    step="0.01"
                    placeholder="Enter offered gross amount"
                  />
                </b-form-group>
              </b-card>
            </b-col>
            
            <!-- Smart Meter Project Fields - Right Column -->
            <b-col md="6">
              <b-card title="Smart Meter Configuration" class="mb-3" v-if="isSmartMeterProject">
                <b-form-group label="Salary Model" label-for="salary-model">
                  <v-select
                    id="salary-model"
                    v-model="payrollForm.salaryModel"
                    :options="salaryModelOptions"
                    placeholder="Select salary model"
                    :reduce="option => option.value"
                    label="title"
                  />
                </b-form-group>
                
                <b-form-group label="Benefits Included" label-for="benefits-included" v-if="payrollForm.salaryModel === 'proRata' || payrollForm.salaryModel === 'fixed'">
                  <v-select
                    id="benefits-included"
                    v-model="payrollForm.benefitsIncluded"
                    :options="benefitsOptions"
                    placeholder="Select benefits"
                    :reduce="option => option.value"
                    label="title"
                    multiple
                  />
                </b-form-group>
              </b-card>
              
              <!-- Document Upload - Right Column -->
              <b-card title="Document Upload" class="mb-3">
                <b-form-group :label="isSmartMeterProject && payrollForm.salaryModel === 'perMeter' ? 'Upload Contract Letter' : 'Upload Offer Letter'" label-for="offer-letter">
                  <b-form-file
                    id="offer-letter"
                    v-model="payrollForm.offerLetter"
                    :placeholder="isSmartMeterProject && payrollForm.salaryModel === 'perMeter' ? 'Choose or drop contract letter file' : 'Choose or drop offer letter file'"
                    drop-placeholder="Drop file here"
                    browse-text=""
                    accept=".pdf,.doc,.docx"
                  />
                  <small class="text-muted">Supported formats: PDF, DOC, DOCX</small>
                </b-form-group>
              </b-card>
            </b-col>
          </b-row>

          <!-- Validation Fields - Full Width -->
          <b-card title="Data Validation" class="mb-3">
            <!-- Account Number Validation -->
            <b-row>
              <b-col md="6">
                <b-form-group label="Original Account Number" label-for="original-account">
                  <b-form-input
                    id="original-account"
                    :value="candidateMetadata.accountNumber || ''"
                    readonly
                    class="bg-light"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Re-enter Account Number" label-for="reenter-account">
                  <b-form-input
                    id="reenter-account"
                    v-model="payrollForm.reenterAccountNumber"
                    placeholder="Re-enter account number"
                    :class="{ 'is-invalid': payrollForm.accountNumberMismatch }"
                  />
                  <div v-if="payrollForm.accountNumberMismatch" class="invalid-feedback">
                    Account numbers do not match
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- IFSC Code Validation -->
            <b-row>
              <b-col md="6">
                <b-form-group label="Original IFSC Code" label-for="original-ifsc">
                  <b-form-input
                    id="original-ifsc"
                    :value="candidateMetadata.ifscCode || ''"
                    readonly
                    class="bg-light"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Re-enter IFSC Code" label-for="reenter-ifsc">
                  <b-form-input
                    id="reenter-ifsc"
                    v-model="payrollForm.reenterIfscCode"
                    placeholder="Re-enter IFSC code"
                    :class="{ 'is-invalid': payrollForm.ifscCodeMismatch }"
                  />
                  <div v-if="payrollForm.ifscCodeMismatch" class="invalid-feedback">
                    IFSC codes do not match
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- PAN Number Validation -->
            <b-row>
              <b-col md="6">
                <b-form-group label="Original PAN Number" label-for="original-pan">
                  <b-form-input
                    id="original-pan"
                    :value="candidateMetadata.panNumber || ''"
                    readonly
                    class="bg-light"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Re-enter PAN Number" label-for="reenter-pan">
                  <b-form-input
                    id="reenter-pan"
                    v-model="payrollForm.reenterPanNumber"
                    placeholder="Re-enter PAN number"
                    :class="{ 'is-invalid': payrollForm.panNumberMismatch }"
                  />
                  <div v-if="payrollForm.panNumberMismatch" class="invalid-feedback">
                    PAN numbers do not match
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <!-- Verification Checkboxes - Full Width -->
          <b-card title="Verification Status" class="mb-3">
            <b-row>
              <b-col md="4">
                <b-form-group label="Account Number Checked" label-for="account-checked">
                  <b-form-checkbox
                    id="account-checked"
                    v-model="payrollForm.accountNumberChecked"
                    name="account-checked"
                    switch
                    :disabled="payrollForm.accountNumberMismatch"
                  >
                    Account Number Verified
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="IFSC Code Checked" label-for="ifsc-checked">
                  <b-form-checkbox
                    id="ifsc-checked"
                    v-model="payrollForm.ifscCodeChecked"
                    name="ifsc-checked"
                    switch
                    :disabled="payrollForm.ifscCodeMismatch"
                  >
                    IFSC Code Verified
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="PAN Number Checked" label-for="pan-checked">
                  <b-form-checkbox
                    id="pan-checked"
                    v-model="payrollForm.panNumberChecked"
                    name="pan-checked"
                    switch
                    :disabled="payrollForm.panNumberMismatch"
                  >
                    PAN Number Verified
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <!-- Candidate Details for Reference -->
          <b-card title="Candidate Details for Reference" class="mb-3">
            <b-row>
              <b-col md="6" class="mb-2 d-flex align-items-center">
                <span class="font-weight-bold mr-2">Aadhaar Number:</span>
                <span>{{ candidateMetadata.aadhaarNumber || 'Not Available' }}</span>
              </b-col>
              <b-col md="6" class="mb-2 d-flex align-items-center">
                <span class="font-weight-bold mr-2">PAN Card Number:</span>
                <span>{{ candidateMetadata.panNumber || 'Not Available' }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mb-2 d-flex align-items-center">
                <span class="font-weight-bold mr-2">Bank Proof:</span>
                <span v-if="bankUploaded" class="mr-2 text-success">
                  <feather-icon icon="CheckCircleIcon" size="16" class="mr-1" />
                  Uploaded
                </span>
                <span v-else class="mr-2 text-muted">
                  <feather-icon icon="XCircleIcon" size="16" class="mr-1" />
                  Not Uploaded
                </span>
                <b-button
                  v-if="bankUploaded"
                  variant="outline-primary"
                  size="sm"
                  @click="previewFile('bankProof')"
                  title="Preview Bank Proof"
                  class="mr-2"
                >
                  <feather-icon icon="EyeIcon" size="14" class="mr-1" />
                  Preview
                </b-button>
                <span class="font-weight-bold ml-2">Account Number:</span>
                <span class="ml-1">{{ candidateMetadata.accountNumber || 'Not Available' }}</span>
                <span class="font-weight-bold ml-3">IFSC:</span>
                <span class="ml-1">{{ candidateMetadata.ifscCode || 'Not Available' }}</span>
              </b-col>
            </b-row>
          </b-card>

          <!-- View Documents Section -->
          <b-card title="View Uploaded Documents" class="mt-3">
            <b-row>
              <b-col md="6">
                <b-form-group label="Aadhaar Card">
                  <div class="d-flex align-items-center">
                    <span v-if="aadhaarUploaded" class="text-success mr-2">
                      <feather-icon icon="CheckCircleIcon" size="16" />
                      Uploaded
                    </span>
                    <span v-else class="text-muted mr-2">
                      <feather-icon icon="XCircleIcon" size="16" />
                      Not Uploaded
                    </span>
                    <b-button 
                      v-if="aadhaarUploaded" 
                      variant="outline-primary" 
                      size="sm"
                      @click="previewFile('aadhaar')"
                    >
                      <feather-icon icon="EyeIcon" size="14" class="mr-1" />
                      Preview
                    </b-button>
                    <b-button 
                      v-if="aadhaarUploaded" 
                      variant="outline-secondary" 
                      size="sm"
                      @click="downloadFile('aadhaar')"
                    >
                      <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
                      Download
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="PAN Card">
                  <div class="d-flex align-items-center">
                    <span v-if="panUploaded" class="text-success mr-2">
                      <feather-icon icon="CheckCircleIcon" size="16" />
                      Uploaded
                    </span>
                    <span v-else class="text-muted mr-2">
                      <feather-icon icon="XCircleIcon" size="16" />
                      Not Uploaded
                    </span>
                    <b-button 
                      v-if="panUploaded" 
                      variant="outline-primary" 
                      size="sm"
                      @click="previewFile('pan')"
                    >
                      <feather-icon icon="EyeIcon" size="14" class="mr-1" />
                      Preview
                    </b-button>
                    <b-button 
                      v-if="panUploaded" 
                      variant="outline-secondary" 
                      size="sm"
                      @click="downloadFile('pan')"
                    >
                      <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
                      Download
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-row>
              <b-col md="6">
                <b-form-group label="Photo">
                  <div class="d-flex align-items-center">
                    <span v-if="photoUploaded" class="text-success mr-2">
                      <feather-icon icon="CheckCircleIcon" size="16" />
                      Uploaded
                    </span>
                    <span v-else class="text-muted mr-2">
                      <feather-icon icon="XCircleIcon" size="16" />
                      Not Uploaded
                    </span>
                    <b-button 
                      v-if="photoUploaded" 
                      variant="outline-primary" 
                      size="sm"
                      @click="previewFile('photo')"
                    >
                      <feather-icon icon="EyeIcon" size="14" class="mr-1" />
                      Preview
                    </b-button>
                    <b-button 
                      v-if="photoUploaded" 
                      variant="outline-secondary" 
                      size="sm"
                      @click="downloadFile('photo')"
                    >
                      <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
                      Download
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Skill Certificate">
                  <div class="d-flex align-items-center">
                    <span v-if="certificateUploaded" class="text-success mr-2">
                      <feather-icon icon="CheckCircleIcon" size="16" />
                      Uploaded
                    </span>
                    <span v-else class="text-muted mr-2">
                      <feather-icon icon="XCircleIcon" size="16" />
                      Not Uploaded
                    </span>
                    <b-button 
                      v-if="certificateUploaded" 
                      variant="outline-primary" 
                      size="sm"
                      @click="previewFile('certificate')"
                    >
                      <feather-icon icon="EyeIcon" size="14" class="mr-1" />
                      Preview
                    </b-button>
                    <b-button 
                      v-if="certificateUploaded" 
                      variant="outline-secondary" 
                      size="sm"
                      @click="downloadFile('certificate')"
                    >
                      <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
                      Download
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <!-- Selected File Preview -->
          <b-card title="Selected File" class="mt-3" v-if="payrollForm.offerLetter">
            <div class="d-flex align-items-center">
              <span v-if="payrollForm.offerLetter" class="text-success mr-2">
                <feather-icon icon="CheckCircleIcon" size="16" />
                File Selected
              </span>
              <span v-if="payrollForm.offerLetter" class="text-info">
                {{ payrollForm.offerLetter.name }}
              </span>
            </div>
          </b-card>
        </b-form>

        <template #modal-footer="{ ok, cancel }">
          <b-button variant="secondary" @click="cancel">
            Cancel
          </b-button>
          <b-button 
            variant="primary" 
            @click="ok"
            :disabled="isInfraIndustryValidationFailed"
          >
            Submit
          </b-button>
        </template>
      </b-modal>
      
      <!-- KPMG RPO Offer Process Modal -->
      <b-modal
        id="modal-kpmg-offer-process"
        ref="modal-kpmg-offer-process"
        :title="isKPMGOfferProcessReadOnly ? 'KPMG RPO Offer Process (Read Only)' : 'KPMG RPO Offer Process'"
        size="xl"
        no-close-on-backdrop
        cancel-variant="outline-secondary"
        :ok-disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly"
        :ok-title="isKPMGOfferProcessReadOnly ? 'Close' : 'Submit Offer Process'"
        @ok="isKPMGOfferProcessReadOnly ? $bvModal.hide('modal-kpmg-offer-process') : saveKPMGOfferProcess"
      >
        <div class="kpmg-offer-process-container">
          <!-- Access Control Notice -->
          <div v-if="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly" class="access-notice mb-3 p-3 bg-warning text-dark rounded">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            <strong v-if="isKPMGOfferProcessReadOnly">Read Only Mode:</strong>
            <strong v-else>View Only Mode:</strong>
            <span v-if="isKPMGOfferProcessReadOnly">
              This candidate is in {{ candidateJobData.candidateStatus }} status. You can view the KPMG RPO Offer Process details, but no changes can be made.
            </span>
            <span v-else>
              You can view the KPMG RPO Offer Process details, but you don't have permission to make changes. 
              Only the assigned POC permission can update this process.
            </span>
          </div>
          
          <!-- Progress Bar -->
          <div class="progress-section mb-4">
            <div class="progress-info">
              <span class="progress-text">Progress: {{ completedStagesCount }}/{{ totalStagesCount }} stages completed ({{ progressPercentage }}%)</span>
              <div v-if="!isKPMGOfferProcessCompleted" class="completion-notice">
                <i class="fas fa-info-circle text-info"></i>
                Complete all stages to enable "Update Status" button
              </div>
              <div v-else class="completion-notice">
                <i class="fas fa-check-circle text-success"></i>
                All stages completed! You can now use "Update Status" button
              </div>
            </div>
            <div class="progress">
              <div 
                class="progress-bar bg-success" 
                :style="{ width: progressPercentage + '%' }"
                role="progressbar"
              ></div>
            </div>
          </div>

          <!-- Business and POC Selection -->
          <!-- <div class="business-poc-section mb-4">
            <h6 class="section-title mb-3">Business and POC Assignment</h6>
            <b-row>
              <b-col md="6">
                <b-form-group label="Business" label-for="business-select">
                  <v-select
                    id="business-select"
                    v-model="offerProcess.business.selected"
                    :options="businessOptions"
                    placeholder="Select Business"
                    :reduce="option => option.value"
                    label="text"
                    @input="onStageStatusChange('business')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="POC" label-for="poc-select">
                  <v-select
                    id="poc-select"
                    v-model="offerProcess.pocs.selected"
                    :options="pocOptions"
                    placeholder="Select POC"
                    :reduce="option => option.value"
                    label="text"
                    @input="onStageStatusChange('pocs')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div> -->

          <!-- Stages List -->
          <div class="stages-list" v-if="isKPMGRPOEnabled">
            <!-- Tagging Stage -->
            <div class="stage-item" :class="{ 'active': true, 'completed': getOfferProcessStatus('tagging') === 'Tagged' && offerProcess.tagging.reqId }">
              <div class="stage-info">
                <span class="stage-number">1.</span>
                <span class="stage-name">Tagging</span>
                <span class="stage-status" v-if="getOfferProcessStatus('tagging') === 'Tagged' && offerProcess.tagging.reqId">
                  <i class="fas fa-check-circle text-success"></i> Tagged
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('tagging') === 'Pending'">
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.tagging.status" @change="onStageStatusChange('tagging')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Tagged">Tagged</b-form-radio>
                </b-form-radio-group>
                <b-form-input
                  v-if="offerProcess.tagging.status === 'Tagged'"
                  v-model="offerProcess.tagging.reqId"
                  placeholder="Req ID"
                  size="sm"
                  class="req-id-input"
                  @input="onStageStatusChange('tagging')"
                  :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly"
                />
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('tagging')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.tagging.comments && offerProcess.tagging.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.tagging" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.tagging.comments[offerProcess.tagging.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.tagging.comments[offerProcess.tagging.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.tagging.comments[offerProcess.tagging.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.tagging.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.tagging.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('tagging')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.tagging ? 'Show Less' : `Show ${offerProcess.tagging.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Early KGS BGV Stage (KYC F&A Only) -->
            <div class="stage-item" :class="{ 'active': isStageVisible('earlyKgsBGV'), 'completed': getOfferProcessStatus('earlyKgsBGV') === 'Cleared' }" v-if="isStageVisible('earlyKgsBGV')">
              <div class="stage-info">
                <span class="stage-number">2.</span>
                <span class="stage-name">Early KGS BGV (KYC F&A)</span>
                <span class="stage-status" v-if="getOfferProcessStatus('earlyKgsBGV') === 'Cleared'">
                  <i class="fas fa-check-circle text-success"></i> Cleared
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('earlyKgsBGV') === 'Failed'">
                  <i class="fas fa-times-circle text-danger"></i> Failed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('earlyKgsBGV') === 'InProcess With Client'">
                  <i class="fas fa-spinner text-info"></i> InProcess With Client
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('earlyKgsBGV') === 'Pending With Candidate'">
                  <i class="fas fa-user-clock text-warning"></i> Pending With Candidate
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('earlyKgsBGV') === 'Initiated'">
                  <i class="fas fa-play-circle text-primary"></i> Initiated
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.earlyKgsBGV.status" @change="onStageStatusChange('earlyKgsBGV')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Initiated">Initiated</b-form-radio>
                  <b-form-radio value="InProcess With Client">InProcess With Client</b-form-radio>
                  <b-form-radio value="Pending With Candidate">Pending With Candidate</b-form-radio>
                  <b-form-radio value="Cleared">Cleared</b-form-radio>
                  <b-form-radio value="Failed">Failed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('earlyKgsBGV')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.earlyKgsBGV.comments && offerProcess.earlyKgsBGV.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.earlyKgsBGV" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.earlyKgsBGV.comments[offerProcess.earlyKgsBGV.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.earlyKgsBGV.comments[offerProcess.earlyKgsBGV.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.earlyKgsBGV.comments[offerProcess.earlyKgsBGV.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.earlyKgsBGV.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.earlyKgsBGV.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('earlyKgsBGV')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.earlyKgsBGV ? 'Show Less' : `Show ${offerProcess.earlyKgsBGV.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Job Application Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('jobApplication'), 'completed': getOfferProcessStatus('jobApplication') === 'Completed' }" v-if="isStageVisible('jobApplication')">
              <div class="stage-info">
                <span class="stage-number">3.</span>
                <span class="stage-name">Job Application</span>
                <span class="stage-status" v-if="getOfferProcessStatus('jobApplication') === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('jobApplication') === 'Triggered'">
                  <i class="fas fa-play-circle text-info"></i> Triggered
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('jobApplication') === 'Retriggered'">
                  <i class="fas fa-redo text-warning"></i> Retriggered
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Not Triggered
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.jobApplication.status" @change="onStageStatusChange('jobApplication')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Not Triggered">Not Triggered</b-form-radio>
                  <b-form-radio value="Triggered">Triggered</b-form-radio>
                  <b-form-radio value="Retriggered">Retriggered</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('jobApplication')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.jobApplication.comments && offerProcess.jobApplication.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.jobApplication" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.jobApplication.comments[offerProcess.jobApplication.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.jobApplication.comments[offerProcess.jobApplication.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.jobApplication.comments[offerProcess.jobApplication.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.jobApplication.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.jobApplication.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('jobApplication')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.jobApplication ? 'Show Less' : `Show ${offerProcess.jobApplication.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- CAF Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('caf'), 'completed': getOfferProcessStatus('caf') === 'Completed' }" v-if="isStageVisible('caf')">
              <div class="stage-info">
                <span class="stage-number">4.</span>
                <span class="stage-name">CAF</span>
                <span class="stage-status" v-if="getOfferProcessStatus('caf') === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('caf') === 'Triggered'">
                  <i class="fas fa-play-circle text-info"></i> Triggered
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('caf') === 'Retriggered'">
                  <i class="fas fa-redo text-warning"></i> Retriggered
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Not Triggered
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.caf.status" @change="onStageStatusChange('caf')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Not Triggered">Not Triggered</b-form-radio>
                  <b-form-radio value="Triggered">Triggered</b-form-radio>
                  <b-form-radio value="Retriggered">Retriggered</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('caf')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.caf.comments && offerProcess.caf.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.caf" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.caf.comments[offerProcess.caf.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.caf.comments[offerProcess.caf.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.caf.comments[offerProcess.caf.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.caf.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.caf.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('caf')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.caf ? 'Show Less' : `Show ${offerProcess.caf.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Documentation Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('documentation'), 'completed': getOfferProcessStatus('documentation') === 'Completed' }" v-if="isStageVisible('documentation')">
              <div class="stage-info">
                <span class="stage-number">5.</span>
                <span class="stage-name">Documentation</span>
                <span class="stage-status" v-if="getOfferProcessStatus('documentation') === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('documentation') === 'Triggered'">
                  <i class="fas fa-play-circle text-info"></i> Triggered
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('documentation') === 'Retriggered'">
                  <i class="fas fa-redo text-warning"></i> Retriggered
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Not Triggered
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.documentation.status" @change="onStageStatusChange('documentation')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Not Triggered">Not Triggered</b-form-radio>
                  <b-form-radio value="Triggered">Triggered</b-form-radio>
                  <b-form-radio value="Retriggered">Retriggered</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('documentation')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.documentation.comments && offerProcess.documentation.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.documentation" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.documentation.comments[offerProcess.documentation.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.documentation.comments[offerProcess.documentation.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.documentation.comments[offerProcess.documentation.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.documentation.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.documentation.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('documentation')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.documentation ? 'Show Less' : `Show ${offerProcess.documentation.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- TAF Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('taf'), 'completed': getOfferProcessStatus('taf') === 'Completed' }" v-if="isStageVisible('taf')">
              <div class="stage-info">
                <span class="stage-number">6.</span>
                <span class="stage-name">TAF</span>
                <span class="stage-status" v-if="getOfferProcessStatus('taf') === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('taf') === 'Triggered'">
                  <i class="fas fa-play-circle text-info"></i> Triggered
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('taf') === 'Retriggered'">
                  <i class="fas fa-redo text-warning"></i> Retriggered
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Not Triggered
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.taf.status" @change="onStageStatusChange('taf')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Not Triggered">Not Triggered</b-form-radio>
                  <b-form-radio value="Triggered">Triggered</b-form-radio>
                  <b-form-radio value="Retriggered">Retriggered</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('taf')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.taf.comments && offerProcess.taf.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.taf" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.taf.comments[offerProcess.taf.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.taf.comments[offerProcess.taf.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.taf.comments[offerProcess.taf.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.taf.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.taf.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('taf')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.taf ? 'Show Less' : `Show ${offerProcess.taf.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- HAF Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('haf'), 'completed': getOfferProcessStatus('haf') === 'Completed' }" v-if="isStageVisible('haf')">
              <div class="stage-info">
                <span class="stage-number">7.</span>
                <span class="stage-name">HAF</span>
                <span class="stage-status" v-if="getOfferProcessStatus('haf') === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('haf') === 'Triggered'">
                  <i class="fas fa-play-circle text-info"></i> Triggered
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('haf') === 'Retriggered'">
                  <i class="fas fa-redo text-warning"></i> Retriggered
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Not Triggered
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.haf.status" @change="onStageStatusChange('haf')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Not Triggered">Not Triggered</b-form-radio>
                  <b-form-radio value="Triggered">Triggered</b-form-radio>
                  <b-form-radio value="Retriggered">Retriggered</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('haf')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.haf.comments && offerProcess.haf.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.haf" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.haf.comments[offerProcess.haf.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.haf.comments[offerProcess.haf.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.haf.comments[offerProcess.haf.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.haf.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.haf.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('haf')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.haf ? 'Show Less' : `Show ${offerProcess.haf.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- HR Discussion Stage (Always Visible) -->
            <div class="stage-item hr-discussion" :class="{ 'active': true, 'completed': getOfferProcessStatus('hrDiscussion') === 'Completed', 'rejected': getOfferProcessStatus('hrDiscussion') === 'Rejected' }">
              <div class="stage-info">
                <span class="stage-number">8.</span>
                <span class="stage-name">HR Discussion</span>
                
                <span class="stage-status" v-if="getOfferProcessStatus('hrDiscussion') === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('hrDiscussion') === 'Rejected'">
                  <i class="fas fa-times-circle text-danger"></i> Rejected
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('hrDiscussion') === 'Pending'">
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.hrDiscussion.status" @change="onStageStatusChange('hrDiscussion')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                  <b-form-radio value="Rejected">Rejected</b-form-radio>
                </b-form-radio-group>
                <b-form-textarea
                  v-if="offerProcess.hrDiscussion.status === 'Rejected'"
                  v-model="offerProcess.hrDiscussion.comment"
                  placeholder="Reason for rejection"
                  size="sm"
                  rows="2"
                  class="rejection-comment"
                  @input="onStageStatusChange('hrDiscussion')"
                  :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly"
                />
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('hrDiscussion')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.hrDiscussion.comments && offerProcess.hrDiscussion.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.hrDiscussion" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.hrDiscussion.comments[offerProcess.hrDiscussion.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.hrDiscussion.comments[offerProcess.hrDiscussion.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.hrDiscussion.comments[offerProcess.hrDiscussion.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.hrDiscussion.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.hrDiscussion.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('hrDiscussion')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.hrDiscussion ? 'Show Less' : `Show ${offerProcess.hrDiscussion.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Fitment Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('fitment'), 'completed': getOfferProcessStatus('fitment') === 'Completed' }" v-if="isStageVisible('fitment')">
              <div class="stage-info">
                <span class="stage-number">9.</span>
                <span class="stage-name">Fitment</span>
                <span class="stage-status" v-if="getOfferProcessStatus('fitment') === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('fitment') === 'InProcess'">
                  <i class="fas fa-spinner text-info"></i> InProcess
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('fitment') === 'Raised'">
                  <i class="fas fa-arrow-up text-primary"></i> Raised
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('fitment') === 'Pending'">
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.fitment.status" @change="onStageStatusChange('fitment')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Raised">Raised</b-form-radio>
                  <b-form-radio value="InProcess">InProcess</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('fitment')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.fitment.comments && offerProcess.fitment.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.fitment" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.fitment.comments[offerProcess.fitment.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.fitment.comments[offerProcess.fitment.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.fitment.comments[offerProcess.fitment.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.fitment.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.fitment.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('fitment')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.fitment ? 'Show Less' : `Show ${offerProcess.fitment.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- OfferDesk Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('offerDesk'), 'completed': getOfferProcessStatus('offerDesk') === 'Extended' }" v-if="isStageVisible('offerDesk')">
              <div class="stage-info">
                <span class="stage-number">10.</span>
                <span class="stage-name">OfferDesk</span>
                <span class="stage-status" v-if="getOfferProcessStatus('offerDesk') === 'Extended'">
                  <i class="fas fa-check-circle text-success"></i> Extended
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('offerDesk') === 'InProcess'">
                  <i class="fas fa-spinner text-info"></i> InProcess
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('offerDesk') === 'Requested'">
                  <i class="fas fa-hand-paper text-primary"></i> Requested
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('offerDesk') === 'Pending'">
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.offerDesk.status" @change="onStageStatusChange('offerDesk')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Requested">Requested</b-form-radio>
                  <b-form-radio value="InProcess">InProcess</b-form-radio>
                  <b-form-radio value="Extended">Extended</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('offerDesk')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.offerDesk.comments && offerProcess.offerDesk.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.offerDesk" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.offerDesk.comments[offerProcess.offerDesk.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.offerDesk.comments[offerProcess.offerDesk.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.offerDesk.comments[offerProcess.offerDesk.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.offerDesk.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.offerDesk.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('offerDesk')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.offerDesk ? 'Show Less' : `Show ${offerProcess.offerDesk.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- KGS BGV Stage -->
            <div class="stage-item" :class="{ 'active': isStageVisible('kgsBGV'), 'completed': getOfferProcessStatus('kgsBGV') === 'Cleared' }" v-if="isStageVisible('kgsBGV')">
              <div class="stage-info">
                <span class="stage-number">11.</span>
                <span class="stage-name">KGS BGV</span>
                <span class="stage-status" v-if="getOfferProcessStatus('kgsBGV') === 'Cleared'">
                  <i class="fas fa-check-circle text-success"></i> Cleared
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('kgsBGV') === 'Failed'">
                  <i class="fas fa-times-circle text-danger"></i> Failed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('kgsBGV') === 'InProcess With Client'">
                  <i class="fas fa-spinner text-info"></i> InProcess With Client
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('kgsBGV') === 'Pending With Candidate'">
                  <i class="fas fa-user-clock text-warning"></i> Pending With Candidate
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('kgsBGV') === 'Initiated'">
                  <i class="fas fa-play-circle text-primary"></i> Initiated
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.kgsBGV.status" @change="onStageStatusChange('kgsBGV')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Initiated">Initiated</b-form-radio>
                  <b-form-radio value="InProcess With Client">InProcess With Client</b-form-radio>
                  <b-form-radio value="Pending With Candidate">Pending With Candidate</b-form-radio>
                  <b-form-radio value="Cleared">Cleared</b-form-radio>
                  <b-form-radio value="Failed">Failed</b-form-radio>
                </b-form-radio-group>
                
                <!-- Drop Reason for KGS BGV Failure -->
                <div v-if="offerProcess.kgsBGV.status === 'Failed'" class="mt-2">
                  <b-form-group label="Drop Reason *" label-for="kgs-bgv-drop-reason">
                    <v-select
                      v-model="offerProcess.kgsBGV.dropReason"
                      :options="notOfferedOptions"
                      placeholder="Select drop reason"
                      label="title"
                      :reduce="option => option.title"
                      @input="onStageStatusChange('kgsBGV')"
                      :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly"
                    />
                  </b-form-group>
                </div>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('kgsBGV')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.kgsBGV.comments && offerProcess.kgsBGV.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.kgsBGV" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.kgsBGV.comments[offerProcess.kgsBGV.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.kgsBGV.comments[offerProcess.kgsBGV.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.kgsBGV.comments[offerProcess.kgsBGV.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.kgsBGV.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.kgsBGV.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('kgsBGV')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.kgsBGV ? 'Show Less' : `Show ${offerProcess.kgsBGV.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Offer Accepted Stage (New) -->
            <div class="stage-item" :class="{ 'active': isStageVisible('offerAccepted'), 'completed': getOfferProcessStatus('offerAccepted') === 'Yes' || getOfferProcessStatus('offerAccepted') === 'No', 'rejected': getOfferProcessStatus('offerAccepted') === 'No' }" v-if="isStageVisible('offerAccepted')">
              <div class="stage-info">
                <span class="stage-number">12.</span>
                <span class="stage-name">Offer Accepted</span>
                <span class="stage-status" v-if="getOfferProcessStatus('offerAccepted') === 'Yes'">
                  <i class="fas fa-check-circle text-success"></i> Yes
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('offerAccepted') === 'No'">
                  <i class="fas fa-times-circle text-danger"></i> No
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('offerAccepted') === 'Re-release'">
                  <i class="fas fa-redo text-warning"></i> Re-release
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.offerAccepted.status" @change="onStageStatusChange('offerAccepted')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Yes">Yes</b-form-radio>
                  <b-form-radio value="No">No</b-form-radio>
                  <b-form-radio value="Re-release">Re-release</b-form-radio>
                </b-form-radio-group>
                
                <!-- Drop Reason for No -->
                <div v-if="offerProcess.offerAccepted.status === 'No'" class="mt-2">
                  <v-select
                    v-model="offerProcess.offerAccepted.dropReason"
                    :options="offerDropOptions"
                    placeholder="Select drop reason"
                    label="title"
                    :reduce="option => option.title"
                    @input="onStageStatusChange('offerAccepted')"
                    :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly"
                  />
                </div>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('offerAccepted')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.offerAccepted.comments && offerProcess.offerAccepted.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.offerAccepted" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.offerAccepted.comments[offerProcess.offerAccepted.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.offerAccepted.comments[offerProcess.offerAccepted.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.offerAccepted.comments[offerProcess.offerAccepted.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.offerAccepted.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.offerAccepted.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('offerAccepted')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.offerAccepted ? 'Show Less' : `Show ${offerProcess.offerAccepted.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Client BGV Stage (Conditional) -->
            <div class="stage-item" :class="{ 'active': isStageVisible('clientBGV'), 'completed': getOfferProcessStatus('clientBGV') === 'Cleared' }" v-if="isStageVisible('clientBGV')">
              <div class="stage-info">
                <span class="stage-number">13.</span>
                <span class="stage-name">Client BGV</span>
                <span class="stage-status" v-if="getOfferProcessStatus('clientBGV') === 'Cleared'">
                  <i class="fas fa-check-circle text-success"></i> Cleared
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('clientBGV') === 'Failed'">
                  <i class="fas fa-times-circle text-danger"></i> Failed
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('clientBGV') === 'InProcess With Client'">
                  <i class="fas fa-spinner text-info"></i> InProcess With Client
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('clientBGV') === 'Pending With Candidate'">
                  <i class="fas fa-user-clock text-warning"></i> Pending With Candidate
                </span>
                <span class="stage-status" v-else-if="getOfferProcessStatus('clientBGV') === 'Initiated'">
                  <i class="fas fa-play-circle text-primary"></i> Initiated
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group v-model="offerProcess.clientBGV.status" @change="onStageStatusChange('clientBGV')" class="demo-inline-spacing" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Initiated">Initiated</b-form-radio>
                  <b-form-radio value="InProcess With Client">InProcess With Client</b-form-radio>
                  <b-form-radio value="Pending With Candidate">Pending With Candidate</b-form-radio>
                  <b-form-radio value="Cleared">Cleared</b-form-radio>
                  <b-form-radio value="Failed">Failed</b-form-radio>
                </b-form-radio-group>
                
                <!-- Drop Reason for Client BGV Failure -->
                <div v-if="offerProcess.clientBGV.status === 'Failed'" class="mt-2">
                  <b-form-group label="Drop Reason *" label-for="client-bgv-drop-reason">
                    <v-select
                      v-model="offerProcess.clientBGV.dropReason"
                      :options="notOfferedOptions"
                      placeholder="Select drop reason"
                      label="title"
                      :reduce="option => option.title"
                      @input="onStageStatusChange('clientBGV')"
                      :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly"
                    />
                  </b-form-group>
                </div>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openCommentModal('clientBGV')" class="mt-1" :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <!-- Display Comments -->
                <div v-if="offerProcess.clientBGV.comments && offerProcess.clientBGV.comments.length > 0" class="comments-list mt-2">
                  <!-- Show last comment by default -->
                  <div v-if="!showAllComments.clientBGV" class="comment-item">
                    <small class="text-muted">{{ new Date(offerProcess.clientBGV.comments[offerProcess.clientBGV.comments.length - 1].timestamp).toLocaleString() }} - {{ offerProcess.clientBGV.comments[offerProcess.clientBGV.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ offerProcess.clientBGV.comments[offerProcess.clientBGV.comments.length - 1].text }}</div>
                  </div>
                  
                  <!-- Show all comments when expanded -->
                  <div v-else>
                    <div v-for="comment in offerProcess.clientBGV.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  
                  <!-- Show More/Less button if there are multiple comments -->
                  <div v-if="offerProcess.clientBGV.comments.length > 1" class="mt-2">
                    <b-button 
                      size="sm" 
                      variant="link" 
                      @click="toggleComments('clientBGV')"
                      class="p-0 text-primary"
                    >
                      {{ showAllComments.clientBGV ? 'Show Less' : `Show ${offerProcess.clientBGV.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Footer with information about OK button -->
        <template #modal-footer>
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-center">
              <div class="small text-warning">
                <i class="fas fa-info-circle mr-1"></i>
                <strong>Note:</strong> All stage changes will be saved only when you click "Submit Offer Process" button.
              </div>
              <div>
                <b-button variant="outline-secondary" @click="$bvModal.hide('modal-kpmg-offer-process')">
                  Cancel
                </b-button>
                <b-button 
                  variant="primary" 
                  @click="saveKPMGOfferProcess"
                  :disabled="!isPOCForKPMGOfferProcess || isKPMGOfferProcessReadOnly"
                  class="ml-2"
                >
                  <i class="fas fa-save mr-1"></i>
                  Submit Offer Process
                </b-button>
            </div>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- Reliance RPO Offer Process Modal -->
      <b-modal
        id="modal-reliance-rpo-offer-process"
        ref="modal-reliance-rpo-offer-process"
        :title="isRelianceOfferProcessReadOnly ? 'Reliance RPO Offer Process (Read Only)' : 'Reliance RPO Offer Process'"
        size="lg"
        no-close-on-backdrop
      >
        <div class="reliance-offer-process-container">
          <!-- Access Control Notice -->
          <div v-if="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly" class="access-notice mb-3 p-3 bg-warning text-dark rounded">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            <strong v-if="isRelianceOfferProcessReadOnly">Read Only Mode:</strong>
            <strong v-else>View Only Mode:</strong>
            <span v-if="isRelianceOfferProcessReadOnly">
              This candidate is in {{ candidateJobData.candidateStatus }} status. You can view the Reliance RPO Offer Process details, but no changes can be made.
            </span>
            <span v-else>
              You can view the Reliance RPO Offer Process details, but you don't have permission to make changes.
            </span>
          </div>
          
          <!-- Progress Bar -->
          <div class="progress-section mb-4">
            <div class="progress-info">
              <span class="progress-text">Progress: {{ relianceCompletedStagesCount }}/{{ relianceTotalStagesCount }} stages completed ({{ relianceProgressPercentage }}%)</span>
              <div v-if="!isRelianceOfferProcessCompleted" class="completion-notice">
                <i class="fas fa-info-circle text-info"></i>
                Complete all stages to finalize the offer process
              </div>
              <div v-else class="completion-notice">
                <i class="fas fa-check-circle text-success"></i>
                All stages completed!
              </div>
            </div>
            <div class="progress">
              <div 
                class="progress-bar bg-success" 
                :style="{ width: relianceProgressPercentage + '%' }"
                role="progressbar"
              ></div>
            </div>
          </div>

          <!-- Stages List -->
          <div class="stages-list">
            <!-- Stage 1: Documentation -->
            <div class="stage-item" :class="{ 'completed': relianceOfferProcess.documentation.status === 'Completed' }">
              <div class="stage-info">
                <span class="stage-number">1.</span>
                <span class="stage-name">Documentation</span>
                <span class="stage-status" v-if="relianceOfferProcess.documentation.status === 'Completed'">
                  <i class="fas fa-check-circle text-success"></i> Completed
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group 
                  v-model="relianceOfferProcess.documentation.status" 
                  @change="onRelianceStageStatusChange('documentation')" 
                  class="demo-inline-spacing" 
                  :disabled="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly"
                >
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Completed">Completed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openRelianceCommentModal('documentation')" class="mt-1" :disabled="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <div v-if="relianceOfferProcess.documentation.comments && relianceOfferProcess.documentation.comments.length > 0" class="comments-list mt-2">
                  <div v-if="!showAllRelianceComments.documentation" class="comment-item">
                    <small class="text-muted">{{ new Date(relianceOfferProcess.documentation.comments[relianceOfferProcess.documentation.comments.length - 1].timestamp).toLocaleString() }} - {{ relianceOfferProcess.documentation.comments[relianceOfferProcess.documentation.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ relianceOfferProcess.documentation.comments[relianceOfferProcess.documentation.comments.length - 1].text }}</div>
                  </div>
                  <div v-else>
                    <div v-for="comment in relianceOfferProcess.documentation.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  <div v-if="relianceOfferProcess.documentation.comments.length > 1" class="mt-2">
                    <b-button size="sm" variant="link" @click="toggleRelianceComments('documentation')" class="p-0 text-primary">
                      {{ showAllRelianceComments.documentation ? 'Show Less' : `Show ${relianceOfferProcess.documentation.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-3">

            <!-- Stage 2: Confirmation -->
            <div class="stage-item" :class="{ 'completed': relianceOfferProcess.confirmation.status === 'Confirmed' }">
              <div class="stage-info">
                <span class="stage-number">2.</span>
                <span class="stage-name">Confirmation</span>
                <span class="stage-status" v-if="relianceOfferProcess.confirmation.status === 'Confirmed'">
                  <i class="fas fa-check-circle text-success"></i> Confirmed
                </span>
                <span class="stage-status" v-else-if="relianceOfferProcess.confirmation.status === 'Not Confirmed'">
                  <i class="fas fa-times-circle text-danger"></i> Not Confirmed
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group 
                  v-model="relianceOfferProcess.confirmation.status" 
                  @change="onRelianceStageStatusChange('confirmation')" 
                  class="demo-inline-spacing" 
                  :disabled="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly"
                >
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Confirmed">Confirmed</b-form-radio>
                  <b-form-radio value="Not Confirmed">Not Confirmed</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openRelianceCommentModal('confirmation')" class="mt-1" :disabled="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <div v-if="relianceOfferProcess.confirmation.comments && relianceOfferProcess.confirmation.comments.length > 0" class="comments-list mt-2">
                  <div v-if="!showAllRelianceComments.confirmation" class="comment-item">
                    <small class="text-muted">{{ new Date(relianceOfferProcess.confirmation.comments[relianceOfferProcess.confirmation.comments.length - 1].timestamp).toLocaleString() }} - {{ relianceOfferProcess.confirmation.comments[relianceOfferProcess.confirmation.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ relianceOfferProcess.confirmation.comments[relianceOfferProcess.confirmation.comments.length - 1].text }}</div>
                  </div>
                  <div v-else>
                    <div v-for="comment in relianceOfferProcess.confirmation.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  <div v-if="relianceOfferProcess.confirmation.comments.length > 1" class="mt-2">
                    <b-button size="sm" variant="link" @click="toggleRelianceComments('confirmation')" class="p-0 text-primary">
                      {{ showAllRelianceComments.confirmation ? 'Show Less' : `Show ${relianceOfferProcess.confirmation.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-3">

            <!-- Stage 3: Medical -->
            <div class="stage-item" :class="{ 'completed': relianceOfferProcess.medical.status === 'Fit' }">
              <div class="stage-info">
                <span class="stage-number">3.</span>
                <span class="stage-name">Medical</span>
                <span class="stage-status" v-if="relianceOfferProcess.medical.status === 'Fit'">
                  <i class="fas fa-check-circle text-success"></i> Fit
                </span>
                <span class="stage-status" v-else-if="relianceOfferProcess.medical.status === 'Unfit'">
                  <i class="fas fa-times-circle text-danger"></i> Unfit
                </span>
                <span class="stage-status" v-else>
                  <i class="fas fa-clock text-warning"></i> Pending
                </span>
              </div>
              <div class="stage-actions">
                <b-form-radio-group 
                  v-model="relianceOfferProcess.medical.status" 
                  @change="onRelianceStageStatusChange('medical')" 
                  class="demo-inline-spacing" 
                  :disabled="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly"
                >
                  <b-form-radio value="Pending">Pending</b-form-radio>
                  <b-form-radio value="Fit">Fit</b-form-radio>
                  <b-form-radio value="Unfit">Unfit</b-form-radio>
                </b-form-radio-group>
              </div>
              <!-- Comments Section -->
              <div class="comments-section mt-2">
                <b-button size="sm" variant="outline-primary" @click="openRelianceCommentModal('medical')" class="mt-1" :disabled="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly">
                  <i class="fas fa-comment"></i> Add Comment
                </b-button>
                <div v-if="relianceOfferProcess.medical.comments && relianceOfferProcess.medical.comments.length > 0" class="comments-list mt-2">
                  <div v-if="!showAllRelianceComments.medical" class="comment-item">
                    <small class="text-muted">{{ new Date(relianceOfferProcess.medical.comments[relianceOfferProcess.medical.comments.length - 1].timestamp).toLocaleString() }} - {{ relianceOfferProcess.medical.comments[relianceOfferProcess.medical.comments.length - 1].user }}</small>
                    <div class="comment-text">{{ relianceOfferProcess.medical.comments[relianceOfferProcess.medical.comments.length - 1].text }}</div>
                  </div>
                  <div v-else>
                    <div v-for="comment in relianceOfferProcess.medical.comments" :key="comment.id" class="comment-item">
                      <small class="text-muted">{{ new Date(comment.timestamp).toLocaleString() }} - {{ comment.user }}</small>
                      <div class="comment-text">{{ comment.text }}</div>
                    </div>
                  </div>
                  <div v-if="relianceOfferProcess.medical.comments.length > 1" class="mt-2">
                    <b-button size="sm" variant="link" @click="toggleRelianceComments('medical')" class="p-0 text-primary">
                      {{ showAllRelianceComments.medical ? 'Show Less' : `Show ${relianceOfferProcess.medical.comments.length - 1} More Comments` }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        
        <template #modal-footer>
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-center">
              <div class="small text-warning">
                <i class="fas fa-info-circle mr-1"></i>
                <strong>Note:</strong> All stage changes will be saved only when you click "Submit Offer Process" button.
              </div>
              <div>
                <b-button variant="outline-secondary" @click="$bvModal.hide('modal-reliance-rpo-offer-process')">
                  Cancel
                </b-button>
                <b-button 
                  variant="primary" 
                  @click="saveRelianceOfferProcess"
                  :disabled="!isPOCForRelianceOfferProcess || isRelianceOfferProcessReadOnly"
                  class="ml-2"
                >
                  <i class="fas fa-save mr-1"></i>
                  Submit Offer Process
                </b-button>
            </div>
            </div>
          </div>
        </template>
      </b-modal>
      
    </div>
    <div v-if="pdf && canShowResume">
      <iframe :src="blink" frameborder="0" height="1200px" width="100%"></iframe>
    </div>
    <div v-if="(docx || doc) && canShowResume">
      <a class="font-weight-bolder" :href="mlink" target="_blank" v-if="docx || doc"> Preview CV</a>
      <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
    </div>
    <div v-if="rtf && canShowResume">
      <iframe :src="glink" frameborder="0" height="1200px" width="100%"></iframe>
    </div>
    <div v-if="otherDoc && canShowResume">
      <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
    </div>
    <div>
      <!-- <b-row>
        <b-col cols="6" xl="6" md="6">
          <iframe :src="blink" frameborder="0" height="800px" width="100%"></iframe>    
        </b-col>
        <b-col cols="6" xl="6" md="6">
          <iframe :src="glink" frameborder="0" height="800px" width="100%"></iframe>
        </b-col>
      </b-row> -->
    </div>
    
    <!-- Comment Modal -->
    <b-modal
      id="comment-modal"
      ref="comment-modal"
      :title="`Add Comment - ${currentCommentStage ? currentCommentStage.charAt(0).toUpperCase() + currentCommentStage.slice(1) : 'Stage'}`"
      size="md"
      @ok="saveComment"
      @hidden="currentCommentText = ''"
    >
      <b-form-group label="Comment" label-for="comment-textarea">
        <b-form-textarea
          id="comment-textarea"
          v-model="currentCommentText"
          placeholder="Enter your comment here..."
          rows="4"
          max-rows="6"
          required
        />
      </b-form-group>
    </b-modal>
    
    
    
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "vue";
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BCard,
  BModal,
  BBadge,
  BForm,
  BFormGroup,
  BButton,
  BFormTextarea,
  BFormInput,
  BAvatar,
  BAvatarGroup,
  VBTooltip,
  BFormFile,
  BCardText,
  BFormCheckbox,
  BSpinner,
  BFormRadioGroup,
  BFormRadio
} from "bootstrap-vue";
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
  import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import moment from "moment";
import vSelect from 'vue-select'
// import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import Ripple from "vue-ripple-directive";
import flatPickr from 'vue-flatpickr-component'
//import candidateStoreModule from "../candidateStoreModule";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import JobService from "@/services/job-service";
import CandidateService from "@/services/candidate-service";
import jobTimelineService from "@/services/job-timeline";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import emailTemplates from "@/services/email-templates";
import mailService from "@/services/mail-service"
import UserService from "@/services/user-service"
import { quillEditor } from 'vue-quill-editor'
import adminConfigService from "@/services/admin-config-service";
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver';
import { email } from 'vee-validate/dist/rules';
import candidateService from "@/services/candidate-service";
import exotelService from "@/services/exotel-service";
import { allowedNextStatusOptions } from "@/utils/candidate-status-flow";
import { getExotelCallErrorMessage } from "@/utils/exotel-call-helpers";
// import VueDocPreview from 'vue-doc-preview'



export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._backRoute = from.path
      //console.log("from", from.path)
    })
  },
  data() {
    return {
      pausedFor7Seconds: false,
      cStatusOption: [
        
      ],
      // cStatusOptionSourcer: [
      
      // ],
      NotInterestedReason: [
        { title: "Not Looking for Change"},
        { title: "Not ok with the Client/Company"},
        { title: "Not ok with Location"},
        { title: "Not ok with Shift"},
        { title: "Not ok with Compensation"},
        { title: "Not ok with Designation/Role"},
        { title: "Recently Changed"},
        { title: "Already Interviewed/Duplicate"},
        { title: "Already working with Organization"},
        { title: "Re-Hire"},
        { title: "Ex-Employee"},
        { title: "Other"},
      ],
      NotAnsweredOptions: [
        { title: 'Not Answered'},
        { title: 'Not Reachable'},
        { title: 'Wrong Number'},
        { title: 'Call Back'}
      ],
      DuplicateOptions: [
        { title: 'Other Vendor Source Lock'},
        { title: 'Profile in Cooling Period'},
      ],
      coolingTimelineOptions: [
        { title: '0', value: 0},
        { title: '1 Month', value: 30},
        { title: '2 Months', value: 60},
        { title: '3 Months', value: 90},
        { title: '4 Months', value: 120},
        { title: '5 Months', value: 150},
        { title: '6 Months', value: 180},
      ],
      dupReasonSelected: null,
      coolingTimeline: null,
      NI_NR_comment : '',
      statusSelected: "",
      prevStatus: '',
      statusCSelected: "",
      error_status: "",
      jobId: '',
      userRole: '',
      emp_id: '',
      breadcrumb: [],
      recruiters: [],
      candidateData: null,
      glink: '',
      dlink: '',
      updateButton: true,
      jobBySourcer: '',
      intNotIntNotRelVisible: '',
      updateButtonVisible: '',
      position_name: '',
      locations: '',
      client: '',
      rec_name: '',
      attachments: '',
      sourcer_name: '',
      am_name: '',
      NI_Reason_Selected: '',
      NI_NR_comment: '',
      error_NI_NR_comment: '',
      NI: true,
      NA_comment: '',
      NA_Reason_Selected: '',
      error_NA_comment: '',
      blink: '',
      pdf: false,
      docx: false,
      rtf: false,
      doc: false,
      otherDoc: false,
      mlink: '',
      jobCode: '',
      selectionDate: null,
      offeredDate: null,
      joiningDate: null,
      attritionDate: null,
      
      // Interview Process for Reliance RPO
      interviewRounds: 1,
      interviewProcess: {
        rounds: 1,
        round_results: {}
      },
      interviewRoundOptions: [
        { value: 1, text: '1 Round' },
        { value: 2, text: '2 Rounds' },
        { value: 3, text: '3 Rounds' },
        { value: 4, text: '4 Rounds' },
        { value: 5, text: '5 Rounds' }
      ],
      interviewTimelineMessage: null, // Custom timeline message for interview process updates
      error: '',
      isValid: true,
      allUsers: [],
      sourcer: '',
      recruiter: '',
      loadingAadhaar: false,  // Keep for backward compatibility
      loadingAadhaarFront: false,
      loadingAadhaarBack: false,
      loadingPan: false,
      loadingPhoto: false,
      loadingBankDoc: false,
      loadingCertificate: false,
      candidateJobs: [],
      candidateTimelineEvents: [],
      expandedTimelineRuns: {},
      showAllTimelineUpdates: {},
      timelineRunPreviewLimit: 3,
      timelineExpanded: false,
      timelineOverflows: false,
      candidateJobData: {},
      jobData: {},
      offeredCTC: null,
      dropReason: '',
      notOfferedOptions: [
        {title: 'BGV Failed'},
        {title: 'Documentation Issue'},
        {title: 'CTC Issue'},
        {title: 'Notice Period Issue'},
        {title: 'Location Issue'},
        {title: 'Designation Issue'},
        {title: 'Position Closed'},
        {title: 'Position On-Hold'}
      ],
      offerDropOptions: [
        {title: 'Got Another Offer'},
        {title: 'Retained By Current Organization'},
        {title: 'CTC Issue'},
        {title: 'Notice Period Issue'},
        {title: 'Location Issue'},
        {title: 'Designation Issue'},
        {title: 'BGV/Documentation Issue'},
      ],
      savedPosition: 0,
      flatpickrConfig: {
        maxDate: "today"
      },
      jobPage: null,
      variableCTC: null,
      // band: null ,
      positionType: '',
      payroll: '',
      category: '',
      vertical: '',
      blueCollar: false,
      cvPresent: true,
      documents: {
        aadhaarCard: null,  // Keep for backward compatibility
        aadhaarCardFront: null,
        aadhaarCardBack: null,
        panCard: null,
        passportPhoto: null,
        bankProof: null,
        skillCertificate: null
      },
      aadhaarUploaded: false,  // Keep for backward compatibility
      aadhaarFrontUploaded: false,
      aadhaarBackUploaded: false,
      panUploaded: false,
      photoUploaded: false,
      certificateUploaded: false,
      bankUploaded: false,
      showAadhaarUpload: true,  // Keep for backward compatibility
      showAadhaarFrontUpload: true,
      showAadhaarBackUpload: true,
      showPanUpload: true,
      showPhotoUpload: true,
      showCertificateUpload: true,
      showBankUpload: true,
      file: '',
      canDocLink: null,
      showCandidateDetails: true,
      // aadhaarLink: null,
      // panLink: null,
      // photoLink: null,
      // skillCertificateLink: null,
      // bankProofLink: null
      skillCertificateAvailable: true,
      contractStartDate: null,
      contractEndDate: null,
      rateCard: null,
      monthlyCTC: null,
      probationDays: null,
      today: null,
      daysDifference: null,
      offerLetterContent: null,
      offerDetails: null,
      // blueCollar: false
      snowOption: {
        theme: 'snow',
      },
      projectLocationOptions: [],
      projectOptions: [],
      projectStateOptions: [],
      candidateMetadata: {
        emp_id: null,
        name: null,
        contact_no: null,
        email: null,
        fatherName: null,
        gender: null,
        dob: null,
        panNumber: null,
        uanNumber: null,
        doj: null,
        offeredDate: null,
        annualCTC: null,
        title: null,
        address: null,
        emergencyContactNo: null,
        emergencyContactName: null,
        references: null,
        bankName: null,
        accountNumber: null,
        ifscCode: null,
        projectName: null,
        projectLocation: null,
        projectState: null,
        // esicNumber: null,
      },
      // Call-related data
      isCallInProgress: false,
      callStatus: null,
      lastCallSid: null,
      exotelConfig: null,
      canMakeCall: false,
      metadataDownload: [],
      whiteCollarInfra: false,
      duplicateMailAlert: false,
      isDuplicate: false,
      notes: [
        // Add some sample notes for testing
        {
          content: "Initial screening completed. Candidate shows strong potential.",
          addedBy: "John Doe",
          addedOn: new Date(2024, 1, 15).toISOString()
        },
        {
          content: "Technical assessment scheduled for next week.",
          addedBy: "Jane Smith",
          addedOn: new Date(2024, 1, 14).toISOString()
        },
        {
          content: "Reference check completed successfully.",
          addedBy: "Mike Johnson",
          addedOn: new Date(2024, 1, 13).toISOString()
        }
      ],
      newNote: '',
      showAllNotes: false,
      showNoteInput: false, // New property to control note input visibility
      
      // Payroll Modal Data
      payrollForm: {
        project: null,
        location: null,
        joiningDate: null,
        offeredGross: null,  
        accountNumberChecked: false,
        ifscCodeChecked: false,
        panNumberChecked: false,
        offerLetter: null,
        salaryModel: null,
        benefitsIncluded: [],
        submitting: false,
        reenterAccountNumber: '',
        accountNumberMismatch: false,
        reenterIfscCode: '',
        ifscCodeMismatch: false,
        reenterPanNumber: '',
        panNumberMismatch: false
      },
      locationOptions: [
        { title: 'Mumbai', value: 'Mumbai' },
        { title: 'Delhi', value: 'Delhi' },
        { title: 'Bangalore', value: 'Bangalore' },
        { title: 'Chennai', value: 'Chennai' },
        { title: 'Hyderabad', value: 'Hyderabad' },
        { title: 'Pune', value: 'Pune' }
      ],
      salaryModelOptions: [
        { title: 'Per Meter', value: 'perMeter' },
        { title: 'Pro Rata', value: 'proRata' },
        { title: 'Fixed Salary', value: 'fixed' }
      ],
      benefitsOptions: [
        { title: 'PF (Provident Fund)', value: 'pf' },
        { title: 'ESIC (Employee State Insurance)', value: 'esic' }
      ],
      
      // KPMG RPO Offer Process Data
      isKPMGOfferProcessUpdate: false,
      isKPMGBGVProcessUpdate: false,
      offerProcess: {
          // business: { 
          //   selected: null,
          //   createdAt: null,
          //   updatedAt: null,
          //   createdBy: null,
          //   updatedBy: null
          // },
          // pocs: { 
          //   selected: null,
          //   createdAt: null,
          //   updatedAt: null,
          //   createdBy: null,
          //   updatedBy: null
          // },
          tagging: { 
            status: 'Pending', 
            reqId: '',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          earlyKgsBGV: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          jobApplication: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          caf: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          documentation: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          taf: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          haf: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          hrDiscussion: { 
            status: 'Pending', 
            comment: '',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          fitment: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          offerDesk: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          kgsBGV: { 
            status: 'Pending',
            dropReason: '',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          offerAccepted: { 
            status: 'Pending',
            dropReason: '',
            clientBGVRequired: null, // null = not decided, true = required, false = not required
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          clientBGV: { 
            status: 'Pending',
            dropReason: '',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          },
          bgv: { 
            status: 'Pending',
            comments: [],
            createdAt: null,
            updatedAt: null,
            createdBy: null,
            updatedBy: null
          }
        },
      
      // KPMG RPO Stage Options
      kpmgStageOptions: {
        tagging: [
          { value: 'Tagged', text: 'Tagged' },
          { value: 'Pending', text: 'Pending' }
        ],
        earlyKgsBGV: [
          { value: 'Pending', text: 'Pending' },
          { value: 'Initiated', text: 'Initiated' },
          { value: 'InProcess With Client', text: 'InProcess With Client' },
          { value: 'Pending With Candidate', text: 'Pending With Candidate' },
          { value: 'Cleared', text: 'Cleared' },
          { value: 'Failed', text: 'Failed' }
        ],
        jobApplication: [
          { value: 'Not Triggered', text: 'Not Triggered' },
          { value: 'Triggered', text: 'Triggered' },
          { value: 'Retriggered', text: 'Retriggered' },
          { value: 'Completed', text: 'Completed' }
        ],
        caf: [
          { value: 'Not Triggered', text: 'Not Triggered' },
          { value: 'Triggered', text: 'Triggered' },
          { value: 'Retriggered', text: 'Retriggered' },
          { value: 'Completed', text: 'Completed' }
        ],
        documentation: [
          { value: 'Not Triggered', text: 'Not Triggered' },
          { value: 'Triggered', text: 'Triggered' },
          { value: 'Retriggered', text: 'Retriggered' },
          { value: 'Completed', text: 'Completed' }
        ],
        taf: [
          { value: 'Not Triggered', text: 'Not Triggered' },
          { value: 'Triggered', text: 'Triggered' },
          { value: 'Retriggered', text: 'Retriggered' },
          { value: 'Completed', text: 'Completed' }
        ],
        haf: [
          { value: 'Not Triggered', text: 'Not Triggered' },
          { value: 'Triggered', text: 'Triggered' },
          { value: 'Retriggered', text: 'Retriggered' },
          { value: 'Completed', text: 'Completed' }
        ],
        hrDiscussion: [
          { value: 'Completed', text: 'Completed' },
          { value: 'Rejected', text: 'Rejected' },
          { value: 'Pending', text: 'Pending' }
        ],
        fitment: [
          { value: 'Raised', text: 'Raised' },
          { value: 'InProcess', text: 'InProcess' },
          { value: 'Completed', text: 'Completed' },
          { value: 'Pending', text: 'Pending' }
        ],
        offerDesk: [
          { value: 'Requested', text: 'Requested' },
          { value: 'InProcess', text: 'InProcess' },
          { value: 'Extended', text: 'Extended' },
          { value: 'Pending', text: 'Pending' }
        ],
        kgsBGV: [
          { value: 'Initiated', text: 'Initiated' },
          { value: 'InProcess With Client', text: 'InProcess With Client' },
          { value: 'Pending With Candidate', text: 'Pending With Candidate' },
          { value: 'Cleared', text: 'Cleared' },
          { value: 'Failed', text: 'Failed' },
          { value: 'Pending', text: 'Pending' }
        ],
        offerAccepted: [
          { value: 'Pending', text: 'Pending' },
          { value: 'Yes', text: 'Yes' },
          { value: 'No', text: 'No' },
          { value: 'Re-release', text: 'Re-release' }
        ],
        clientBGV: [
          { value: 'Initiated', text: 'Initiated' },
          { value: 'InProcess With Client', text: 'InProcess With Client' },
          { value: 'Pending With Candidate', text: 'Pending With Candidate' },
          { value: 'Cleared', text: 'Cleared' },
          { value: 'Failed', text: 'Failed' },
          { value: 'Pending', text: 'Pending' }
        ],
        bgv: [
          { value: 'Initiated', text: 'Initiated' },
          { value: 'InProcess With Client', text: 'InProcess With Client' },
          { value: 'Pending With Candidate', text: 'Pending With Candidate' },
          { value: 'Cleared', text: 'Cleared' },
          { value: 'Failed', text: 'Failed' },
          { value: 'Pending', text: 'Pending' }
        ]
      },
      
              // Business and POC Options
        businessOptions: [],
        pocOptions: [],
        
        // Comment Modal
        currentCommentStage: null,
        currentCommentText: '',
        currentCommentType: null, // 'kpmg' or 'reliance'
        
        // Comment visibility tracking
        showAllComments: {
          tagging: false,
          earlyKgsBGV: false,
          jobApplication: false,
          caf: false,
          documentation: false,
          taf: false,
          haf: false,
          hrDiscussion: false,
          fitment: false,
          offerDesk: false,
          kgsBGV: false,
          offerAccepted: false,
          clientBGV: false,
          bgv: false
        },
      
      // Reliance RPO Offer Process Data
      relianceOfferProcess: {
        documentation: { 
          status: 'Pending', 
          comments: [],
          createdAt: null,
          updatedAt: null,
          createdBy: null,
          updatedBy: null
        },
        confirmation: { 
          status: 'Pending', 
          comments: [],
          createdAt: null,
          updatedAt: null,
          createdBy: null,
          updatedBy: null
        },
        medical: { 
          status: 'Pending', 
          comments: [],
          createdAt: null,
          updatedAt: null,
          createdBy: null,
          updatedBy: null
        }
      },
      showAllRelianceComments: {
        documentation: false,
        confirmation: false,
        medical: false
      },
      downloadingAllDocuments: false,
      downloadingAllDocumentsText: 'Download All Documents',
      payrollApprovalStatus: null,
      panNumberFormatError: false,
      panNumberMismatchError: false,
      reenterPanNumberFormatError: false,
      panNumbersMatch: false,
      reenterPanNumber: '',
      uanNumberFormatError: false,
      uanNumberMismatchError: false,
      reenterUanNumberFormatError: false,
      uanNumbersMatch: false,
      reenterUanNumber: '',
      accountNumberFormatError: false,
      accountNumberMismatchError: false,
      reenterAccountNumberFormatError: false,
      accountNumbersMatch: false,
      ifscCodeFormatError: false,
      ifscCodeMismatchError: false,
      reenterIfscCodeFormatError: false,
      ifscCodesMatch: false,
      reenterIfscCode: '',
      reenterAccountNumber: '',
      reenterReenterAccountNumber: '',
      reenterReenterIfscCode: ''
    };
  },
  directives: {
     'b-tooltip': VBTooltip, Ripple
  },
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BCardActions,
    BCard,
    BModal,
    BBadge,
    BForm,
    BFormGroup,
    AppTimeline,
    AppTimelineItem,
    BButton,
    vSelect,
    BFormTextarea,
    ToastificationContent,
    // VueDocPreview,
    flatPickr,
    BAvatar,
    BFormInput,
    BFormFile,
    BCardText,
    BFormCheckbox,
    quillEditor,
    BSpinner,
    AppCollapse,
    AppCollapseItem,
    BFormRadioGroup,
    BFormRadio
    // VBTooltip

  },
  /*computed: {
    candidateId() {
      return `SHC-${( parseInt(this.cid) + 1000)}`
    }
  },*/
  created() {
    console.log('Environment:', process.env.NODE_ENV, window.location.href)
    // UserService.getAllUsersDdActiveInactive().then(res => {
    //   //console.log(res)
    //   this.allUsers = res.data
    // })
    // const scrollPosition = localStorage.getItem('lastPosition')
    //   //console.log('called',JSON.stringify(scrollPosition))
    //   //console.log('last position', JSON.parse(scrollPosition).y  )
    // this.savedPosition = JSON.parse(JSON.stringify(localStorage.getItem('lastPosition'))).y 

    this.id = this.$route.params.id
    this.jobId = this.$route.params.jobId
    if (this.$route.query) {
      this.position_name = this.$route.query.position_name
      this.locations = this.$route.query.locations
      this.client = this.$route.query.client
      this.recruiter = this.$route.query.recruiter
      this.attachments = this.$route.query.attachments
      this.sourcer = this.$route.query.sourcer
      this.am_name = this.$route.query.am_name
      this.jobCode = this.$route.query.job_id
      this.jobPage = this.$route.query.page
      this.positionType = this.$route.query.position_type || this.$route.query.positionType
      this.category = this.$route.query.category
      this.payroll = this.$route.query.payroll
      this.vertical = this.$route.query.vertical
    }
    console.log('route query: ', this.positionType, this.category, this.vertical, this.payroll)
    if(this.positionType === 'Contractual' && this.category === 'Blue Collar' && this.payroll === 'Sattva Payroll' && this.vertical === 'Infra Industry') {
      this.blueCollar = true
      console.log('job type blue collar: ', this.blueCollar)
    }
    if(this.positionType === 'Contractual' && this.category === 'White Collar' && this.payroll === 'Sattva Payroll' && this.vertical === 'Infra Industry') {
      this.whiteCollarInfra = true
      console.log('job type blue collar: ', this.whiteCollarInfra)
    }
    //console.log(this.jobId, this.id, this.$route.query)
    this.getCandidateData()
    this.today = new Date().getDate()

    //console.log('hiring details', this.recruiter, this.sourcer, this.am_name)
    
    // UserService.getAllUsersDdActiveInactive().then(res => {
    //   this.recruiters = res.data
    //   console.log('recruiters',this.recruiters)
    // })
    UserService.getAllRecruitersList().then(res => {
      this.recruiters = res.data
      console.log('recruiters list',this.recruiters)
      const userData = JSON.parse(localStorage.getItem("userData"));
      const userMgr = this.recruiters.filter(item => item.emp_id === userData.mgr_id)
      const p_mgr_id = userMgr[0].manager
      console.log('Manager Detail:', userMgr, p_mgr_id)
    })
    this.jobId = this.jobId !== 'null' ? this.jobId : null
          console.log('jobId in candidate view new', this.jobId, this.id)
      if(this.jobId) {
        CandidateService.getCandidateCurrentStatus(this.id, this.jobId).then( res => {
        console.log('candidate Status prev status', res)
        if (res.status === 'OK' && res.data && res.data.length > 0) {

          this.prevStatus = res.data[0].candidateStatus
          
          this.computeStatusOption()
        } else {
          console.log('No candidate status data found or empty array')
          this.prevStatus = null
        }
      })
    }
    

    
    this.userRole = JSON.parse(localStorage.getItem('userData')).roles[0]
    console.log('Current user Role: ', this.userRole)
    this.emp_id = JSON.parse(localStorage.getItem('userData')).emp_id
    console.log('job type blue collar: ', this.blueCollar)
    
  },
    
  watch: {
    prevStatus: function(newStatus) {
      
      // if(this.positionType === 'Contractual' && this.category === 'Blue Collar' && this.payroll === 'Sattva Payroll' && this.vertical === 'Infra Industry') {
      //   this.blueCollar = true
      //   console.log('job type blue collar: ', this.blueCollar)
      // }
      this.computeStatusOption()
    },
    // 'aadhaarUploaded': 'computeDocumentDone',
    // 'panUploaded': 'computeDocumentDone',
    // 'photoUploaded': 'computeDocumentDone',
    // 'certificateUploaded': 'computeDocumentDone',
    // 'bankUploaded': 'computeDocumentDone'
    'payrollForm.reenterAccountNumber': function(newValue) {
      this.payrollForm.accountNumberMismatch = newValue !== '' && newValue !== this.candidateMetadata.accountNumber;
    },
    'payrollForm.reenterIfscCode': function(newValue) {
      this.payrollForm.ifscCodeMismatch = newValue !== '' && newValue !== this.candidateMetadata.ifscCode;
    },
    'payrollForm.reenterPanNumber': function(newValue) {
      this.payrollForm.panNumberMismatch = newValue !== '' && newValue !== this.candidateMetadata.panNumber;
    },
    interviewRounds(val) {
      const numVal = Number(val);
      if (this.interviewProcess && !isNaN(numVal) && numVal >= 1) {
        this.interviewProcess.rounds = numVal;
        if (this.client !== 'Reliance RPO') return;
        const lastRoundKey = 'round' + numVal;
        const lastRoundData = this.interviewProcess.round_results?.[lastRoundKey];
        const lastStatus = lastRoundData && typeof lastRoundData === 'object' ? lastRoundData.status : null;
        const lastRoundComplete = (lastStatus === 'select' || lastStatus === 'final_select');
        if (this.statusCSelected === 'Selected' && !lastRoundComplete) {
          this.statusCSelected = 'Interview';
          this.$nextTick(() => {
            this.selectCStatus('Interview');
          });
        } else if (this.statusCSelected === 'Interview' && lastRoundComplete) {
          this.statusCSelected = 'Selected';
          this.$nextTick(() => {
            this.selectCStatus('Selected');
          });
        }
      }
    }
  },
  methods: {
    /**
     * Load Exotel configuration and check if user can make calls
     */
    async loadExotelConfig() {
      try {
        console.log('Loading Exotel config')
        const response = await adminConfigService.getExotelConfig();
        console.log('response exotel config', response)
        if (response && response.status === 'OK') {
          // The exotelConfig is now an array of objects with emp_id and callerId
          this.exotelConfig = response.data;
          console.log('Exotel config', this.exotelConfig)
          
          // Check if current user's emp_id is in the allowed list
          const currentUserEmpId = JSON.parse(localStorage.getItem('userData'))?.emp_id;
          console.log('currentUserEmpId', currentUserEmpId)
          
          // Check if user has permission to make calls
          const hasExotelPermission = this.exotelConfig.some(config => 
            config.emp_id === currentUserEmpId
          );
          const hasCreatePermission = this.$can('create', 'exotel_call');
          
          this.canMakeCall = hasExotelPermission || hasCreatePermission;
          
          console.log('Exotel config loaded:', this.exotelConfig);
          console.log('Has Exotel permission:', hasExotelPermission);
          console.log('Has create permission:', hasCreatePermission);
          console.log('Can make call:', this.canMakeCall);
        }
      } catch (error) {
        console.error('Error loading Exotel config:', error);
        this.canMakeCall = false;
      }
    },

    /**
     * Get caller ID for current user from Exotel config
     */
    getCallerIdForCurrentUser() {
      if (!this.exotelConfig) return null;
      
      const currentUserEmpId = JSON.parse(localStorage.getItem('userData'))?.emp_id;
      const userConfig = this.exotelConfig.find(config => 
        config.emp_id === currentUserEmpId
      );
      
      return userConfig ? userConfig.callerId : null;
    },

    /**
     * Initiate a call to the candidate using Exotel API
     * @param {string} phoneNumber - The phone number to call
     */
    async initiateCall(phoneNumber) {
      try {
        this.isCallInProgress = true;
        this.callStatus = 'initiating';
        console.log('exotel service.initiateCall', phoneNumber)
        console.log('exotel API_BASE_URL:', process.env.VUE_APP_API)
        console.log('Using hardcoded values for testing')
        console.log('VUE_APP_API:', process.env.VUE_APP_API)
        
        // Get current user's phone number
        const fromNumber = '0' + (JSON.parse(localStorage.getItem('userData'))?.contact_no || '');
        
        // Get Exotel virtual number (caller ID) from config
        let callerId = this.getCallerIdForCurrentUser();
        
        // Fallback to hardcoded value for testing
        if (!callerId) {
          callerId = '09484956746';
          console.log('Using hardcoded caller ID for testing:', callerId);
        }
        
        console.log('Caller ID for current user:', callerId);
        console.log('From number:', fromNumber);
        
        if (!fromNumber || !callerId) {
          throw new Error('Missing required call configuration. Please check Exotel configuration and environment variables.');
        }
        
                // Prepare call data
        const callData = {
          from: '91' + (JSON.parse(localStorage.getItem('userData'))?.contact_no || ''),
          to: '91' + (phoneNumber.replace(/^0+/, '')),
          callerId: callerId,
          source: 'induslabs',
          options: {
            callType: 'trans', // Transactional call
            timeLimit: 2000, // 33 Minutes
            timeOut: 30, // 30 seconds ring time
            record: true, // Record the call
            recordingChannels: 'dual', // Record both legs separately
            recordingFormat: 'mp3', // MP3 format
            customField: JSON.stringify({
              candidate_id: this.candidateData.id,
              candidate_name: this.candidateData.firstName + ' ' + this.candidateData.lastName,
              job_id: this.jobId,
              recruiter: (JSON.parse(localStorage.getItem('userData'))?.emp_id) || 'Unknown'
            }),
            statusCallback: "https://ats.sattvahuman.in/api/exotel/webhook",
            statusCallbackEvents: ['terminal', 'answered'],
            statusCallbackContentType: 'application/json'
          }
        };
        
        console.log('Initiating call with data exotel service:', callData);
        console.log('Status callback URL:', callData.options.statusCallback);
        
        // Exotel service is now hardcoded for testing
        console.log('Exotel service baseURL:', exotelService.baseURL);
        
        // Make the API call through backend to avoid CORS
        const response = await adminConfigService.makeExotelCall(callData);
        console.log('exotel backend service.response', response)
        
        if (response && response.status === 'OK' && response.data) {
          this.lastCallSid = response.data.data.call_id;
          this.callStatus = 'initiated';
        } else {
          throw new Error(getExotelCallErrorMessage(response) || 'Failed to initiate call through backend');
        }
        
        // Show success message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Call Initiated',
            icon: 'CheckIcon',
            variant: 'success',
            text: `Call to ${phoneNumber} has been initiated. Call ID: ${this.lastCallSid}`
          }
        });
        
        // Log the call attempt
        console.log('Call initiated successfully:', response);
        
      } catch (error) {
        console.error('Error initiating call:', error);
        this.callStatus = 'failed';
        
        // Show error message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Call Failed',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.message || 'Failed to initiate call. Please try again.'
          }
        });
      } finally {
        this.isCallInProgress = false;
      }
    },
    
    goToPOFUTracker() {
      this.$router.push(`/apps/pofu-tracker?filter=${this.candidateData.candidate_id}`);
    },
    computeStatusOption() {
      console.log('inside computeStatusOption', this.prevStatus, this.client)
      this.jobId = this.jobId !== 'null' ? this.jobId : null
      if (this.jobId) {
        if (this.positionType === 'Contractual' && this.category === 'Blue Collar' && this.payroll === 'Sattva Payroll' && this.vertical === 'Infra Industry') {
          this.blueCollar = true
          console.log('job type blue collar: ', this.blueCollar)
        }
        this.cStatusOption = allowedNextStatusOptions(this.prevStatus, {
          client: this.client,
          positionType: this.positionType,
          category: this.category,
          payroll: this.payroll,
          vertical: this.vertical,
          blueCollar: this.blueCollar,
          hasFinalSelect: this.hasFinalSelect,
          isLastInterviewRoundSelect: this.isLastInterviewRoundSelect,
          isRelianceOfferProcessCompleted: this.isRelianceOfferProcessCompleted,
          isKPMGOfferProcessCompleted: this.isKPMGOfferProcessCompleted,
        })
      }
    },
    differenceInDays(date1, date2) {
      console.log('in loi check dates', date1, date2)
      const oneDay = 1000 * 60 * 60 * 24; // milliseconds in a day
      const diffTime = Math.abs(date2 - date1); // difference in milliseconds
      return Math.ceil(diffTime / oneDay); // convert to days and round up
    },
    extractTimelineList(payload) {
      if (!payload) return []
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload.timeline)) return payload.timeline
      if (Array.isArray(payload.jobTimeline)) return payload.jobTimeline
      if (Array.isArray(payload.candidateTimeline)) return payload.candidateTimeline
      if (Array.isArray(payload.data)) return payload.data
      if (payload.data && Array.isArray(payload.data.timeline)) return payload.data.timeline
      if (payload.data && Array.isArray(payload.data.jobTimeline)) return payload.data.jobTimeline
      return []
    },
    parseAddedByName(addedBy) {
      if (!addedBy) return ''
      if (typeof addedBy === 'string') {
        try {
          const parsed = JSON.parse(addedBy)
          if (Array.isArray(parsed) && parsed[0] && parsed[0].title) return parsed[0].title
        } catch (e) {
          return addedBy
        }
      }
      if (Array.isArray(addedBy) && addedBy[0] && addedBy[0].title) return addedBy[0].title
      if (addedBy.title) return addedBy.title
      return ''
    },
    formatTimelineTime(raw) {
      if (!raw) return ''
      const parsed = moment(raw)
      return parsed.isValid() ? parsed.format('DD MMM YYYY HH:mm:ss').toUpperCase() : String(raw).replace(/T/, ' ').replace(/\..+/, '')
    },
    formatTimelineDateOnly(raw) {
      const text = this.sanitizeTimelineText(raw)
      if (!text) return ''
      const dateOnly = text.match(/^(\d{4}-\d{2}-\d{2})/)
      const parsed = dateOnly ? moment(dateOnly[1], 'YYYY-MM-DD', true) : moment(text)
      if (!parsed.isValid() || parsed.year() < 1990) return ''
      return parsed.format('DD MMM YYYY').toUpperCase()
    },
    collectTimelineDateSources(item) {
      const raw = (item && item.raw) || {}
      const nested = raw.candidate_jobs && typeof raw.candidate_jobs === 'object' ? raw.candidate_jobs : null
      const job = this.findTimelineJobSource(item)
      const jobNested = job && job.candidate_jobs && typeof job.candidate_jobs === 'object' ? job.candidate_jobs : null
      return [
        raw,
        nested,
        this.parseTimelineExtraDetails(raw),
        nested && this.parseTimelineExtraDetails(nested),
        job,
        jobNested,
        job && this.parseTimelineExtraDetails(job),
      ].filter(source => source && typeof source === 'object' && !Array.isArray(source))
    },
    findTimelineJobSource(item) {
      const jobs = this.candidateJobs || []
      const key = item && item.jobKey
      if (key) {
        const match = jobs.find(job => String(job.id) === String(key) || String(job.job_id) === String(key))
        if (match) return match
      }
      return (item && item.raw) || null
    },
    pickTimelineDateFromSources(sources, keys) {
      const list = Array.isArray(sources) ? sources : []
      for (let i = 0; i < list.length; i++) {
        const value = this.pickTimelineField(list[i], keys)
        if (value) return value
      }
      return ''
    },
    timelineDayValue(raw) {
      const formatted = this.formatTimelineDateOnly(raw)
      if (!formatted) return 0
      const parsed = moment(formatted, 'DD MMM YYYY', true)
      return parsed.isValid() ? parsed.startOf('day').valueOf() : 0
    },
    entryTimelineRawTime(entry) {
      const raw = (entry && entry.raw) || {}
      const nested = raw.candidate_jobs || {}
      return (entry && entry.kind === 'event' ? (raw.createdAt || raw.created_at || entry.sortAt) : null)
        || (entry && entry.sortAt)
        || raw.createdAt
        || raw.created_at
        || nested.createdAt
        || nested.created_at
        || (entry && entry.time)
        || ''
    },
    pickTimelineDateFromStatusHistoryOnOrBefore(siblings, statusKeys, limitDay) {
      const list = Array.isArray(siblings) ? siblings : []
      const wants = (Array.isArray(statusKeys) ? statusKeys : []).map(key => this.normalizeTimelineStatusKey(key))
      let bestRaw = ''
      let bestDay = 0
      list.forEach(entry => {
        if (entry && entry.hasOwnStatus === false) return
        const statusKey = this.normalizeTimelineStatusKey(entry && entry.status)
        if (!wants.includes(statusKey)) return
        const rawTime = this.entryTimelineRawTime(entry)
        const day = this.timelineDayValue(rawTime)
        if (!day) return
        if (limitDay && day > limitDay) return
        if (!bestRaw || day < bestDay) {
          bestRaw = rawTime
          bestDay = day
        }
      })
      return bestRaw
    },
    pickHeadingDateOnOrBefore(fieldRaw, fallbackRaw, limitDay) {
      const fieldFormatted = this.formatTimelineDateOnly(fieldRaw)
      const fieldDay = this.timelineDayValue(fieldRaw || fieldFormatted)
      if (fieldFormatted && (!limitDay || !fieldDay || fieldDay <= limitDay)) {
        return fieldFormatted
      }
      return this.formatTimelineDateOnly(fallbackRaw)
    },
    collectDojDayFromItem(item) {
      const sources = this.collectTimelineDateSources(item)
      return this.timelineDayValue(this.pickTimelineDateFromSources(sources, [
        'joining_date', 'joiningDate', 'doj', 'date_of_joining', 'dateOfJoining', 'DOJ',
      ]))
    },
    parseTimelineStamp(raw) {
      const text = this.sanitizeTimelineText(raw)
      if (!text) return 0
      const iso = Date.parse(text)
      if (!Number.isNaN(iso)) return iso
      const parsed = moment(text, ['DD MMM YYYY HH:mm:ss', 'DD MMM YYYY'], true)
      return parsed.isValid() ? parsed.valueOf() : 0
    },
    isOfferLikeStatus(status) {
      const key = this.normalizeTimelineStatusKey(status)
      return key === 'offered' || key === 'offer' || key === 'offeraccepted'
    },
    isJoinedOrLaterStatus(status) {
      const key = this.normalizeTimelineStatusKey(status)
      return key === 'joined' || key === 'attrition' || key === 'earlyattrition'
    },
    isLateOfferBackfill(entry, headingSource) {
      if (!entry || entry.hasOwnStatus === false || !this.isOfferLikeStatus(entry.status)) return false
      if (!this.isJoinedOrLaterStatus(headingSource && headingSource.status)) return false
      const rawTime = this.entryTimelineRawTime(entry)
      const eventDay = this.timelineDayValue(rawTime)
      const eventTs = this.parseTimelineStamp(rawTime)
      const dojDay = this.collectDojDayFromItem(headingSource)
      if (dojDay && eventDay && eventDay > dojDay) return true
      const headingTs = this.parseTimelineStamp(headingSource && headingSource.time)
        || this.timelineSortValue(headingSource)
      if (headingTs && eventTs && eventTs > headingTs) return true
      return false
    },
    buildTimelineKeyDates(item, siblings) {
      const sources = this.collectTimelineDateSources(item)
      const dojRaw = this.pickTimelineDateFromSources(sources, [
        'joining_date', 'joiningDate', 'doj', 'date_of_joining', 'dateOfJoining', 'DOJ',
      ])
      const doj = this.formatTimelineDateOnly(dojRaw)
      const dojDay = this.timelineDayValue(dojRaw || doj)
      const limitDay = dojDay || 0
      const offeredField = this.pickTimelineDateFromSources(sources, [
        'offered_date', 'offeredDate', 'offer_date', 'offerDate', 'dateOfOffer',
      ])
      const offered = this.formatTimelineDateOnly(offeredField)
        || this.formatTimelineDateOnly(this.pickTimelineDateFromStatusHistoryOnOrBefore(
          siblings,
          ['Offered', 'Offer', 'Offer Accepted'],
          0
        ))
      const offeredDay = this.timelineDayValue(offered)
      const selectionLimit = [limitDay, offeredDay].filter(Boolean).sort((left, right) => left - right)[0] || 0
      const selectionField = this.pickTimelineDateFromSources(sources, [
        'selection_date', 'selectionDate', 'selected_on', 'selectedOn', 'shortlisted_date', 'shortlistedDate',
      ])
      const selectionFallback = this.pickTimelineDateFromStatusHistoryOnOrBefore(
        siblings,
        ['Selected', 'Shortlisted', 'Interview'],
        selectionLimit || limitDay
      )
      const selection = this.pickHeadingDateOnOrBefore(
        selectionField,
        selectionFallback,
        selectionLimit || limitDay
      )
      const dates = []
      if (doj) dates.push({ label: 'DOJ', value: doj })
      if (offered) dates.push({ label: 'Offered Date', value: offered })
      if (selection) dates.push({ label: 'Selection Date', value: selection })
      return dates
    },
    timelineInitials(name) {
      const text = this.sanitizeTimelineText(name)
      if (!text) return ''
      const words = text.split(/\s+/).filter(Boolean)
      if (words.length === 1) {
        const word = words[0]
        return word.length <= 3 ? word.toUpperCase() : word.slice(0, 2).toUpperCase()
      }
      return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase()
    },
    timelinePersonTooltip(role, name) {
      const text = this.sanitizeTimelineText(name)
      return text ? `${role}: ${text}` : role
    },
    timelineStatusPrefix(item) {
      return item && (item.isCurrent || item.showJobHeader) ? 'Current status' : 'Status'
    },
    timelinePriorStatusLabel(item, update) {
      const updateStatus = this.sanitizeTimelineText((update && update.status) || (item && item.status))
      const parentStatus = this.sanitizeTimelineText(item && item.status)
      if (!updateStatus || this.timelineStatusesMatch(updateStatus, parentStatus)) {
        return 'Prior update'
      }
      return `Prior status: ${updateStatus}`
    },
    timelineUpdateHasPeople(update) {
      return !!(
        (update && update.sourcerName)
        || (update && update.recruiterName)
        || this.timelineShowUpdateActor(update)
      )
    },
    timelineShowUpdateActor(update) {
      const actor = this.sanitizeTimelineText(update && update.actorName)
      if (!actor) return false
      const actorKey = actor.toLowerCase()
      const sourcer = this.sanitizeTimelineText(update && update.sourcerName)
      const recruiter = this.sanitizeTimelineText(update && update.recruiterName)
      if (sourcer && sourcer.toLowerCase() === actorKey) return false
      if (recruiter && recruiter.toLowerCase() === actorKey) return false
      return true
    },
    formatTimelineClientValue(value) {
      if (value === undefined || value === null) return ''
      if (typeof value === 'number') return ''
      if (typeof value === 'string') {
        const text = this.sanitizeTimelineText(value)
        if (!text || /^\d+$/.test(text)) return ''
        if (text.charAt(0) === '[' || text.charAt(0) === '{') {
          try {
            return this.formatTimelineClientValue(JSON.parse(text))
          } catch (e) {
            return text
          }
        }
        return text
      }
      if (Array.isArray(value)) {
        return value.length ? this.formatTimelineClientValue(value[0]) : ''
      }
      if (typeof value === 'object') {
        return this.sanitizeTimelineText(value.title || value.name || value.client_name || value.client)
      }
      return ''
    },
    pickTimelineClientName(obj) {
      if (!obj) return ''
      return this.formatTimelineClientValue(obj.client_name)
        || this.formatTimelineClientValue(obj.clientName)
        || this.formatTimelineClientValue(obj.Client)
        || this.formatTimelineClientValue(obj.client)
    },
    formatTimelineJobHeading(code, position) {
      const jobCode = this.sanitizeTimelineText(code)
      const pos = this.sanitizeTimelineText(position)
      if (!jobCode && !pos) return ''
      return `${jobCode}${jobCode && pos ? ' - ' : ''}${pos}`
    },
    isJobTimelineRow(item) {
      if (!item || !item.showJobHeader) return false
      const title = this.sanitizeTimelineText(item.title)
      if (!title || /^candidate activity$/i.test(title)) return false
      if (/status changes?/i.test(title)) return false
      return true
    },
    timelineDotVariant(item) {
      return this.isJobTimelineRow(item) ? 'success' : 'info'
    },
    timelineJobExtras(item) {
      const raw = item && item.raw
      if (!raw) return []
      const extras = []
      if (raw.attrition_date && (item.status === 'Attrition' || item.status === 'Early Attrition')) {
        extras.push({ label: 'Attrition Date', value: this.formatTimelineDateOnly(raw.attrition_date) || raw.attrition_date })
      }
      if (raw.drop_reason) extras.push({ label: 'Reason', value: raw.drop_reason })
      if (raw.offered_ctc || raw.revenue) extras.push({ label: 'CTC vs Revenue', value: `${raw.offered_ctc || ''} - ${raw.revenue || ''}` })
      return extras
    },
    timelineSortValue(item) {
      const raw = (item && item.sortAt) || (item && item.raw && (item.raw.createdAt || item.raw.created_at || item.raw.updatedAt)) || ''
      const ts = Date.parse(raw)
      return Number.isNaN(ts) ? 0 : ts
    },
    sanitizeTimelineText(value) {
      if (value === undefined || value === null) return ''
      const text = String(value).trim()
      if (!text || text === 'undefined' || text === 'null' || text === 'NaN') return ''
      return text
    },
    parseTimelineJsonField(value) {
      if (typeof value !== 'string') return value
      const trimmed = value.trim()
      if (!trimmed.startsWith('[') && !trimmed.startsWith('{')) return value
      try {
        return JSON.parse(trimmed)
      } catch (e) {
        return value
      }
    },
    extractTimelineAssignmentEmpId(value) {
      if (value == null || value === '') return ''
      const parsed = this.parseTimelineJsonField(value)
      if (Array.isArray(parsed)) return ''
      if (parsed && typeof parsed === 'object') {
        const id = parsed.emp_id || parsed.empId || parsed.id
        const text = this.sanitizeTimelineText(id)
        return /^[A-Z]{1,6}[-_]?\d+$/i.test(text) ? text : ''
      }
      const text = this.sanitizeTimelineText(parsed)
      return /^[A-Z]{1,6}[-_]?\d+$/i.test(text) ? text : ''
    },
    assignmentRecruiterIdFromBag(bag) {
      if (!bag || typeof bag !== 'object' || Array.isArray(bag)) return ''
      return this.extractTimelineAssignmentEmpId(bag.recruiter)
    },
    pickTimelineAssignmentColumn(raw, nested, job, field) {
      const joins = []
      const jobCj = job && job.candidate_jobs && typeof job.candidate_jobs === 'object' && !Array.isArray(job.candidate_jobs)
        ? job.candidate_jobs
        : null
      const rawCj = raw && raw.candidate_jobs && typeof raw.candidate_jobs === 'object' && !Array.isArray(raw.candidate_jobs)
        ? raw.candidate_jobs
        : null
      const isJoin = bag => bag && typeof bag === 'object' && !Array.isArray(bag) && Object.keys(bag).length > 0
      if (isJoin(jobCj)) joins.push(jobCj)
      if (isJoin(nested) && nested !== jobCj) joins.push(nested)
      if (isJoin(rawCj) && rawCj !== nested && rawCj !== jobCj) joins.push(rawCj)
      for (let i = 0; i < joins.length; i++) {
        const value = joins[i][field]
        if (value != null && value !== '' && !Array.isArray(value)) return value
      }
      if (joins.length) return ''
      if (job && job[field] != null && job[field] !== '' && !Array.isArray(job[field])) return job[field]
      if (raw && raw[field] != null && raw[field] !== '' && !Array.isArray(raw[field])) return raw[field]
      return ''
    },
    lookupTimelineAssignmentName(value) {
      if (value == null || value === '' || Array.isArray(value)) return ''
      const parsed = this.parseTimelineJsonField(value)
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        const name = this.sanitizeTimelineText(parsed.title || parsed.name || parsed.full_name || parsed.fullName)
        if (name) return name
        const id = this.sanitizeTimelineText(parsed.emp_id || parsed.empId || parsed.id)
        return this.lookupTimelineUserName(id)
      }
      const text = this.sanitizeTimelineText(parsed)
      if (!text) return ''
      if (this.extractTimelineAssignmentEmpId(text)) return this.lookupTimelineUserName(text)
      return text
    },
    lookupTimelineUserName(empId) {
      const id = this.sanitizeTimelineText(empId)
      if (!id) return ''
      const lists = []
      if (Array.isArray(this.recruiters)) lists.push(this.recruiters)
      if (Array.isArray(this.allUsers)) lists.push(this.allUsers)
      try {
        const stored = JSON.parse(localStorage.getItem('allusers') || 'null')
        if (Array.isArray(stored)) lists.push(stored)
      } catch (e) { /* ignore */ }
      for (let i = 0; i < lists.length; i++) {
        const match = lists[i].find(person => {
          if (!person || typeof person !== 'object') return false
          return String(person.emp_id || person.empId || person.id) === id
        })
        if (match) {
          const name = this.sanitizeTimelineText(
            match.title || match.name || match.emp_name
            || [match.first_name, match.last_name].filter(Boolean).join(' ')
          )
          if (name) return name
        }
      }
      return ''
    },
    resolveTimelineSourcerName(raw, nested, job) {
      return this.lookupTimelineAssignmentName(this.pickTimelineAssignmentColumn(raw, nested, job, 'sourcer'))
    },
    resolveTimelineRecruiterName(raw, nested, job) {
      return this.lookupTimelineAssignmentName(this.pickTimelineAssignmentColumn(raw, nested, job, 'recruiter'))
    },
    pickTimelineField(obj, keys) {
      if (!obj) return ''
      for (let i = 0; i < keys.length; i++) {
        const raw = obj[keys[i]]
        if (raw && typeof raw === 'object') continue
        const value = this.sanitizeTimelineText(raw)
        if (value) return value
      }
      return ''
    },
    parseTimelineExtraDetails(obj) {
      const raw = obj && (obj.extra_details || obj.extraDetails)
      if (!raw) return null
      if (typeof raw === 'object') return raw
      if (typeof raw === 'string') {
        try {
          const parsed = JSON.parse(raw)
          return parsed && typeof parsed === 'object' ? parsed : null
        } catch (e) {
          return null
        }
      }
      return null
    },
    // job_timeline rows do not persist jt.comment — read this row's aliases / description.
    // Do not pass candidate_jobs here; assignment comment is overlaid only on the latest row.
    pickTimelineComment(obj) {
      if (!obj) return ''
      const keys = ['comment', 'comments', 'remarks', 'callback_comment', 'callbackComment', 'NA_comment', 'notes']
      const direct = this.pickTimelineField(obj, keys)
      if (direct) return direct
      const extra = this.parseTimelineExtraDetails(obj)
      if (extra) {
        const fromExtra = this.pickTimelineField(extra, keys)
        if (fromExtra) return fromExtra
      }
      return this.pickTimelineDescriptionComment(obj)
    },
    pickTimelineDescriptionComment(obj) {
      const description = this.sanitizeTimelineText(obj && obj.description)
      if (description && !/^cs-changed$/i.test(description) && !/^previous status/i.test(description)) {
        return description
      }
      return ''
    },
    pickTimelineEventOwnComment(obj) {
      if (!obj) return ''
      // Per-update text is written to description so history survives before backend item 18.
      return this.pickTimelineDescriptionComment(obj) || this.pickTimelineComment(obj)
    },
    pickTimelineEventOwnStatus(raw) {
      const fromEvent = this.pickTimelineField(raw, ['candidateStatus', 'candidate_status'])
      if (fromEvent) return fromEvent
      const title = String((raw && raw.title) || '')
      const match = title.match(/status changes? to (.+)$/i)
      return match ? this.sanitizeTimelineText(match[1]) : ''
    },
    pickTimelineActivityLabel(raw) {
      const title = this.sanitizeTimelineText(raw && raw.title)
      if (/offer letter sent/i.test(title)) return 'Offer letter sent'
      if (/offer letter generated/i.test(title)) return 'Offer letter generated'
      return title
        .replace(/\s+for Candidate Id.*$/i, '')
        .replace(/\s+to Candidate Id.*$/i, '')
        .trim()
    },
    isJobKindTimelineEntry(item) {
      return !!(item && item.kind === 'job')
    },
    firstNonEmptyTimelineField(items, field) {
      const list = Array.isArray(items) ? items : []
      for (let i = 0; i < list.length; i++) {
        const value = this.sanitizeTimelineText(list[i] && list[i][field])
        if (value) return value
      }
      return ''
    },
    timelineStatusesMatch(left, right) {
      const a = this.normalizeTimelineStatusKey(left)
      const b = this.normalizeTimelineStatusKey(right)
      return !!a && a === b
    },
    normalizeTimelineStatusKey(status) {
      return this.sanitizeTimelineText(status).toLowerCase().replace(/\s+/g, '')
    },
    collapseConsecutiveStatusRuns(items) {
      const list = Array.isArray(items) ? items : []
      const runs = []
      list.forEach(item => {
        const statusKey = this.normalizeTimelineStatusKey(item.status)
        const last = runs[runs.length - 1]
        if (last && last.statusKey === statusKey) {
          last.items.push(item)
        } else {
          runs.push({ statusKey, items: [item] })
        }
      })
      return runs
    },
    diffCollapsedTimelineFields(entry, previous) {
      const source = this.sanitizeTimelineText(entry && entry.source)
      const comment = this.sanitizeTimelineText(entry && entry.comment)
      const reason = this.sanitizeTimelineText(entry && entry.reason)
      const prevSource = this.sanitizeTimelineText(previous && previous.source)
      const prevReason = this.sanitizeTimelineText(previous && previous.reason)
      return {
        key: entry.key,
        time: entry.time,
        status: this.sanitizeTimelineText(entry && entry.status),
        actorName: this.sanitizeTimelineText(entry && entry.actorName),
        sourcerName: this.sanitizeTimelineText(entry && entry.sourcerName),
        recruiterName: this.sanitizeTimelineText(entry && entry.recruiterName),
        clientName: this.sanitizeTimelineText(entry && entry.clientName),
        source: source && source.toLowerCase() !== prevSource.toLowerCase() ? source : '',
        // Each same-status update keeps its own comment (do not hide when it matches the latest).
        comment,
        reason: reason && reason.toLowerCase() !== prevReason.toLowerCase() ? reason : '',
      }
    },
    toggleTimelineRun(runKey) {
      this.$set(this.expandedTimelineRuns, runKey, !this.expandedTimelineRuns[runKey])
    },
    toggleShowAllTimelineUpdates(runKey) {
      this.$set(this.showAllTimelineUpdates, runKey, true)
      this.measureCandidateTimelineOverflow()
    },
    measureCandidateTimelineOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.candidateTimelineScroll
        if (!el) {
          this.timelineOverflows = false
          return
        }
        this.timelineOverflows = el.scrollHeight > el.clientHeight + 2
      })
    },
    toggleCandidateTimelineExpand() {
      this.timelineExpanded = !this.timelineExpanded
      this.$nextTick(() => {
        const el = this.$refs.candidateTimelineScroll
        if (el && !this.timelineExpanded) el.scrollTop = 0
        this.measureCandidateTimelineOverflow()
      })
    },
    visibleTimelineUpdates(item) {
      const updates = (item && item.updates) || []
      if (this.showAllTimelineUpdates[item.runKey] || updates.length <= this.timelineRunPreviewLimit) {
        return updates
      }
      return updates.slice(0, this.timelineRunPreviewLimit)
    },
    groupTimelineByJob(items) {
      const list = Array.isArray(items) ? items : []
      const groups = []
      const indexByKey = {}
      list.forEach(item => {
        const key = item.jobKey || item.title || 'job'
        if (indexByKey[key] == null) {
          indexByKey[key] = groups.length
          groups.push({
            key,
            title: item.title,
            jobCode: item.jobCode,
            position: item.position,
            sourcerName: item.sourcerName,
            recruiterName: item.recruiterName,
            clientName: item.clientName,
            items: [],
          })
        } else {
          const group = groups[indexByKey[key]]
          if (!group.jobCode && item.jobCode) group.jobCode = item.jobCode
          if (!group.position && item.position) group.position = item.position
          if (!group.sourcerName && item.sourcerName) group.sourcerName = item.sourcerName
          if (!group.recruiterName && item.recruiterName) group.recruiterName = item.recruiterName
          if (!group.clientName && item.clientName) group.clientName = item.clientName
        }
        groups[indexByKey[key]].items.push(item)
      })
      groups.forEach(group => {
        group.items.sort((a, b) => this.timelineSortValue(b) - this.timelineSortValue(a))
      })
      groups.sort((a, b) => this.timelineSortValue(b.items[0]) - this.timelineSortValue(a.items[0]))
      const flat = []
      groups.forEach(group => {
        const jobRow = group.items.find(item => this.isJobKindTimelineEntry(item))
        const eventRows = group.items.filter(item => !this.isJobKindTimelineEntry(item))
        const headingSource = jobRow || eventRows[0]
        if (!headingSource) return
        const historyRows = jobRow ? eventRows : eventRows.slice(1)
        const runs = this.collapseConsecutiveStatusRuns(historyRows)
        const headingStatus = headingSource.status
        const headingRunItems = [headingSource]
        const buildGrouped = (runItems, index, isHeading) => {
          const latest = runItems[0]
          const updates = runItems.slice(1).map((entry, updateIndex) => (
            this.diffCollapsedTimelineFields(Object.assign({}, entry, {
              sourcerName: entry.sourcerName || group.sourcerName,
              recruiterName: entry.recruiterName || group.recruiterName,
              clientName: entry.clientName || group.clientName,
            }), runItems[updateIndex])
          ))
          const grouped = Object.assign({}, latest, {
            showJobHeader: isHeading,
            isCurrent: isHeading,
            title: this.formatTimelineJobHeading(group.jobCode, group.position) || group.title,
            sourcerName: latest.sourcerName || group.sourcerName,
            recruiterName: latest.recruiterName || group.recruiterName,
            clientName: latest.clientName || group.clientName,
            status: isHeading ? headingStatus : latest.status,
            source: isHeading ? latest.source : '',
            comment: this.sanitizeTimelineText(latest.comment) || this.firstNonEmptyTimelineField(runItems, 'comment'),
            reason: this.sanitizeTimelineText(latest.reason) || this.firstNonEmptyTimelineField(runItems, 'reason'),
            runKey: `${group.key}-${index}-${this.normalizeTimelineStatusKey(isHeading ? headingStatus : latest.status)}`,
            updates: (latest.updates || []).concat(updates),
            keyDates: isHeading ? this.buildTimelineKeyDates(latest, group.items) : [],
          })
          grouped.updateCount = (grouped.updates && grouped.updates.length)
            ? grouped.updates.length + 1
            : Math.max(runItems.length, latest.updateCount || 1)
          grouped.variant = this.timelineDotVariant(grouped)
          return grouped
        }
        flat.push(buildGrouped(headingRunItems, 0, true))
        let emittedJoined = false
        runs.forEach((run, index) => {
          const sameAsHeading = this.timelineStatusesMatch(run.items[0] && run.items[0].status, headingStatus)
          if (sameAsHeading && this.isJoinedOrLaterStatus(headingStatus)) {
            const ownJoined = run.items.filter(entry => entry.hasOwnStatus)
            if (ownJoined.length) {
              flat.push(buildGrouped(ownJoined, index + 1, false))
              emittedJoined = true
            }
            return
          }
          if (sameAsHeading) return
          flat.push(buildGrouped(run.items, index + 1, false))
        })
        if (!emittedJoined && this.isJoinedOrLaterStatus(headingStatus)) {
          const joinedStage = Object.assign({}, headingSource, {
            key: `${headingSource.jobKey || headingSource.key}-joined-stage`,
            kind: 'event',
            hasOwnStatus: true,
            status: headingStatus,
            comment: '',
            reason: '',
            updates: [],
            updateCount: 1,
            source: '',
          })
          const joinedGrouped = buildGrouped([joinedStage], 1, false)
          const joinedTs = this.timelineSortValue(joinedGrouped)
          let insertAt = flat.length
          for (let i = 1; i < flat.length; i += 1) {
            if (this.timelineSortValue(flat[i]) <= joinedTs) {
              insertAt = i
              break
            }
          }
          flat.splice(insertAt, 0, joinedGrouped)
        }
      })
      return flat
    },
    isThisCandidateEvent(event) {
      if (!event) return false
      const cid = event.candidate_id || event.candidateId || event.cid
      if (cid != null && String(cid) === String(this.id)) return true
      const title = String(event.title || '')
      if (title.includes(`Candidate - ${this.id}`)) return true
      const publicId = this.candidateData && this.candidateData.candidate_id
      if (publicId && title.includes(String(publicId))) return true
      return false
    },
    findJobForTimelineEvent(event) {
      const jobs = this.candidateJobs || []
      const jobId = event && (event.jobId || event.job_id)
      if (jobId != null) {
        const match = jobs.find(job => String(job.id) === String(jobId) || String(job.job_id) === String(jobId))
        if (match) return match
      }
      return null
    },
    normalizeTimelineEntry(raw, kind) {
      const nested = (raw && raw.candidate_jobs) || {}
      const job = kind === 'event' ? this.findJobForTimelineEvent(raw) : raw
      const ownStatus = kind === 'event'
        ? this.pickTimelineEventOwnStatus(raw)
        : (this.pickTimelineField(raw, ['candidateStatus', 'candidate_status', 'status'])
          || this.pickTimelineField(nested, ['candidateStatus', 'candidate_status', 'status'])
          || '')
      const hasOwnStatus = kind === 'job' || !!ownStatus
      const status = ownStatus || (kind === 'event' ? this.pickTimelineActivityLabel(raw) : '')
      const earlyStatuses = ['Not Interested', 'Not Relevant', 'Call Back', 'Not Answered', 'Not Reachable', 'Wrong Number']
      const isEarly = earlyStatuses.includes(status)
      const jobCode = this.sanitizeTimelineText((job && job.job_id) || raw.job_id)
      const position = this.sanitizeTimelineText((job && job.position_name) || raw.position_name)
      const clientName = this.pickTimelineClientName(raw)
        || this.pickTimelineClientName(nested)
        || this.pickTimelineClientName(job)
      const title = this.formatTimelineJobHeading(jobCode, position)
        || this.sanitizeTimelineText(raw.title)
        || 'Candidate activity'
      const source = this.pickTimelineField(raw, ['source'])
        || this.pickTimelineField(nested, ['source'])
        || (job && this.pickTimelineField(job, ['source']))
        || this.sanitizeTimelineText(this.candidateData && this.candidateData.source)
      const jobStatus = job
        ? (this.pickTimelineField(job, ['candidateStatus', 'candidate_status', 'status']) || this.sanitizeTimelineText(job.status))
        : ''
      // Events: only this row's description/comment. Assignment comment is applied later
      // onto the latest same-status row only — never onto historical Call Back rows.
      const comment = kind === 'event'
        ? this.pickTimelineEventOwnComment(raw)
        : (this.pickTimelineComment(raw)
          || this.pickTimelineComment(nested)
          || (job && this.timelineStatusesMatch(status, jobStatus) ? this.pickTimelineComment(job) : ''))
      const reason = kind === 'event'
        ? this.pickTimelineField(raw, ['reason'])
        : (this.pickTimelineField(raw, ['reason'])
          || this.pickTimelineField(nested, ['reason'])
          || (job && this.timelineStatusesMatch(status, jobStatus) ? this.pickTimelineField(job, ['reason']) : ''))
      const by = this.sanitizeTimelineText(raw.createdBy)
        || this.sanitizeTimelineText(raw.rec_name)
        || this.sanitizeTimelineText(nested.rec_name)
        || this.sanitizeTimelineText(this.parseAddedByName(raw.addedBy || nested.addedBy))
        || this.sanitizeTimelineText(job && job.rec_name)
      const timeRaw = kind === 'event'
        ? (raw.createdAt || raw.created_at || nested.createdAt || nested.created_at || raw.updatedAt || raw.updated_at || '')
        : (raw.updatedAt || raw.updated_at || raw.createdAt || raw.created_at || nested.createdAt || '')
      const time = this.formatTimelineTime(timeRaw)
      const jobKey = this.sanitizeTimelineText(
        (job && (job.id || job.job_id)) || raw.jobId || raw.job_id || jobCode || title
      ) || 'job'
      const sourcerName = this.resolveTimelineSourcerName(raw, nested, job)
      const recruiterName = this.resolveTimelineRecruiterName(raw, nested, job)
      return {
        key: `${kind}-${raw.id || title}-${timeRaw}-${status}`,
        kind,
        hasOwnStatus,
        jobKey,
        variant: raw.type || (isEarly ? 'warning' : 'success'),
        title,
        jobCode,
        position,
        time,
        actorName: by,
        status: this.sanitizeTimelineText(status),
        source,
        comment,
        reason,
        sourcerName,
        recruiterName,
        clientName,
        sortAt: timeRaw,
        raw: kind === 'event' ? raw : (job || raw || {}),
      }
    },
    mapJobsToTimelineEntries(jobs) {
      if (!Array.isArray(jobs)) return []
      return jobs.map(job => this.normalizeTimelineEntry(job, 'job'))
    },
    hydrateCandidateTimeline(viewData) {
      const fromView = [
        ...this.extractTimelineList(viewData && viewData.timeline),
        ...this.extractTimelineList(viewData && viewData.candidateTimeline),
        ...this.extractTimelineList(viewData && viewData.jobTimeline),
      ].filter(event => this.isThisCandidateEvent(event))
      if (fromView.length) {
        this.candidateTimelineEvents = fromView
          .map(event => this.normalizeTimelineEntry(event, 'event'))
          .sort((a, b) => this.timelineSortValue(b) - this.timelineSortValue(a))
        return
      }
      this.loadCandidateJobTimelines()
    },
    async loadCandidateJobTimelines() {
      const jobs = this.candidateJobs || []
      const ids = [...new Set(jobs.map(job => job.id).filter(Boolean))]
      if (!ids.length) {
        this.candidateTimelineEvents = []
        return
      }
      try {
        const results = await Promise.all(ids.map(id => jobTimelineService.getJobTimeline(id)))
        const events = []
        results.forEach(res => {
          this.extractTimelineList(res).forEach(event => {
            if (this.isThisCandidateEvent(event)) events.push(event)
          })
        })
        const seen = new Set()
        this.candidateTimelineEvents = events
          .filter(event => {
            const key = event.id || `${event.title}-${event.createdAt || event.created_at}`
            if (seen.has(key)) return false
            seen.add(key)
            return true
          })
          .map(event => this.normalizeTimelineEntry(event, 'event'))
          .sort((a, b) => this.timelineSortValue(b) - this.timelineSortValue(a))
      } catch (e) {
        this.candidateTimelineEvents = []
      }
    },
    getCandidateData() {
      CandidateService.getCandidateViewData(this.id).then(res => {
        console.log(res)
        if(res.status === "OK") {
          this.candidateData = res.data.candidateData[0]
          this.candidateJobs = res.data.candidateJobs || []
          this.candidateJobData = this.candidateJobs.filter(item => item.id == this.jobId)[0]
          this.hydrateCandidateTimeline(res.data)
          console.log("this.candidateJobData", this.candidateJobData, this.jobId, this.candidateJobs)
          
                // Load KPMG RPO offer process data if available
      if (this.isKPMGRPOEnabled || this.isRelianceRPOEnabled) {
        this.loadOfferProcessData();
      }
          // this.candidateMetadata = res.data.candidateData[0].metadata
          if (res.data.candidateData[0].metadata) {
            // Overwrite only if the server returned a valid object
            this.candidateMetadata = {
              ...this.candidateMetadata,
              ...res.data.candidateData[0].metadata,
            }
          }
          // this.isDuplicate = this.candidateMetadata?.isDuplicate ? this.candidateMetadata?.isDuplicate : false
          if(this.candidateData.documents) {
            // Handle aadhaar front - check both new format (aadhaar_front) and old format (aadhaar)
            if(this.candidateData.documents.aadhaar_front || this.candidateData.documents.aadhaar) {
              this.aadhaarUploaded = true
              this.showAadhaarUpload = false
              this.aadhaarFrontUploaded = true
              this.showAadhaarFrontUpload = false
            }
            // Handle aadhaar_back (back is stored as 'aadhaar_back' key)
            if(this.candidateData.documents.aadhaar_back) {
              this.aadhaarBackUploaded = true
              this.showAadhaarBackUpload = false
            }
            if(this.candidateData.documents.pan) {
              this.panUploaded = true
              this.showPanUpload = false
            }
            if(this.candidateData.documents.photo) {
              this.photoUploaded = true
              this.showPhotoUpload = false
            }
            if(this.candidateData.documents.skillCertificate) {
              this.certificateUploaded = true
              this.showCertificateUpload = false
            }
            if(this.candidateData.documents.bankProof) {
              this.bankUploaded = true
              this.showBankUpload = false
            }
          }
          
          let key = null
          if(this.candidateData.cv_path) {
            key = this.candidateData.cv_path.replace("/","%2F")

            const temp = key.split(".");
            const cStatus = this.candidateJobs.filter(item => item.id === this.jobId )[0]
            this.prevStatus = cStatus ? cStatus.candidateStatus : ''
            const extension = temp[temp.length - 1]; // Or parts.pop();
            ////console.log(extension)
            if(extension === 'pdf') {
              this.pdf = true
              this.docx = false
              this.doc = false
              this.otherDoc = false
              this.rtf = false
            } else if (extension === 'docx'){
              this.pdf = false
              this.docx = true
              this.doc = false
              this.otherDoc = false
              this.rtf = false
            } else if (extension === 'doc'){
              this.pdf = false
              this.docx = false
              this.doc = true
              this.otherDoc = false
              this.rtf = false
            }else if (extension === 'rtf'){
              this.pdf = false
              this.docx = false
              this.doc = false
              this.rtf = true
              this.otherDoc = false
            } else if (extension !== 'docx' || extension !== 'doc' || extension !== 'pdf' || extension !== 'rtf') {
              this.pdf = false
              this.docx = false
              this.doc = false
              this.rtf = false
              this.otherDoc = true
            } 
            
            JobService.getFile(key)
              .then(res => {
                console.log('res file', res.file)
                this.dlink = res.file;
                var encodedUrl = encodeURIComponent(res.file);
                this.glink = //'https://192.168.1.104:5000/download/' + response.data.cv_path
                  "https://docs.google.com/viewer?url=" + encodedUrl + "&embedded=true";

                this.mlink = "https://view.officeapps.live.com/op/view.aspx?src=" + encodedUrl
                ////console.log(this.dlink)
                this.dlink = res.file;
            });
            if(this.pdf) {
              JobService.getFileBase64(key)
                .then(res => {
                  ////console.log(res)
                  const base64 = res.file;
                  //var encodedUrl = encodeURIComponent(res.file);
                  this.blink = "data:application/pdf;base64," + base64
                  
              }); 
            }
          } else {
            this.cvPresent = false
          }
          
          //console.log('testcase', this.candidateJobs.createdAt, moment(this.candidateJobs.createdAt).format("DD MMM YYYY"))
          
          console.log('job Id in candidate view', this.jobId)
          if (this.jobId) {
            console.log('jobid data', this.jobId, typeof this.jobId, this.candidateJobs, this.candidateJobs.filter(item => item.id == this.jobId))
            const temp1 = this.candidateJobs.filter(item => item.id == this.jobId)
            const temp = temp1 && temp1.length > 0 ? temp1[0].sourcer : null
            
            this.jobBySourcer = temp ? 'sourcer' : 'non-sourcer'
            console.log('assigned to job',temp1, temp, this.jobBySourcer)
            if (temp && temp.length > 0) {
              CandidateService.getCandidateCurrentStatus(this.id, this.jobId).then( res => {
                if (res.status === 'OK' && res.data && res.data.length > 0) {
                  console.log('candidate status', res)
                  this.prevStatus = res.data[0].candidateStatus
                  if(this.prevStatus === 'Joined' && this.category === 'Blue Collar') {
                    const today = new Date()
                    const joining_date = new Date(this.candidateJobs[0].joining_date)                    
                    this.daysDifference = this.differenceInDays(today, joining_date)
                    console.log('days difference: ', this.daysDifference)
                  }
                } else {
                  console.log('No candidate status data found or empty array')
                  this.prevStatus = null
                }
              })
            }
            this.updateButtonVisible = this.CandidateBelongsToJob()
            this.intNotIntNotRelVisible = this.CandidateBelongsToSourcerJob()
            //console.log(this.updateButtonVisible, this.intNotIntNotRelVisible)
          
          }

        } else if ((res.status === 401 ) || (res.status === 403 )) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        } else if ((res.status === 400 ) ) {
          this.error = 'Some Error Occurred, Please Try after sometime. If Same Issue occurs multiple times, Kindly contact IT admin.'
        } else if ((res.status === 500 ) ) {
          this.error = 'ERROR: ' + res.data.message + 'Kindly contact IT admin.'
        } else {
          this.error = res
        }
        
        
      })

    },
    showCModal(id, status) {
      this.candidate_id = id;
      //console.log('compute status')
      this.computeStatusOption()
      //console.log('compute status end')
      
      // Load interview process data for Reliance RPO
      this.loadInterviewProcessData()
      
      // Reliance RPO only: if candidate is already in Interview, pre-select Interview in the modal
      const currentStatus = status || this.candidateJobData?.candidateStatus
      if (this.client === 'Reliance RPO' && currentStatus === 'Interview') {
        this.statusCSelected = 'Interview'
        this.$nextTick(() => {
          this.selectCStatus('Interview')
        })
      }
      
      this.$refs["modal-cupdate-status"].show();
    },
    
    // ========== Interview Process Helper Methods for Reliance RPO ==========
    
    /**
     * Get the array of round numbers to display for updating
     * If any round has "final_select", only show rounds up to that round
     */
    getInterviewRoundsToUpdate() {
      // Use current in-memory rounds so changing "Number of Interview Rounds" in modal updates the list
      const roundCount = this.interviewProcess?.rounds ?? this.candidateJobData?.extra_details?.interview_process?.rounds
      if (!roundCount) return []
      const numRounds = typeof roundCount === 'object' ? roundCount.value : Number(roundCount)
      if (isNaN(numRounds) || numRounds < 1) return []

      const process = this.candidateJobData?.extra_details?.interview_process
      const roundResults = this.interviewProcess.round_results || process?.round_results || {}
      let finalSelectRound = null
      
      for (let i = 1; i <= numRounds; i++) {
        const roundKey = 'round' + i
        const roundData = roundResults[roundKey]
        if (roundData) {
          const status = typeof roundData === 'object' ? roundData.status : roundData
          if (status === 'final_select') {
            finalSelectRound = i
            break
          }
        }
      }

      // If final_select found, only show rounds up to that round
      if (finalSelectRound !== null) {
        return Array.from({ length: finalSelectRound }, (_, i) => i + 1)
      }

      return Array.from({ length: numRounds }, (_, i) => i + 1)
    },
    
    /**
     * Get current user's emp_id for tracking who made updates
     */
    getCurrentUserEmpId() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      return userData.emp_id || ''
    },
    
    /**
     * Get the status of a specific interview round
     * Checks both local interviewProcess and source data from candidateJobData
     */
    getInterviewRoundStatus(roundNumber) {
      const roundKey = 'round' + roundNumber
      
      // First check local interviewProcess (for newly updated values)
      let roundData = this.interviewProcess.round_results?.[roundKey]
      
      // If not found locally, check source data from candidateJobData
      if (!roundData && this.candidateJobData?.extra_details?.interview_process?.round_results) {
        roundData = this.candidateJobData.extra_details.interview_process.round_results[roundKey]
      }
      
      if (!roundData) return null
      return typeof roundData === 'object' ? roundData.status : roundData
    },

    /**
     * Get round_date for a specific interview round
     */
    getInterviewRoundDate(roundNumber) {
      const roundKey = 'round' + roundNumber
      let roundData = this.interviewProcess.round_results?.[roundKey]
      if (!roundData && this.candidateJobData?.extra_details?.interview_process?.round_results) {
        roundData = this.candidateJobData.extra_details.interview_process.round_results[roundKey]
      }
      if (!roundData || typeof roundData !== 'object') return null
      return roundData.round_date || null
    },

    /**
     * Set round_date for a specific interview round (preserves status and other fields)
     */
    setInterviewRoundDate(roundNumber, date) {
      const roundKey = 'round' + roundNumber
      const existing = this.interviewProcess.round_results?.[roundKey]
      const existingObj = existing && typeof existing === 'object' ? existing : {}
      this.$set(this.interviewProcess.round_results, roundKey, {
        ...existingObj,
        status: existingObj.status ?? null,
        round_date: date || null,
        updated_by: this.getCurrentUserEmpId()
      })
    },

    getInterviewRoundComment(roundNumber) {
      const roundKey = 'round' + roundNumber
      let roundData = this.interviewProcess.round_results?.[roundKey]
      if (!roundData && this.candidateJobData?.extra_details?.interview_process?.round_results) {
        roundData = this.candidateJobData.extra_details.interview_process.round_results[roundKey]
      }
      if (!roundData || typeof roundData !== 'object') return null
      return roundData.comment ?? null
    },

    setInterviewRoundComment(roundNumber, comment) {
      const roundKey = 'round' + roundNumber
      const existing = this.interviewProcess.round_results?.[roundKey]
      const existingObj = existing && typeof existing === 'object' ? existing : {}
      this.$set(this.interviewProcess.round_results, roundKey, {
        ...existingObj,
        status: existingObj.status ?? null,
        round_date: existingObj.round_date ?? null,
        comment: comment || null,
        updated_by: this.getCurrentUserEmpId()
      })
    },
    
    /**
     * Set the status for a specific interview round with full metadata
     * If "final_select" is chosen, automatically set status to "Selected" and selection date
     */
    setInterviewRoundStatus(roundNumber, status) {
      const roundKey = 'round' + roundNumber
      const existing = this.interviewProcess.round_results?.[roundKey]
      const existingObj = existing && typeof existing === 'object' ? existing : {}
      this.$set(this.interviewProcess.round_results, roundKey, {
        ...existingObj,
        status: status,
        round_date: existingObj.round_date ?? null,
        comment: existingObj.comment ?? null,
        createdAt: new Date().toISOString(),
        updated_by: this.getCurrentUserEmpId()
      })
      
      // If "final_select" is chosen, or last round is "select", auto-set status to "Selected" (Reliance RPO)
      const totalRounds = this.getInterviewRoundsToUpdate().length
      const isLastRound = roundNumber === totalRounds
      if (status === 'final_select') {
        this.statusCSelected = 'Selected'
        if (!this.selectionDate) {
          this.selectionDate = new Date().toISOString().slice(0, 10) // YYYY-MM-DD
        }
        this.$nextTick(() => {
          this.computeStatusOption()
        })
      } else if (status === 'select' && isLastRound) {
        // Last round marked as Select → auto move to Selected
        this.statusCSelected = 'Selected'
        if (!this.selectionDate) {
          this.selectionDate = new Date().toISOString().slice(0, 10) // YYYY-MM-DD
        }
        this.$nextTick(() => {
          this.computeStatusOption()
        })
      }
    },
    
    /**
     * Load existing interview process data when modal opens.
     * Handles extra_details as object or JSON string (from API).
     */
    loadInterviewProcessData() {
      if (this.client !== 'Reliance RPO' || !this.candidateJobData) {
        this.interviewProcess = { rounds: 1, round_results: {} }
        this.interviewRounds = 1
        return
      }
      let extraDetails = this.candidateJobData.extra_details
      if (typeof extraDetails === 'string') {
        try {
          extraDetails = JSON.parse(extraDetails)
        } catch (_) {
          this.interviewProcess = { rounds: 1, round_results: {} }
          this.interviewRounds = 1
          return
        }
      }
      const process = extraDetails?.interview_process
      if (!process) {
        this.interviewProcess = { rounds: 1, round_results: {} }
        this.interviewRounds = 1
        return
      }
      const roundCount = typeof process.rounds === 'object' ? process.rounds?.value : process.rounds
      const numRounds = Math.max(1, parseInt(roundCount, 10) || 1)
      const roundResults = process.round_results && typeof process.round_results === 'object'
        ? { ...process.round_results }
        : {}
      this.interviewProcess = {
        rounds: numRounds,
        round_results: roundResults
      }
      this.interviewRounds = numRounds
    },
    
    /**
     * Get total number of interview rounds configured
     */
    getTotalInterviewRounds() {
      const rounds = this.getInterviewRoundsToUpdate()
      return rounds.length
    },
    
    /**
     * Get count of completed interview rounds
     */
    getCompletedRoundsCount() {
      const rounds = this.getInterviewRoundsToUpdate()
      return rounds.filter(round => this.getInterviewRoundStatus(round) !== null).length
    },
    
    /**
     * Get count of pending interview rounds
     */
    getPendingRoundsCount() {
      const rounds = this.getInterviewRoundsToUpdate()
      return rounds.filter(round => this.getInterviewRoundStatus(round) === null).length
    },
    
    /**
     * Get badge variant based on round status
     */
    getRoundStatusBadgeVariant(roundNumber) {
      const status = this.getInterviewRoundStatus(roundNumber)
      if (!status) return 'warning' // Pending
      if (status === 'final_select') return 'primary' // Final Select
      return status === 'select' ? 'success' : 'danger' // Select or Reject
    },

    /**
     * Build interview_process payload for save: rounds + round_results trimmed to round1..roundN.
     * Uses interviewRounds (dropdown) as source of truth for N so backend gets the selected round count.
     */
    getInterviewProcessPayloadForSave() {
      const N = Math.max(1, Number(this.interviewRounds) || Number(this.interviewProcess?.rounds) || 1)
      const raw = this.interviewProcess.round_results || {}
      const round_results = {}
      for (let i = 1; i <= N; i++) {
        const key = 'round' + i
        if (raw[key]) round_results[key] = raw[key]
      }
      return {
        rounds: N,
        round_results,
        updatedAt: new Date().toISOString(),
        updated_by: this.getCurrentUserEmpId()
      }
    },

    /**
     * Clear status (and date) for one round
     */
    clearInterviewRoundStatus(roundNumber) {
      const roundKey = 'round' + roundNumber
      this.$set(this.interviewProcess.round_results, roundKey, {
        status: null,
        round_date: null,
        comment: null,
        updated_by: this.getCurrentUserEmpId()
      })
    },

    /**
     * Clear status and date for all rounds (round results reset to empty)
     */
    clearAllInterviewRoundStatuses() {
      const N = Math.max(1, Number(this.interviewProcess.rounds) || 1)
      const round_results = {}
      for (let i = 1; i <= N; i++) {
        round_results['round' + i] = {
          status: null,
          round_date: null,
          comment: null,
          updated_by: this.getCurrentUserEmpId()
        }
      }
      this.interviewProcess.round_results = round_results
    },
    
    // ========== End Interview Process Helper Methods ==========
    
    showNINRModal(val) {
      if (val === 'nr') {
        this.NI = false
      } else {
        this.NI = true
      }
      this.$refs["modal-ni-nr-reason"].show();
    },
    showNotAnsweredModal() {
      this.$refs["modal-na-status"].show();
    },
    showDupModal() {
      this.$refs["modal-dup-status"].show();
    },
    selectCStatus(status) {
      this.statusCSelected = status;

      //this.clicked = true
      ////console.log(this.statusCSelected);
      
      for (var i = 0; i < this.cStatusOption.length; i++) {
        if (this.cStatusOption[i].text === status) {
          document.getElementById(this.cStatusOption[i].text).classList.remove('badge-light')
          document.getElementById(this.cStatusOption[i].text).classList.add('badge-primary')
          var el = document.getElementById(status);
          el.style.color = 'white';
        } else {
          document.getElementById(this.cStatusOption[i].text).classList.remove('badge-primary')
          document.getElementById(this.cStatusOption[i].text).classList.add('badge-light')
          var el = document.getElementById(this.cStatusOption[i].text);
          el.style.color = 'black';
        }
      }
    },
    isLoggedIn() {
      const expireIn = localStorage.getItem('expireIn')
      if (Math.floor(Date.now() / 1000 > expireIn)) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
          ////console.log("called logout")
          localStorage.clear();
          this.$router.push({ name: "auth-login" });
      }
    },
    UpdateNotInterested() {
      this.isLoggedIn()
      this.statusCSelected = 'Not Interested'
      this.candidate_id = this.id
      this.updateCandidateStatus()

    },
    UpdateNotRelevant() {
      this.isLoggedIn()
      this.statusCSelected = 'Not Relevant'
      this.candidate_id = this.id
      this.updateCandidateStatus()
    },
    updateNotAnswered() {
      this.isLoggedIn()
      //console.log('called not answered', this.NA_Reason_Selected.title)
      this.statusCSelected = this.NA_Reason_Selected.title
      this.candidate_id = this.id
      this.updateCandidateStatus()
    },
    updateDuplicate() {
      this.isLoggedIn()
      //console.log('called not answered', this.NA_Reason_Selected.title)
      this.statusCSelected = 'Duplicate'
      this.candidate_id = this.id
      this.updateCandidateStatus()
    },
    updateCandidateStatus() {
      this.isLoggedIn()
      console.log('updateCandidateStatus', this.statusCSelected)
       if (!this.statusCSelected) {
        this.error_status = 'Please Select Status!!'
        //this.$refs["modal-cupdate-status"].show();
        this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Status Not Selected",
                  icon: "EditIcon",
                  variant: "danger",
                },
        });
        return
       }
      ////console.log(this.statusCSelected, this.candidate_id);
      const userData = JSON.parse(localStorage.getItem("userData"));
      //const allUsers = JSON.parse(localStorage.getItem("allusers"));
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
      const username = `${userData.first_name} ${userData.last_name}`
      const useremail = userData.email
      const userEmpId = userData.emp_id
      const userMgr = this.recruiters.filter(item => item.emp_id === userData.mgr_id)
      console.log('Manager Detail:', userMgr)
      const p_mgr_id = userMgr[0].manager
      let status = {}
      let contractDetails = {}
      //console.log('Status Selected', this.statusCSelected)
      // if(this.statusCSelected === 'Joined') {
      //   //console.log('Joining Date', this.joiningDate)
      // }
      if( this.statusCSelected !== 'Not Interested' && this.statusCSelected !== 'Not Relevant' && this.statusCSelected !== 'Duplicate' && this.statusCSelected !== 'Not Answered' && this.statusCSelected !== 'Not Reachable' && this.statusCSelected !== 'Wrong Number' && this.statusCSelected !== 'Call Back' && this.statusCSelected !== 'Shortlisted' && this.statusCSelected !== 'Selected'  && this.statusCSelected !== 'Offered' && this.statusCSelected !== 'Joined' && this.statusCSelected !== 'Early Attrition' && this.statusCSelected !== 'Attrition' && this.statusCSelected !== 'OfferDrop' && this.statusCSelected !== 'NotOffered'  && this.statusCSelected !== 'ProfileShared' && this.statusCSelected !== 'LOI Issued' && this.statusCSelected !== 'Interview') {
        console.log('updateCandidateStatus in 1st if condition', this.statusCSelected)
        status = {
          candidateStatus: this.statusCSelected,
          updatedBy: user,
          //recruiter: userData.emp_id
        };
      } else if(this.statusCSelected === 'Not Interested'){
        
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
            reason: this.NI_Reason_Selected.title,
            comment: this.NI_NR_comment,
            recruiter: userData.emp_id,
            mgr_id: userData.mgr_id,
            p_mgr_id: p_mgr_id,
            // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
            "Manager Name": this.$can('read','talent_acquisition') ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
            "Employee Name": username.toUpperCase(),
          };
      } else if(this.statusCSelected === 'Not Relevant'){
        status = {
          candidateStatus: this.statusCSelected,
          updatedBy: user,
          comment: this.NI_NR_comment,
          recruiter: userData.emp_id,
          mgr_id: userData.mgr_id,
          p_mgr_id: p_mgr_id,
          // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
          "Manager Name": this.$can('read','talent_acquisition') ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
          "Employee Name": username.toUpperCase(),
        };
      }
      else if(this.statusCSelected === 'Duplicate'){
        console.log(this.dupReasonSelected)
        status = {
          candidateStatus: this.statusCSelected,
          updatedBy: user,
          reason: this.dupReasonSelected.title + '| Cooling Time: ' + this.coolingTimeline.value + ' days',
          recruiter: userData.emp_id,
          mgr_id: userData.mgr_id,
          p_mgr_id: p_mgr_id,
          // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
          "Manager Name": this.$can('read','talent_acquisition') ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
          "Employee Name": username.toUpperCase(),
        };
      }
      else if(this.statusCSelected === 'Not Answered' || this.statusCSelected === 'Not Reachable' || this.statusCSelected === 'Wrong Number' || this.statusCSelected === 'Call Back'){
        //console.log('inside NA', this.statusCSelected, this.NA_comment, user)
        status = {
          candidateStatus: this.statusCSelected,
          updatedBy: user,
          recruiter: userData.emp_id,
          mgr_id: userData.mgr_id,
          p_mgr_id: p_mgr_id,
          // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
          "Manager Name": this.$can('read','talent_acquisition') ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
          "Employee Name": username.toUpperCase(),
        };
        const trimmedNaComment = this.sanitizeTimelineText(this.NA_comment)
        const sameStatusCallBack = this.statusCSelected === 'Call Back' && (
          this.timelineStatusesMatch(this.statusCSelected, this.prevStatus)
          || this.timelineStatusesMatch(this.statusCSelected, this.candidateJobData && this.candidateJobData.candidateStatus)
        )
        // Same-status Call Back with a blank field must not wipe candidate_jobs.comment.
        if (trimmedNaComment) {
          status.comment = trimmedNaComment
        } else if (!sameStatusCallBack) {
          status.comment = this.NA_comment
        }
      } else if(this.statusCSelected === 'Interview'){
        console.log('check Documents', this.statusCSelected, this.candidateData.documents, user)

          // if(!this.candidateData.documents.aadhaar  || !this.candidateData.documents.pan || !this.candidateData.documents.photo || (!this.candidateData.documents.skillCertificate && this.skillCertificateAvailable) ) {
  //|| !this.candidateData.documents.bankProof
        if(!this.candidateData.documents && this.client !== 'Reliance RPO') {
            this.error = 'Aadhaar, PAN, Skill Certificate & Photo is mandatory for Interview Status!!'
            this.isValid = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title:  this.error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
            return
            
          }
          this.isValid = true
          this.error = ''
          
          // For Reliance RPO - handle interview process
          if (this.client === 'Reliance RPO') {
            window.__relianceRpoRequestCase = null
            // Check if this is a new Interview status (from ScreenSelect) or updating existing interview
            if (this.prevStatus !== 'Interview') {
              window.__relianceRpoRequestCase = 'Reliance_RPO_MOVING_TO_INTERVIEW'
              // Moving TO Interview - create new interview_process
              const existingExtraDetails = this.candidateJobData.extra_details || {}
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
                extra_details: {
                  ...existingExtraDetails,
                  interview_process: {
                    rounds: this.interviewRounds,
                    round_results: {},
                    createdAt: new Date().toISOString(),
                    updated_by: userEmpId
                  }
                }
              };
              // Store timeline message for setting rounds
              this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Interview-Rounds-${this.interviewRounds}`;
            } else {
              // Already in Interview - updating round results
              const existingExtraDetails = this.candidateJobData.extra_details || {}
              const existingInterviewProcess = existingExtraDetails.interview_process || {}
              window.__relianceRpoRequestCase = null
              const setRequestCase = (caseName) => { window.__relianceRpoRequestCase = caseName }
              
              // Check if any round has status "reject" or "final_select"
              const roundResults = this.interviewProcess.round_results || {}
              const existingRoundResults = existingInterviewProcess.round_results || {}
              let hasRejectedRound = false
              let hasFinalSelect = false
              let rejectedRoundNumber = null
              let finalSelectRoundNumber = null
              let updatedRoundNumber = null
              let updatedRoundStatus = null
              
              // Find which round was updated and if any round is rejected or has final_select
              for (const [roundKey, roundData] of Object.entries(roundResults)) {
                const roundNum = parseInt(roundKey.replace('round', ''))
                const roundStatus = typeof roundData === 'object' ? roundData.status : roundData
                
                // Check if this round was just updated (compare with existing data)
                const existingRoundData = existingRoundResults[roundKey]
                const existingRoundStatus = existingRoundData ? (typeof existingRoundData === 'object' ? existingRoundData.status : existingRoundData) : null
                
                // Round was updated if it didn't exist before or status changed
                if (!existingRoundData || existingRoundStatus !== roundStatus) {
                  // This round was just updated or newly added
                  updatedRoundNumber = roundNum
                  updatedRoundStatus = roundStatus
                }
                
                if (roundStatus === 'reject') {
                  hasRejectedRound = true
                  if (!rejectedRoundNumber) {
                    rejectedRoundNumber = roundNum
                  }
                }
                
                if (roundStatus === 'final_select') {
                  hasFinalSelect = true
                  if (!finalSelectRoundNumber) {
                    finalSelectRoundNumber = roundNum
                  }
                }
              }

              // Round date is mandatory for every round that has a status (select / final_select / reject)
              for (const [roundKey, roundData] of Object.entries(roundResults)) {
                const roundNum = parseInt(roundKey.replace('round', ''))
                const roundStatus = typeof roundData === 'object' ? roundData.status : roundData
                const roundDate = typeof roundData === 'object' ? roundData.round_date : null
                if (roundStatus && (!roundDate || String(roundDate).trim() === '')) {
                  this.error = `Round ${roundNum} date is mandatory when round result is selected.`
                  this.isValid = false
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.error,
                      icon: 'EditIcon',
                      variant: 'danger'
                    }
                  })
                  return
                }
              }

              // Current last round (by interviewRounds) has Select or Final Select → can become Selected
              const totalRounds = Math.max(1, Number(this.interviewRounds) || this.getInterviewRoundsToUpdate().length)
              const lastRoundKey = 'round' + totalRounds
              const lastRoundData = this.interviewProcess.round_results?.[lastRoundKey]
              const lastRoundStatus = lastRoundData && typeof lastRoundData === 'object' ? lastRoundData.status : null
              const hasLastRoundSelect = (lastRoundStatus === 'select' || lastRoundStatus === 'final_select')

              // Branch 1: Any round rejected → Rejected (validate mandatory comment first)
              if (hasRejectedRound) {
                for (const [roundKey, roundData] of Object.entries(roundResults)) {
                  const roundNum = parseInt(roundKey.replace('round', ''))
                  const roundStatus = typeof roundData === 'object' ? roundData.status : roundData
                  const comment = typeof roundData === 'object' ? (roundData.comment || '') : ''
                  if (roundStatus === 'reject' && (!comment || String(comment).trim() === '')) {
                    this.error = `Round ${roundNum} comment is mandatory when result is Reject.`
                    this.isValid = false
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: this.error,
                        icon: 'EditIcon',
                        variant: 'danger'
                      }
                    })
                    return
                  }
                }
                setRequestCase('Reliance_RPO_ROUND_STATUS_CHANGED_REJECT')
                this.statusCSelected = 'Rejected'
                if (updatedRoundNumber && updatedRoundStatus === 'reject') {
                  this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Rejected - Round ${updatedRoundNumber} Reject`
                } else if (rejectedRoundNumber) {
                  this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Rejected - Round ${rejectedRoundNumber} Reject`
                } else {
                  this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Rejected`
                }
                const interviewPayloadRej = this.getInterviewProcessPayloadForSave()
                status = {
                  candidateStatus: 'Rejected',
                  updatedBy: user,
                  extra_details: {
                    ...existingExtraDetails,
                    interview_process: { ...existingInterviewProcess, ...interviewPayloadRej }
                  }
                };
              } else if (hasFinalSelect || hasLastRoundSelect) {
                // Branch 2: Final Select or last round Select → Selected
                setRequestCase(hasFinalSelect ? 'Reliance_RPO_ROUND_STATUS_CHANGED_FINAL_SELECT' : 'Reliance_RPO_ROUND_STATUS_CHANGED_SELECT')
                this.statusCSelected = 'Selected'
                if (!this.selectionDate) {
                  this.selectionDate = new Date().toISOString().slice(0, 10) // YYYY-MM-DD
                }
                if (hasFinalSelect) {
                  if (updatedRoundNumber && updatedRoundStatus === 'final_select') {
                    this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Selected - Round ${updatedRoundNumber} Final Select`
                  } else if (finalSelectRoundNumber) {
                    this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Selected - Round ${finalSelectRoundNumber} Final Select`
                  } else {
                    this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Selected`
                  }
                } else {
                  this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Selected - Round ${totalRounds} Select`
                }
                const interviewPayload = this.getInterviewProcessPayloadForSave()
                status = {
                  candidateStatus: 'Selected',
                  updatedBy: user,
                  selection_date: this.selectionDate,
                  extra_details: {
                    ...existingExtraDetails,
                    interview_process: { ...existingInterviewProcess, ...interviewPayload }
                  }
                };
              } else {
                // Branch 3: Stay Interview (cases 1–3: round updates and/or rounds count change)
                setRequestCase('Reliance_RPO_NUMBER_OF_ROUNDS_CHANGED')
                this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Interview-Rounds-${this.interviewRounds}`
                const interviewPayloadDefault = this.getInterviewProcessPayloadForSave()
                status = {
                  candidateStatus: 'Interview',
                  updatedBy: user,
                  extra_details: {
                    ...existingExtraDetails,
                    interview_process: { ...existingInterviewProcess, ...interviewPayloadDefault }
                  }
                };
              }
            }
          } else {
            // Non-Reliance RPO - original logic
            status = {
              candidateStatus: this.statusCSelected,
              updatedBy: user,
            };
          }
          
      } else if(this.statusCSelected === 'Selected' && this.client === 'Reliance RPO'){
          // If we're updating an existing interview, re-decide status from current round count: only Selected if current last round has select/final_select
          const existingExtraDetailsSel = this.candidateJobData.extra_details || {}
          const existingInterviewProcessSel = existingExtraDetailsSel.interview_process || {}
          if ((this.prevStatus === 'Interview' || (this.candidateJobData && this.candidateJobData.candidateStatus === 'Interview')) && this.hasInterviewProcess) {
            const totalRoundsSel = Math.max(1, Number(this.interviewRounds) || 1)
            const lastRoundKeySel = 'round' + totalRoundsSel
            const lastRoundDataSel = this.interviewProcess.round_results?.[lastRoundKeySel]
            const lastRoundStatusSel = lastRoundDataSel && typeof lastRoundDataSel === 'object' ? lastRoundDataSel.status : null
            const hasLastRoundSelectSel = (lastRoundStatusSel === 'select' || lastRoundStatusSel === 'final_select')
            // If any round has final_select, always send Selected with selection_date (irrespective of number of rounds)
            if (!hasLastRoundSelectSel && !this.hasFinalSelect) {
              // Round date is mandatory for every round that has a status before submitting as Interview
              const roundResultsStay = this.interviewProcess?.round_results || {}
              for (const [roundKey, roundData] of Object.entries(roundResultsStay)) {
                const roundNum = parseInt(roundKey.replace('round', ''), 10)
                const roundStatus = typeof roundData === 'object' ? roundData.status : roundData
                const roundDate = typeof roundData === 'object' ? roundData.round_date : null
                if (roundStatus && (!roundDate || String(roundDate).trim() === '')) {
                  this.error = `Round ${roundNum} date is mandatory when round result is selected.`
                  this.isValid = false
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.error,
                      icon: 'EditIcon',
                      variant: 'danger'
                    }
                  })
                  return
                }
              }
              this.statusCSelected = 'Interview'
              this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Interview-Rounds-${this.interviewRounds}`
              const interviewPayloadStay = this.getInterviewProcessPayloadForSave()
              status = {
                candidateStatus: 'Interview',
                updatedBy: user,
                extra_details: {
                  ...existingExtraDetailsSel,
                  interview_process: { ...existingInterviewProcessSel, ...interviewPayloadStay }
                }
              }
            }
          }
          if (!(status && status.candidateStatus === 'Interview')) {
          // For Reliance RPO Selected status - require selection date
          // Note: If status was set to Selected due to final_select, selection_date is already set
          if (!this.selectionDate) {
            this.error = 'Selection Date is mandatory!!';
            this.isValid = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! " + this.error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
            return;
          }
          this.isValid = true;
          this.error = '';
          
          // If status was already set with final_select (from Interview block), use that status object
          // Otherwise create new status object and include updated interview_process when coming from last-round Select
          if (!status || status.candidateStatus !== 'Selected') {
            const existingExtraDetails = this.candidateJobData.extra_details || {}
            let extra_details = existingExtraDetails
            // Include updated interview_process when we have round_results (e.g. user selected "Select" on last round)
            if (this.hasInterviewProcess && this.interviewProcess?.round_results && Object.keys(this.interviewProcess.round_results).length > 0) {
              // Round date mandatory for every round that has a status
              const roundResults = this.interviewProcess.round_results || {}
              for (const [roundKey, roundData] of Object.entries(roundResults)) {
                const roundNum = parseInt(roundKey.replace('round', ''))
                const roundStatus = typeof roundData === 'object' ? roundData.status : null
                const roundDate = typeof roundData === 'object' ? roundData.round_date : null
                if (roundStatus && (!roundDate || String(roundDate).trim() === '')) {
                  this.error = `Round ${roundNum} date is mandatory when round result is selected.`
                  this.isValid = false
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.error,
                      icon: 'EditIcon',
                      variant: 'danger'
                    }
                  })
                  return
                }
              }
              window.__relianceRpoRequestCase = 'Reliance_RPO_ROUND_STATUS_CHANGED_SELECT_LAST_ROUND'
              const interviewPayload = this.getInterviewProcessPayloadForSave()
              const existingProcess = existingExtraDetails.interview_process || {}
              extra_details = {
                ...existingExtraDetails,
                interview_process: { ...existingProcess, ...interviewPayload }
              }
            }
            status = {
              candidateStatus: this.statusCSelected,
              updatedBy: user,
              selection_date: this.selectionDate,
              extra_details
            };
            if (!this.interviewTimelineMessage) {
              this.interviewTimelineMessage = `Candidate - ${this.id} Status Changes to Selected`;
            }
          }
          }
          
      } else if(this.statusCSelected === 'Shortlisted'|| this.statusCSelected === 'Selected'){
          //console.log('check if update allowed', this.statusCSelected)
          if (!this.selectionDate) {
            this.error = 'Selection Date is mandatory!!';
            this.isValid = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! " + this.error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
            return;
          }

          if (this.blueCollar && !this.candidateData.documents.bankProof && this.client !== 'Intellismart') {
            this.error = 'Bank Proof Document is mandatory for Shortlisted Blue Collar Candidates!!';
            this.isValid = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! " + this.error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
            return;
          }

          this.isValid = true;
          this.error = '';
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
            selection_date: this.selectionDate,
            //recruiter: userData.emp_id
          };
      } else if(this.statusCSelected === 'Offered'){
        console.log('in offered')
        // name: null,
        // contact_no: null,
        // email: null,
        // fatherName: null,
        // gender: null,
        // dob: null,
        // panNumber: null,
        // doj: null,
        // annualCTC: null,
        // title: null,
        // aadhaarNumber: null,
        // accountNumber: null,
        // ifscCode: null,
        // projectName: null,
        // projectLocation: null,
        // projectState: null
        //offeredDate
        
        
        if((!this.offeredDate || !this.offeredCTC || this.offeredCTC < 9999 || !this.variableCTC ) && this.client !== 'Sattva Human Pvt Ltd' && !this.blueCollar && !this.whiteCollarInfra) {
          
            
          this.error = 'Offered Date, Offered CTC, Variable CTC is mandatory & Mention complete CTC in rupees!!'
          this.isValid = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed!!! " + this.error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
          return
          //return this.error
        } else if((!this.offeredDate) && this.client === 'Sattva Human Pvt Ltd' && !this.blueCollar && !this.whiteCollarInfra) {
          
            
          this.error = 'Offered Date is mandatory!!'
          this.isValid = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed!!! " + this.error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
          return
          //return this.error
        } else if (this.blueCollar|| this.whiteCollarInfra) {
          console.log('in offered blue/white collar')
          // this.candidateMetadata.emp_id = this.candidateData.candidate_id
          // this.candidateMetadata.name = this.candidateData.first_name + ' ' + this.candidateData.last_name
          // this.candidateMetadata.contact_no = this.candidateData.contact_no
          // this.candidateMetadata.email = this.candidateData.email
          // this.candidateMetadata.gender = this.candidateData.gender
          // this.candidateMetadata.dob = this.candidateData.dob
          this.candidateMetadata.doj = this.joiningDate
          this.candidateMetadata.offeredDate = this.offeredDate
          this.candidateMetadata.annualCTC = this.offeredCTC || this.variableCTC

          console.log('candidate metadata: ', this.candidateMetadata,this.offeredCTC, this.variableCTC)

          const aadhaarRegex = /^\d{12}$/;

          // Remove any spaces the user typed
          const rawAadhaar = this.candidateMetadata.aadhaarNumber.replace(/\s+/g, '');

          // Validate
          if (!aadhaarRegex.test(rawAadhaar)) {
            // this.errors.aadhaarNumber = 'Please enter a valid 12-digit Aadhaar number.';
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! Please enter a valid 12-digit Aadhaar Number",
                icon: "EditIcon",
                variant: "danger",
              },
            });
            this.error = "Please enter a valid 12-digit Aadhaar Number."
            return;
          }

          const uppercasePan = this.candidateMetadata.panNumber.toUpperCase();
          const panRegex = /^[A-Z]{5}\d{4}[A-Z]$/;
          
          // Validate
          if (!panRegex.test(uppercasePan)) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! Please enter a valid 10-character PAN (e.g. ABCDE1234F).",
                icon: "EditIcon",
                variant: "danger",
              },
            });
            this.error = "Please enter a valid 10-character PAN (e.g. ABCDE1234F)."
            return;
          }

          // Validate re-enter PAN number
          if (!this.reenterPanNumber) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! Please re-enter the PAN number.",
                icon: "EditIcon",
                variant: "danger",
              },
            });
            this.error = "Please re-enter the PAN number."
            return;
          }

          const uppercaseReenterPan = this.reenterPanNumber.toUpperCase();
          if (!panRegex.test(uppercaseReenterPan)) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! Please enter a valid 10-character PAN in re-enter field (e.g. ABCDE1234F).",
                icon: "EditIcon",
                variant: "danger",
              },
            });
            this.error = "Please enter a valid 10-character PAN in re-enter field (e.g. ABCDE1234F)."
            return;
          }

          // Check if both PAN numbers match
          if (uppercasePan !== uppercaseReenterPan) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! PAN numbers do not match.",
                icon: "EditIcon",
                variant: "danger",
              },
            });
            this.error = "PAN numbers do not match."
            return;
          }

          // Validate Bank Account Number (skip for Intellismart client)
          if (this.client !== 'Intellismart') {
            const accountNumberRegex = /^\d+$/;
            if (!accountNumberRegex.test(this.candidateMetadata.accountNumber)) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Please enter a valid bank account number (numbers only).",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Please enter a valid bank account number (numbers only)."
              return;
            }

            // Validate re-enter Bank Account Number
            if (!this.reenterAccountNumber) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Please re-enter the bank account number.",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Please re-enter the bank account number."
              return;
            }

            if (!accountNumberRegex.test(this.reenterAccountNumber)) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Please enter a valid bank account number in re-enter field (numbers only).",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Please enter a valid bank account number in re-enter field (numbers only)."
              return;
            }

            // Check if both account numbers match
            if (this.candidateMetadata.accountNumber !== this.reenterAccountNumber) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Bank account numbers do not match.",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Bank account numbers do not match."
              return;
            }

            // Validate Bank IFSC Code
            const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
            const uppercaseIfsc = this.candidateMetadata.ifscCode.toUpperCase();
            if (!ifscRegex.test(uppercaseIfsc)) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Please enter a valid IFSC code (e.g., SBIN0001234).",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Please enter a valid IFSC code (e.g., SBIN0001234)."
              return;
            }

            // Validate re-enter Bank IFSC Code
            if (!this.reenterIfscCode) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Please re-enter the bank IFSC code.",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Please re-enter the bank IFSC code."
              return;
            }

            const uppercaseReenterIfsc = this.reenterIfscCode.toUpperCase();
            if (!ifscRegex.test(uppercaseReenterIfsc)) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Please enter a valid IFSC code in re-enter field (e.g., SBIN0001234).",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Please enter a valid IFSC code in re-enter field (e.g., SBIN0001234)."
              return;
            }

            // Check if both IFSC codes match
            if (uppercaseIfsc !== uppercaseReenterIfsc) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Failed!!! Bank IFSC codes do not match.",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
              this.error = "Bank IFSC codes do not match."
              return;
            }
          }

          // Build mandatory fields check - exclude accountNumber and ifscCode for Intellismart
          const mandatoryFieldsCheck = !this.offeredDate || !this.offeredCTC || !this.candidateMetadata.title || !this.candidateMetadata.projectName || !this.candidateMetadata.projectLocation || !this.candidateMetadata.projectState || !this.candidateMetadata.aadhaarNumber || !this.candidateMetadata.panNumber || !this.joiningDate || this.offeredCTC < 9999;
          const accountIfscCheck = this.client !== 'Intellismart' && (!this.candidateMetadata.accountNumber || !this.candidateMetadata.ifscCode);
          if((mandatoryFieldsCheck || accountIfscCheck) && this.client !== 'Sattva Human Pvt Ltd') {
            
            this.error = 'Note!!! "*" Fields are mandatory!!'
            console.log(' offered status update: ', this.offeredDate, this.offeredCTC, this.joiningDate, this.candidateMetadata)
            this.isValid = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! " + this.error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
            return
            //return this.error
          }

          this.candidateMetadata.panNumber = this.candidateMetadata.panNumber.toUpperCase()
          this.candidateMetadata.aadhaarNumber = this.candidateMetadata.aadhaarNumber.toUpperCase()
          // UAN number should be kept as is (12 digits)
          const dupCheck = {
                panNumber: this.candidateMetadata.panNumber,
                aadhaarNumber: this.candidateMetadata.aadhaarNumber,
                uanNumber: this.candidateMetadata.uanNumber
              }
          candidateService.checkCandidateExistWithMetadata(dupCheck).then(res =>{
              console.log('check can exist with metadata:', res)
              this.candidateDupResponse = res.data.data
              if(res.data.status === 'OK' ) {
                console.log('New Candidate', this.duplicateMailAlert)
                this.duplicateMailAlert = false
              } else if (res.data.status === 'MULTI') {
                this.duplicateMailAlert = true
                // this.candidateMetadata.isDuplicate = true
                console.log('Multi Candidate', this.duplicateMailAlert)
              } else if (res.data.status === 'EXIST') {
                this.duplicateMailAlert = true
                // this.candidateMetadata.isDuplicate = true
                console.log('One Candidate Already Exist', this.duplicateMailAlert)
              } else if (res.data.status === 'NOTASSIGNED') {
                this.duplicateMailAlert = false
                console.log('Candidate not assigned to job', this.duplicateMailAlert)
              }
          })
          if(this.duplicateMailAlert) {
            this.candidateMetadata.isDuplicate = true
          }                
        }
          this.isValid = true
          this.error = ''
          
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
            offered_date: this.offeredDate,
            joining_date: this.joiningDate,
            offered_ctc: this.offeredCTC,
            variable_ctc: this.variableCTC,
            // band: this.band
            //recruiter: userData.emp_id
          };  
          status.metadata = this.candidateMetadata

          console.log('metedata final data: ', status.metadata)
          
      } else if(this.statusCSelected === 'Joined'){
        this.candidateMetadata.doj = null
        console.log('joined status update: ', this.joiningDate, this.candidateMetadata.doj)
        //console.log('check if update allowed', this.statusCSelected, this.joiningDate)
        if((this.positionType === 'Contractual' || this.positionType === 'Cost Plus') && this.category === 'White Collar' && this.payroll === 'Sattva Payroll') {
          if(!this.joiningDate && !this.contractStartDate && !this.contractEndDate && !this.rateCard && !this.monthlyCTC && !this.probationDays) {
            this.error = 'All Fields are mandatory !!'
            this.isValid = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! " + this.error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
            return
          }
        } else {
          if(!this.joiningDate) {
            this.error = 'Joining Date is mandatory !!'
            this.isValid = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Failed!!! " + this.error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
            return
          }
        }
        // if(this.blueCollar) {
          this.candidateMetadata.doj = this.joiningDate
           console.log('joined status update: ', this.joiningDate, this.candidateMetadata.doj) 
        // }
        
        this.isValid = true
          this.error = ''
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
            joining_date: this.joiningDate
            //recruiter: userData.emp_id
          };
          status.metadata = this.candidateMetadata
          // if(this.positionType === 'Contractual' && this.vertical === 'Service Industry' && this.category === 'White Collar' && this.payroll === 'Sattva Payroll') {
          if((this.positionType === 'Contractual' || this.positionType === 'Cost Plus') && this.category === 'White Collar' && this.payroll === 'Sattva Payroll') {
            contractDetails = {
              contractStartDate: this.contractStartDate,
              contractEndDate: this.contractEndDate,
              rateCard: this.rateCard,
              monthlyCTC: this.monthlyCTC,
              probationDays: this.probationDays,
              status: 'ACTIVE'
            }
            status.contractDetails = contractDetails
          }
          
      } else if(this.statusCSelected === 'OfferDrop' || this.statusCSelected === 'NotOffered'){
        //console.log('check if update allowed', this.statusCSelected)
        if(!this.dropReason || this.dropReason.length < 1) {
          this.error = 'Drop Reason is mandatory !!'
          this.isValid = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed!!! " + this.error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
          return
        }
        this.isValid = true
        this.error = ''
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
            drop_reason: this.dropReason
          };
      } else if(this.statusCSelected === 'ProfileShared' ){
        //console.log('check if update allowed', this.statusCSelected)
        console.log('updateCandidateStatus in ProfileShared', this.statusCSelected)
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
            recruiter: userData.emp_id,
            mgr_id: userData.mgr_id,
            p_mgr_id: p_mgr_id,
            // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
            "Manager Name": this.$can('read','talent_acquisition') ? userMgr[0].title.toUpperCase() : username.toUpperCase(),
            "Employee Name": username.toUpperCase(),

          };
      } else if(this.statusCSelected === 'Early Attrition' || this.statusCSelected === 'Attrition'){
        ////console.log(this.joiningDate)
        //console.log('check if update allowed', this.statusCSelected, this.joiningDate)
        if(!this.attritionDate) {
          this.error = 'Attrition Date is mandatory !!'
          this.isValid = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed!!! " + this.error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
          return
        } 
        this.isValid = true
          this.error = ''
          status = {
            candidateStatus: this.statusCSelected,
            updatedBy: user,
            attrition_date: this.attritionDate
            //recruiter: userData.emp_id
          };
      } else if(this.statusCSelected === 'LOI Issued' && this.prevStatus === 'Joined'){
        //console.log('check if update allowed', this.statusCSelected)
        // if(!this.selectionDate) {
        //   this.error = 'Selection Date is mandatory !!'
        //   //return this.error
        //   this.isValid = false
        //   this.$toast({
        //     component: ToastificationContent,
        //     props: {
        //       title: "Failed!!! " + this.error,
        //       icon: "EditIcon",
        //       variant: "danger",
        //     },
        //   });
        //   return
        // }  
        // this.isValid = true
        //   this.error = ''
          status = {
            candidateStatus: this.prevStatus,
            updatedBy: user,
            // loi_issued: true,
            // comment: 'NO LOI SENT'
              //recruiter: userData.emp_id
          };
      }

      //else if(this.statusCSelected === 'Document Submitted' ){
      //   //console.log('check if update allowed', this.statusCSelected)
        
      //     status = {
      //       candidateStatus: this.statusCSelected,
      //       updatedBy: user,
      //     };
      // }

      // KPMG RPO specific status handling
      if (this.client === 'KPMG RPO') {
        // Only update offerProcess if coming from KPMG modals
        if (this.isKPMGOfferProcessUpdate || this.isKPMGBGVProcessUpdate) {
          status.offerProcess = this.offerProcess;
        }
        
        // Handle HR Discussion rejection
        if ((this.statusCSelected === 'Shortlisted' || this.statusCSelected === 'Offered') && this.offerProcess.hrDiscussion.status === 'Rejected') {
          this.statusCSelected = 'NotOffered';
          status.candidateStatus = 'NotOffered';
        }
        
        // Handle BGV failure
        if ((this.statusCSelected === 'Shortlisted' || this.statusCSelected === 'Offered') && this.offerProcess.bgv.status === 'Failed') {
          this.statusCSelected = 'NotOffered';
          status.candidateStatus = 'NotOffered';
        }
      }
      
      console.log('status check ',status, this.attritionDate) 
      //console.log('check if update allowed',this.selectionDate, this.offeredDate, this.joiningDate, this.error, this.isvalid)
      if(this.isValid === true) {

        // Use custom timeline message for Reliance RPO interview process, otherwise use default
        const timelineTitle = this.interviewTimelineMessage || `Candidate - ${this.id} Status Changes to ${this.statusCSelected}`
        const timelineComment = this.NA_comment || this.NI_NR_comment || ''

        const timelineData = {
                title: timelineTitle,
                // job_timeline.create persists description, not comment — keep CS-Changed when empty
                description: timelineComment || `CS-Changed`,
                type: "success",
                createdBy: username,
                jobId: this.jobId,
                action: 'candidate-view',
                candidate_id: this.id,
                candidateStatus: this.statusCSelected,
                source: (this.candidateJobData && this.candidateJobData.source) || (this.candidateData && this.candidateData.source) || '',
                comment: timelineComment,
                reason: (this.NI_Reason_Selected && this.NI_Reason_Selected.title) || '',
              }

        status.jt = timelineData  
        // Reset interview timeline message after use
        this.interviewTimelineMessage = null  
        // if(status.candidateStatus === 'Joined') {

        // }

        // Log Reliance RPO request for debugging: case (1=rounds changed, 2=round status changed) and full payload
        if (this.client === 'Reliance RPO' && status && status.extra_details && status.extra_details.interview_process) {
          const caseName = window.__relianceRpoRequestCase || 'Reliance_RPO_OTHER'
          const interviewProcess = status.extra_details.interview_process
          const req = {
            case: caseName,
            candidate_id: this.id,
            job_id: this.jobId,
            body: status,
            interview_process_sent: {
              rounds: interviewProcess.rounds,
              round_results: interviewProcess.round_results,
              updatedAt: interviewProcess.updatedAt,
              updated_by: interviewProcess.updated_by
            }
          }
          console.log('[Reliance RPO] Update Candidate Status – CASE:', caseName)
          console.log('[Reliance RPO] Full API request (copy for backend):', JSON.stringify({ candidate_id: this.id, job_id: this.jobId, body: status }, null, 2))
          console.log('[Reliance RPO] interview_process sent (rounds + round_results):', JSON.stringify(req.interview_process_sent, null, 2))
        }

        CandidateService.updateCandidateStatus(this.id, this.jobId, status).then(
          (res) => {
            
            if (res.status === "OK") {
              console.log('candidate updated:', res.data);
              const updateCandidateResponse = res.data
              
              if(!this.recruiter || this.recruiter === 'ATS' || this.recruiter === 'Sattva') {
                this.$router.push({
                //name: this.$route.name, // Assuming you are using named routes
                query: {
                  //...this.$route.query, // Spread operator to copy all existing query params
                  recruiter: userEmpId, // Update the recruiter query parameter
                  position_name: this.$route.query.position_name,
                  client: this.$route.query.client,
                  attachments: this.$route.query.attachments,
                  locations: this.$route.query.locations,
                  sourcer: this.$route.query.sourcer,
                  am_name: this.$route.query.am_name,
                  job_id: this.$route.query.job_id,
                  jobPage: this.$route.query.page,
                  positionType: this.$route.query.position_type,
                  category: this.$route.query.category,
                  payroll: this.$route.query.payroll,
                  vertical: this.$route.query.vertical
                }
              });
              }
              // if(this.userRole === 'TALENT-ADVISOR-SOURCER' ) {
              // if(this.$can('read','talent_acquisition') ) {
              console.log('recruiter data b4', this.recruiter)
              this.recruiter = !this.recruiter || this.recruiter === 'ATS' || this.recruiter === 'Sattva' ? userEmpId : this.recruiter;
              // } else {
                
              // }
              console.log('recruiter data after', this.recruiter, userEmpId)

              
              //console.log(timelineData);
              const rec = this.recruiters.filter(item => item.emp_id === this.recruiter)
              console.log('filtered',rec, this.recruiter)
              const rec_email = rec[0].email
              const rec_name = rec[0].title
              //const rec_empid = recruiter[0].emp_id
              const rec_mgr = rec[0].manager
              const tl = this.recruiters.filter(item => item.emp_id === rec_mgr)
              console.log('recruiter',rec, rec_email, tl)
              const tl_name = tl[0].title
              let tl_email = tl[0].email
              const infra_email = this.vertical === 'Infra Industry' ? ',sumeet.upadhye@sattvahuman.com' : ''
              tl_email = tl_email + infra_email
              console.log('recruiter mail data:',rec, rec_email, tl, tl_email)
              const acc_mgr = this.recruiters.filter(item => item.title === this.am_name)
              //console.log('acc manager', acc_mgr)
              const am_email = acc_mgr.length > 0 ? acc_mgr[0].email : ''
              const sourcer = this.recruiters.filter(item => item.title === this.sourcer)
              //console.log('sourcer', sourcer)
              const sourcer_email = sourcer.length > 0 ? sourcer[0].email : ''
              const sourcer_name = sourcer.length > 0 ? sourcer[0].title : ''
              const can_tmp = this.candidateJobs.filter(item => item.id === this.jobId)
              const can = can_tmp.length > 0 ? can_tmp[0] : []
              const added_on = can ? moment(can.createdAt).format("DD MMM YYYY") : ''
              //console.log('can', can, can_tmp)
              //const source = can ? can.source : ''

//              jobTimelineService.create(timelineData).then(res => {
//                console.log("timeline", res)
                  if(this.statusCSelected === "ProfileShared" && this.jobId) {
                    
                      //const recruiter = this.recruiters.filter(item => item.title === this.rec_name)
                      //const rec_email = recruiter[0].email
                      
                      if(rec_email) {
                        //console.log('client', this.client, this.locations, this.attachments, this.position_name, this.rec_name)
                        if( this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies' && this.client !== 'AXA XL-RR' && this.client !== 'Wipro RPO' && this.client !== 'Vector3 Digital Tech' && this.client !== 'Larsen & Toubro' && this.client !== 'Zamil Steel') {
                          const mailData = {
                            can_email: this.candidateData.email,
                            can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
                            can_contact: this.candidateData.contact_no,
                            can_position: this.candidateData.curr_position,
                            can_company: this.candidateData.curr_company,
                            can_qualification: this.candidateData.qualification,
                            can_gender: this.candidateData.gender,
                            can_dob: this.candidateData.dob == '1900-01-01' ? '' : this.candidateData.dob,
                            can_exp: this.candidateData.exp,
                            can_ctc: this.candidateData.ctc,
                            can_exp_ctc: this.candidateData.exp_ctc,
                            can_skills: this.candidateData.skills,
                            can_city: this.candidateData.curr_location,
                            can_pref_city: this.candidateData.pref_location,
                            can_notice_period: this.candidateData.notice_period,
                            cv_file: this.candidateData.cv_path, 
                            am_email: `${useremail}` === 'sattva.delhi@sattvahuman.com' ? '' : useremail,
                            position_name: this.position_name,
                            client: this.client,
                            location: this.locations,
                            rec_email: rec_email,
                            rec_name: rec_name,
                            jd_file: this.attachments ? this.attachments : null//.replace("/","%2F")                     
                          }
                          //console.log("in if mail-1", mailData)
                          let mail = ''
                          if (this.attachments) {
                            mail = emailTemplates.candidateProfileShared(mailData)
                          } else {
                            mail = emailTemplates.candidateProfileSharedNoJD(mailData)
                          }
                          const mail_body = {
                            ...mail, // Use Sequelize's .dataValues to get a plain object of the model
                            timeline_id: updateCandidateResponse.timeline // Append the newly created timeline object
                          };
                          //console.log("in if mail-2", mail)
                          if (mail && process.env.NODE_ENV === "production") {
                            mailService.mail(mail_body).then(res => {
                              //console.log("in if mail-2", res)
                            })
                          }
                        }
                      }
                    //})
                  
                  } else if ((this.statusCSelected === "Shortlisted" || this.statusCSelected === "Selected") && this.jobId) {
                    
                      //console.log('recruiter',rec, rec_email, am_email, rec_name)
                      
                      // const selectionDate = can ? moment(can.selection_date).format("DD MMM YYYY") : ''
                      // const offeredDate = can ? moment(can.offered_date).format("DD MMM YYYY") : ''
                      // const joiningDate = can ? moment(can.joiining_date).format("DD MMM YYYY") : ''
                      if(rec_email) {
                        //console.log('client', this.client, this.locations, this.attachments, this.position_name, this.rec_name)
                        //if( this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies'  && this.client !== 'Wipro RPO') {
                          const mailData = {
                            can_email: this.candidateData.email,
                            can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
                            can_contact: this.candidateData.contact_no,
                            can_id: this.candidateData.candidate_id,
                            position_name: this.position_name,
                            job_id: this.jobCode,
                            client: this.client,
                            location: this.locations,
                            rec_email: rec_email,
                            rec_name: rec_name,
                            tl_name: tl_name,
                            tl_email: tl_email,
                            sourcer_name: sourcer_name,
                            sourcer_email: sourcer_email,
                            am_email: am_email,
                            am_name: this.am_name,
                            added_on:  moment(added_on).format("DD MMM YYYY"),
                            selection_date: this.selectionDate ? moment(this.selectionDate).format("DD MMM YYYY") : 'Not Available',
                            source: can.source
                          }
                          //console.log("in if mail-1", mailData)
                          let mail = emailTemplates.selectionInternalMail(mailData)
                          const mail_body = {
                            ...mail, // Use Sequelize's .dataValues to get a plain object of the model
                            timeline_id: updateCandidateResponse.timeline // Append the newly created timeline object
                          };
                          //console.log("in if mail-2", mail)
                          //if (mail && process.env.NODE_ENV === "production") {
                            if (mail && process.env.NODE_ENV === "production") {  
                            mailService.mail(mail_body).then(res => {
                              //console.log("in if mail-2", res)
                            })
                          }
                        //}
                      }
                  } else if (this.statusCSelected === "Offered" && this.jobId) {
                    
                    //console.log('recruiter',rec, rec_email, am_email, rec_name)
                    if(rec_email) {
                      //console.log('client', this.client, this.locations, this.attachments, this.position_name, this.rec_name)
                      //if( this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies'  && this.client !== 'Wipro RPO') {
                        const mailData = {
                          can_email: this.candidateData.email,
                          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
                          can_contact: this.candidateData.contact_no,
                          can_id: this.candidateData.candidate_id,
                          position_name: this.position_name,
                          job_id: this.jobCode,
                          client: this.client,
                          location: this.locations,
                          rec_email: rec_email,
                          rec_name: rec_name,
                          tl_name: tl_name,
                          tl_email: tl_email,
                          sourcer_name: sourcer_name,
                          sourcer_email: sourcer_email,
                          am_email: am_email,
                          am_name: this.am_name,
                          added_on:  moment(added_on).format("DD MMM YYYY"),
                          selection_date: can.selection_date ? moment(can.selection_date).format("DD MMM YYYY") : 'Not Available',
                          offered_date: this.offeredDate ? moment(this.offeredDate).format("DD MMM YYYY") : 'Not Available',
                          joining_date: this.joiningDate ? moment(this.joiningDate).format("DD MMM YYYY") : 'Not Available',
                          offered_ctc: this.offeredCTC ? this.offeredCTC : 'Not Available',
                          source: can.source
                        }
                        //console.log("in if mail-1", mailData)
                        let mail = emailTemplates.offeredInternalMail(mailData)
                        // let this.duplicateMailAlert = false
                        if(this.blueCollar || this.whiteCollarInfra) {
                          
                          // let mailExistData = {}
                          
                          

                            if(this.duplicateMailAlert) {
                             const mailExistData = {
                                newName: this.candidateData.first_name || ' ' || this.candidateData.last_name,
                                newId: this.candidateData.candidate_id,
                                newPositionName: this.jobCode || ' - ' || this.position_name,
                                newDate: this.candidateData.createdAt,
                                newRecruiter: rec_name,
                                newAadhaar: this.candidateMetadata.aadhaarNumber,
                                newPan: this.candidateMetadata.panNumber,
                                oldName: this.candidateDupResponse.name,
                                oldId: this.candidateDupResponse.can_id,
                                oldPositionName: this.candidateDupResponse.job_id || ' - ' || this.candidateDupResponse.position_name,
                                oldDate: this.candidateDupResponse.created_at,
                                oldRecruiter: this.candidateDupResponse.recruiter,
                                oldAadhaar: this.candidateDupResponse.aadhaar,
                                oldPan: this.candidateDupResponse.pan,
                                oldStatus: this.candidateDupResponse.status,
                                name: this.candidateMetadata.aadhaarName,
                                projectName: this.candidateMetadata.projectName
                              }

                              const dupCheckWithMetadata = emailTemplates.duplicateCandidateFoundAlert(mailExistData)
                              console.log('in dup mail before send', dupCheckWithMetadata)
                              mailService.mail(dupCheckWithMetadata).then(res => {
                                console.log('In Blue Collar offer Mail 4 mail sent ',res)
                             })

                            }

                          //})

                          console.log('In Blue Collar offer Mail')
                          const offerData = {
                            name: this.candidateMetadata.aadhaarName || this.candidateData.first_name || ' ' ||  this.candidateData.last_name,
                            candidate_id: this.candidateData.candidate_id,
                            job_id: this.jobCode,
                            position_name: this.position_name,
                            client: this.client,
                            rec_email: rec_email,
                            rec_name: rec_name,
                            tl_name: tl_name,
                            tl_email: tl_email,
                            am_email: am_email,
                            projectName: this.candidateMetadata.projectName,
                            projectLocation: this.candidateMetadata.projectLocation,
                            title: this.candidateMetadata.title,
                            ctc: this.offeredCTC ? this.offeredCTC : 'Not Available',
                            doj: this.joiningDate ? moment(this.joiningDate).format("DD MMM YYYY") : 'Not Available',
                            remarks: this.duplicateMailAlert ? '!!!NOTE!!!: Another Candidate matching PAN/Aadhaar is already present in ATS, Please do not release offer letter. You might receive one more mail with Duplicacy Alert!' : ''
                          }
                          console.log('In Blue Collar offer Mail 1',offerData)
                          const mailOfferLetter = emailTemplates.offerLetterReleaseNotificationMail(offerData)
                          console.log('In Blue Collar offer Mail 2',mailOfferLetter)
                          // if (mailOfferLetter && process.env.NODE_ENV === "production") {
                          if (mailOfferLetter) {
                            // const offerMailBody = {
                            //   ...mailOfferLetter
                            // }
                            // console.log('In Blue Collar offer Mail 3',offerMailBody)

                            mailService.mail(mailOfferLetter).then(res => {
                              console.log('In Blue Collar offer Mail 4 mail sent ',res)
                            })
                          }
                        }
                        const mail_body = {
                            ...mail, // Use Sequelize's .dataValues to get a plain object of the model
                            timeline_id: updateCandidateResponse.timeline // Append the newly created timeline object
                        };
                        //console.log("in if mail-2", mail)
                        if (mail && process.env.NODE_ENV === "production") {
                          mailService.mail(mail_body).then(res => {
                            //console.log("in if mail-2", res)
                          })
                        }
                      //}
                    }
                } else if (this.statusCSelected === "Joined" && this.jobId) {
                    
                    //console.log('recruiter',rec, rec_email, am_email, rec_name)
                    if(rec_email) {
                      //console.log('client', this.client, this.locations, this.attachments, this.position_name, this.rec_name)
                      //if( this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies'  && this.client !== 'Wipro RPO') {
                        const mailData = {
                          can_email: this.candidateData.email,
                          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
                          can_contact: this.candidateData.contact_no,
                          can_id: this.candidateData.candidate_id,
                          position_name: this.position_name,
                          job_id: this.jobCode,
                          client: this.client,
                          location: this.locations,
                          rec_email: rec_email,
                          rec_name: rec_name,
                          tl_name: tl_name,
                          tl_email: tl_email,
                          sourcer_name: sourcer_name,
                          sourcer_email: sourcer_email,
                          am_email: am_email,
                          am_name: this.am_name,
                          added_on:  moment(added_on).format("DD MMM YYYY"),
                          selection_date: can.selection_date ? moment(can.selection_date).format("DD MMM YYYY") : 'Not Available',
                          offered_date: can.offered_date ? moment(can.offered_date).format("DD MMM YYYY") : 'Not Available',
                          joining_date: this.joiningDate ? moment(this.joiningDate).format("DD MMM YYYY") : 'Not Available',
                          offered_ctc: can.offered_ctc ? can.offered_ctc : 'Not Available',
                          revenue: can.revenue ? can.revenue : 'Not Available',
                          source: can.source
                        }
                        console.log("in if mail-1", mailData)
                        if(this.blueCollar || this.whiteCollarInfra) {
                          const payrollFile = this.payrollFile()
                          console.log('In Blue Collar pyaroll add Mail', payrollFile, this.jobCode, this.offeredCTC)
                          const offerData = {
                            name: this.candidateMetadata.aadhaarName || this.candidateData.first_name || ' ' ||  this.candidateData.last_name,
                            candidate_id: this.candidateData.candidate_id,
                            job_id: this.jobCode,
                            position_name: this.position_name,
                            client: this.client,
                            rec_email: rec_email,
                            rec_name: rec_name,
                            tl_name: tl_name,
                            tl_email: tl_email,
                            am_email: am_email,
                            projectName: this.candidateMetadata.projectName,
                            projectLocation: this.candidateMetadata.projectLocation,
                            title: this.candidateMetadata.title,
                            ctc: this.candidateMetadata.annualCTC,
                            doj: this.joiningDate ? moment(this.joiningDate).format("DD MMM YYYY") : 'Not Available',
                            file: payrollFile,
                            url: window.location.href
                          }
                          
                          console.log('In Blue Collar offer Mail 1',offerData)
                          const mailOfferLetter = emailTemplates.payrollOnboardingNotificationMail(offerData)
                          console.log('In Blue Collar offer Mail 2',mailOfferLetter)
                          // if (mailOfferLetter && process.env.NODE_ENV === "production") {
                          if (mailOfferLetter) {
                            mailService.mailWithAttachment(mailOfferLetter).then(res => {
                              console.log('In Blue Collar offer Mail 4 mail sent ',res)
                            })
                          }
                        }

                        let mail = emailTemplates.joinedInternalMail(mailData)
                        const mail_body = {
                            ...mail, // Use Sequelize's .dataValues to get a plain object of the model
                            timeline_id: updateCandidateResponse.timeline // Append the newly created timeline object
                        };
                        console.log("in if mail-2", mail)
                         if (mail && process.env.NODE_ENV === "production") {
                          mailService.mail(mail_body).then(res => {
                            //console.log("in if mail-2", res)
                          })
                         }
                      //}
                    }
                } else if ((this.statusCSelected === "OfferDrop" || this.statusCSelected === 'NotOffered' || this.statusCSelected === 'Early Attrition' || this.statusCSelected === 'Attrition') && this.jobId) {
                    
                    //console.log('recruiter',rec, rec_email, am_email, rec_name)
                    if(rec_email) {
                      //console.log('client', this.client, this.locations, this.attachments, this.position_name, this.rec_name)
                      //if( this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies'  && this.client !== 'Wipro RPO') {
                        const mailData = {
                          can_email: this.candidateData.email,
                          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
                          can_contact: this.candidateData.contact_no,
                          can_id: this.candidateData.candidate_id,
                          position_name: this.position_name,
                          job_id: this.jobCode,
                          client: this.client,
                          location: this.locations,
                          rec_email: rec_email,
                          rec_name: rec_name,
                          tl_name: tl_name,
                          tl_email: tl_email,
                          sourcer_name: sourcer_name,
                          sourcer_email: sourcer_email,
                          am_email: am_email,
                          am_name: this.am_name,
                          added_on:  moment(added_on).format("DD MMM YYYY"),
                          selection_date: can.selection_date ? moment(can.selection_date).format("DD MMM YYYY") : 'Not Available',
                          offered_date: can.offered_date ? moment(can.offered_date).format("DD MMM YYYY") : 'Not Available',
                          joining_date: can.joining_date ? moment(can.joining_date).format("DD MMM YYYY") : 'Not Available',
                          drop_reason: this.dropReason,
                          offered_ctc: can.offered_ctc ? can.offered_ctc : 'Not Available',
                          revenue: can.revenue ? can.revenue : 'Not Available',
                          source: can.source,
                          status: this.statusCSelected
                        }
                        
                        //console.log("in if mail-1", mailData)
                        let mail = emailTemplates.offerDropInternalMail(mailData)
                        // mail.cid = this.id
                        // mail.jid = this.jobId
                        const mail_body = {
                            ...mail, // Use Sequelize's .dataValues to get a plain object of the model
                            timeline_id: updateCandidateResponse.timeline // Append the newly created timeline object
                        };
                        //console.log("in if mail-2", mail)
                        if (mail && process.env.NODE_ENV === "production") {
                          mailService.mail(mail_body).then(res => {
                            //console.log("in if mail-2", res)
                          })
                        }
                      //}
                    }
                }
                else if (this.statusCSelected === "Document Submitted"  && this.jobId) {
                    
                    //console.log('recruiter',rec, rec_email, am_email, rec_name)
                    if(rec_email) {
                      //console.log('client', this.client, this.locations, this.attachments, this.position_name, this.rec_name)
                      //if( this.client !== 'LTI RPO' && this.client !== 'Dummy' && this.client !== 'Sonata Technologies'  && this.client !== 'Wipro RPO') {
                        const mailData = {
                          can_email: this.candidateData.email,
                          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
                          can_contact: this.candidateData.contact_no,
                          can_id: this.candidateData.candidate_id,
                          position_name: this.position_name,
                          job_id: this.jobCode,
                          client: this.client,
                          location: this.locations,
                          rec_email: rec_email,
                          rec_name: rec_name,
                          tl_name: tl_name,
                          tl_email: tl_email,
                          status: this.statusCSelected,
                          url: 'https://ats.sattvahuman.in/#' + this.$route.fullPath
                        }
                        console.log("in if mail-1", mailData)
                        let mail = emailTemplates.documentSubmittedMail(mailData)
                        // mail.cid = this.id
                        // mail.jid = this.jobId
                        const mail_body = {
                            ...mail, // Use Sequelize's .dataValues to get a plain object of the model
                            timeline_id: updateCandidateResponse.timeline // Append the newly created timeline object
                        };
                        console.log("in if mail-2", mail)
                        if (mail && process.env.NODE_ENV === "production") {
                          if (mail) {  
                            mailService.mail(mail_body).then(res => {
                              //console.log("in if mail-2", res)
                            })
                          }
                        }
                    }
                }
              this.statusCSelected = null

//              })
              CandidateService.getCandidateCurrentStatus(this.id, this.jobId).then( res => {
                if (res.status === 'OK' && res.data && res.data.length > 0) {
                  //console.log('candidate status', res)
                  this.prevStatus = res.data[0].candidateStatus
                } else {
                  console.log('No candidate status data found or empty array')
                  this.prevStatus = null
                }
              })
              this.getCandidateData();
              // Reset reenter fields after successful submission
              this.reenterPanNumber = '';
              this.reenterUanNumber = '';
              this.reenterAccountNumber = '';
              this.reenterIfscCode = '';
              
              // Reset KPMG modal update flags after successful submission
              this.isKPMGOfferProcessUpdate = false;
              this.isKPMGBGVProcessUpdate = false;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Candidate Status Updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              
            } else if ((res.status === 401 ) || (res.status === 403 )) {
              window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
              localStorage.clear();
              this.$router.push({ name: "auth-login" });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Candidate Status Update Failed",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          }
      );
    }  else {
      this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed!!! " + this.error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
    }
    this.NI_NR_comment = null
    },
    doCopy(email) {
      this.$copyText(email).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Email copied',
            icon: 'BellIcon',
          },
        })
      }, e => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Can not copy!',
            icon: 'BellIcon',
          },
        })
      })
    },
    CandidateBelongsToJob() {
        
        //console.log('check update button visible')
        const isAssignedToThisJob = this.candidateJobs.filter(item => item.id == this.jobId)
        let visible = false;
        const currentUserRole = JSON.parse(localStorage.getItem("userData")).roles[0];
        const empId = JSON.parse(localStorage.getItem("userData")).emp_id;
        let currentStatus = ''

        if (isAssignedToThisJob.length > 0) {
          currentStatus = isAssignedToThisJob[0].candidateStatus

          if(currentStatus === 'ReviewReject' || currentStatus === 'ScreenReject' || currentStatus === 'Duplicate' || currentStatus === 'Rejected' || currentStatus === 'NotOffered' || currentStatus === 'OfferDrop' || currentStatus === 'UploadedBySourcer' || currentStatus === 'UploadedByRecruiter' || currentStatus === 'AssignedByMassMail' || currentStatus === 'Not Relevant' || currentStatus === 'Not Interested' || currentStatus === 'Not Answered' || currentStatus === 'Not Interested' || currentStatus === 'Not Reachable' || currentStatus === 'Wrong Number'  || currentStatus === 'Call Back' || currentStatus === 'Drop')   {
            visible = false
            return
          }
          //console.log(isAssignedToThisJob, currentUserRole, empId, currentStatus)  
          //console.log(isAssignedToThisJob.length > 0 &&  (currentUserRole === 'ADMIN' || currentUserRole === 'MASTER' || currentUserRole === 'MIS' || currentUserRole === 'HR') && (currentStatus !== 'UploadedBySourcer' || currentStatus !== 'UploadedByRecruiter'  || currentStatus !== 'AssignedByMassMail' || currentStatus !== 'Not Answered' || currentStatus !== 'Not Reachable' || currentStatus !== 'Wrong Number'  || currentStatus !== 'Call Back' || currentStatus === 'ReviewReject' || currentStatus === 'ScreenReject' || currentStatus === 'Rejected' || currentStatus === 'Duplicate' || currentStatus === 'NotOffered' || currentStatus === 'Joined' || currentStatus === 'OfferDrop'))
        } else {
          //console.log('Not assigned to this Job')
        }
        if (isAssignedToThisJob.length > 0 && (this.$can('read','admin') || this.$can('read','master') || this.$can('read','hr_head')) && (currentStatus !== 'UploadedBySourcer' && currentStatus !== 'UploadedByRecruiter' && currentStatus !== 'AssignedByMassMail' && currentStatus !== 'Not Answered' && currentStatus !== 'Not Interested' && currentStatus !== 'Not Reachable' && currentStatus !== 'Wrong Number'  && currentStatus !== 'Call Back' )) {
        // if (isAssignedToThisJob.length > 0 && (currentUserRole === 'ADMIN' || currentUserRole === 'MASTER' || currentUserRole === 'HR') && (currentStatus !== 'UploadedBySourcer' && currentStatus !== 'UploadedByRecruiter' && currentStatus !== 'AssignedByMassMail' && currentStatus !== 'Not Answered' && currentStatus !== 'Not Interested' && currentStatus !== 'Not Reachable' && currentStatus !== 'Wrong Number'  && currentStatus !== 'Call Back' )) {
          visible = true
          //console.log('ADMIN visisble', visible)
        } else if (isAssignedToThisJob.length > 0 && (currentStatus !== 'UploadedBySourcer' || currentStatus !== 'UploadedByRecruiter' || currentStatus !== 'AssignedByMassMail' || currentStatus !== 'AssignedByATSSourcer' || currentStatus !== 'AssignedByATSMassMailer' || currentStatus !== 'Not Answered' || currentStatus !== 'Not Reachable' || currentStatus !== 'Wrong Number'  || currentStatus !== 'Call Back' || currentStatus === 'ReviewReject' || currentStatus === 'ScreenReject' || currentStatus === 'Rejected' || currentStatus === 'Duplicate' || currentStatus === 'NotOffered' || currentStatus === 'Joined' || currentStatus === 'OfferDrop')) {  
          // if(this.client === 'Sattva Human Pvt Ltd' && (currentUserRole === 'TALENT-ADVISOR' || currentUserRole === 'TALENT-ADVISOR-SOURCER' || currentUserRole === 'ACCOUNT-MANAGER' || currentUserRole === 'PROGRAM-MANAGER' || currentUserRole === 'MIS')) {
          if(this.isSattvaHumanClient && this.isSattvaRestrictedRole) {
            visible = false
            this.showCandidateDetails = false
          }
          const hasCurrentUserAdded = isAssignedToThisJob[0].recruiter
          const isAMForTheJob = JSON.parse(isAssignedToThisJob[0].account_mgr)[0].emp_id
          const isMgr = isAssignedToThisJob[0].mgr_id
          //console.log('mgr', isMgr)
          const isPMgr = isAssignedToThisJob[0].p_mgr_id
          const hascurentUserUpdated = isAssignedToThisJob[0].sourcer
          //console.log(hasCurrentUserAdded, isAMForTheJob)
          //console.log('can job update', isAssignedToThisJob, currentUserRole, currentStatus, hasCurrentUserAdded, isAMForTheJob, empId)
          if((String(hasCurrentUserAdded) === String(empId) || String(isAMForTheJob) === String(empId) || String(isMgr) === String(empId) || String(hascurentUserUpdated) === String(empId))) {
            if(isAMForTheJob === empId || isMgr === empId || currentUserRole === 'ACCOUNT-MANAGER') {
              visible = true
              // if(this.client === 'Sattva Human Pvt Ltd' && (currentUserRole === 'TALENT-ADVISOR' || currentUserRole === 'TALENT-ADVISOR-SOURCER' || currentUserRole === 'ACCOUNT-MANAGER' || currentUserRole === 'PROGRAM-MANAGER' || currentUserRole === 'MIS')) {
              if(this.isSattvaHumanClient && this.isSattvaRestrictedRole) {
                visible = false
                this.showCandidateDetails = false
              }
            }
            if((this.$can('read','talent_acquisition') || this.$can('read','mis')) && currentStatus !== 'Initiated') {
              visible = true
              if(this.isSattvaHumanClient && this.isSattvaRestrictedRole) {
                visible = false
                this.showCandidateDetails = false
              }
            } else if ((!this.$can('read','talent_acquisition')) && currentStatus === 'Initiated') {
            // } else if ((currentUserRole !== 'TALENT-ADVISOR' || currentUserRole !== 'TALENT-ADVISOR-SOURCER') && currentStatus === 'Initiated') {
              if(this.isSattvaHumanClient && this.isSattvaRestrictedRole) {
                visible = false
                this.showCandidateDetails = false
              }
              //this.pausedFor7Seconds = true
              visible = true
              setTimeout(() => this.pausedFor7Seconds = false, 7000);
              
            } else if ((!this.$can('read','talent_acquisition')) && currentStatus !== 'Initiated') {
              visible = true
            } else {
              visible = false
            }
          } else {
            visible = false
          }
        } else if (this.vertical === 'Infra Industry' && this.$can('update','vertical_infra') && this.$can('update','vertical_data')) {
          visible = true
        } else if (this.vertical === 'Service Industry' && this.$can('update','vertical_service') && this.$can('update','vertical_data')) {
          visible = true
        } else if ((this.vertical === 'Service Industry' || this.vertical === 'Infra Industry') && this.$can('manage','vertical_service') && this.$can('manage','vertical_data')) {
          visible = true
        }
        else {
          visible = false
        }
        
      
      return visible //this.candidateData.jobs.filter(item => item.id == this.jobId)
    },
    CandidateBelongsToSourcerJob() {
        const isAssignedToThisJob = this.candidateJobs.filter(item => item.id == this.jobId)
        if (!isAssignedToThisJob.length) return false
        const currentStatus = isAssignedToThisJob[0].candidateStatus
        // For early-stage statuses, show Interested/NI/etc. buttons to all users — no ownership check.
        const earlyStatuses = [
          'UploadedBySourcer', 'UploadedByRecruiter', 'AssignedByMassMail',
          'AssignedByATSSourcer', 'AssignedByATSMassMailer',
          'Not Answered', 'Not Reachable', 'Wrong Number', 'Call Back',
          'Not Interested', 'Not Relevant', 'Duplicate',
        ]
        return earlyStatuses.includes(currentStatus)
    },
    isArray(a) {
      return (!!a) && (a.constructor === Array);
    },
    isObject(a) {
      return (!!a) && (a.constructor === Object);
    },
    updateCandidateNINRReason() {
      if (this.NI) {
        this.statusCSelected = 'Not Interested'
        if(this.NI_Reason_Selected !== '' & this.NI_NR_comment !== '') {
          this.updateCandidateStatus()
        } else {
          this.error_NI_NR_comment = 'Reason & comment is mandatory'
          this.$refs["modal-ni-nr-reason"].show();
        }
      } else if (!this.NI) {
        this.statusCSelected = 'Not Relevant'
        if(this.NI_NR_comment !== '') {
          this.updateCandidateStatus()
        } else {
          this.error_NI_NR_comment = 'Comment is mandatory'
          this.$refs["modal-ni-nr-reason"].show();
        }
      }
    },
    showDocuploadModal(id) {
      this.$refs["modal-doc-upload"].show();
    },
    // showGenerateOfferModal(id) {
    //   this.$refs["modal-generate-offer-letter"].show();
    // },
    /** Stored S3/local key for an infra KYC doc type (used for replace / orphan cleanup). */
    getInfraDocKey(docType) {
      const docs = this.candidateData && this.candidateData.documents
      if (!docs) return null
      if (docType === 'aadhaar_front') return docs.aadhaar_front || docs.aadhaar || null
      if (docType === 'aadhaar_back') return docs.aadhaar_back || null
      if (docType === 'aadhaar') return docs.aadhaar || null
      if (docType === 'pan') return docs.pan || null
      if (docType === 'photo') return docs.photo || null
      if (docType === 'skillCertificate') return docs.skillCertificate || null
      if (docType === 'bankProof') return docs.bankProof || null
      return null
    },
    /** Tell upload APIs this is a replace so they can remove the previous object after success. */
    appendInfraDocReplaceFields(formData, oldFile) {
      if (!oldFile) return
      formData.append('replace', 'true')
      formData.append('oldFile', oldFile)
    },
    /**
     * After docs refresh: if the pointer moved to a new key, best-effort delete the old object.
     * Never called before upload succeeds. Skips when keys match (in-place overwrite).
     */
    cleanupReplacedInfraDoc(oldFile, documentType) {
      if (!oldFile) return
      const current = this.getInfraDocKey(documentType)
      if (current && current === oldFile) return
      CandidateService.deleteInfraCanDocument({
        id: this.id,
        documentType,
        oldFile,
      })
    },
    uploadAadhaar() {
     console.log('in upload Docs', this.documents.aadhaarCard)
      const oldFile = this.getInfraDocKey('aadhaar')
      const formData = new FormData();
      formData.append('aadhaarFile', this.documents.aadhaarCard)
      formData.append('id', this.id)
      this.appendInfraDocReplaceFields(formData, oldFile)
      this.loadingAadhaar = true
      CandidateService.uploadInfraCanAadhaar(formData).then(res => {
        console.log('in called api:', res.data)
        if(res.status === 200) {
          this.loadingAadhaar = false
          this.aadhaarUploaded = true
          this.showAadhaarUpload = false
          this.candidateMetadata = res.data.data.metadata
          // this.metadataDownload.push(this.candidateMetadata) 
          CandidateService.getCandidateDocuments(this.id).then(res => {
            if(res.status === 200) {
              this.candidateData.documents = res.data.data.documents
              this.cleanupReplacedInfraDoc(oldFile, 'aadhaar')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Uploaded Successfully",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Upload Failed!!! Please try again!",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          })
        } else {
          this.loadingAadhaar = false
          this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.status + "!!! " + res.data.message,
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
        }
      })
    },
    uploadAadhaarFront() {
      console.log('in upload Aadhaar Front', this.documents.aadhaarCardFront)
      const oldFile = this.getInfraDocKey('aadhaar_front')
      const formData = new FormData();
      formData.append('aadhaarFile', this.documents.aadhaarCardFront)
      formData.append('id', this.id)
      formData.append('aadhaarType', 'front')
      this.appendInfraDocReplaceFields(formData, oldFile)
      this.loadingAadhaarFront = true
      CandidateService.uploadInfraCanAadhaar(formData).then(res => {
        console.log('in called api:', res.data)
        if(res.status === 200) {
          this.loadingAadhaarFront = false
          this.aadhaarFrontUploaded = true
          this.showAadhaarFrontUpload = false
          this.candidateMetadata = res.data.data.metadata
          CandidateService.getCandidateDocuments(this.id).then(res => {
            if(res.status === 200) {
              this.candidateData.documents = res.data.data.documents
              this.cleanupReplacedInfraDoc(oldFile, 'aadhaar_front')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Aadhaar Front Uploaded Successfully",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Upload Failed!!! Please try again!",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          })
        } else {
          this.loadingAadhaarFront = false
          this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.status + "!!! " + res.data.message,
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
        }
      })
    },
    uploadAadhaarBack() {
      console.log('in upload Aadhaar Back', this.documents.aadhaarCardBack)
      const oldFile = this.getInfraDocKey('aadhaar_back')
      const formData = new FormData();
      formData.append('aadhaarFile', this.documents.aadhaarCardBack)
      formData.append('id', this.id)
      formData.append('aadhaarType', 'back')
      this.appendInfraDocReplaceFields(formData, oldFile)
      this.loadingAadhaarBack = true
      CandidateService.uploadInfraCanAadhaar(formData).then(res => {
        console.log('in called api:', res.data)
        if(res.status === 200) {
          this.loadingAadhaarBack = false
          this.aadhaarBackUploaded = true
          this.showAadhaarBackUpload = false
          this.candidateMetadata = res.data.data.metadata
          CandidateService.getCandidateDocuments(this.id).then(res => {
            if(res.status === 200) {
              this.candidateData.documents = res.data.data.documents
              this.cleanupReplacedInfraDoc(oldFile, 'aadhaar_back')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Aadhaar Back Uploaded Successfully",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Upload Failed!!! Please try again!",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          })
        } else {
          this.loadingAadhaarBack = false
          this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.status + "!!! " + res.data.message,
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
        }
      })
    },
    uploadPan() {
     console.log('in upload Docs')
      const oldFile = this.getInfraDocKey('pan')
      const formData = new FormData();
      this.loadingPan = true
      formData.append('panFile', this.documents.panCard)
      formData.append('id', this.id)
      this.appendInfraDocReplaceFields(formData, oldFile)

      CandidateService.uploadInfraCanPan(formData).then(res => {
        console.log('in called api:', res.data.data)
        if(res.status === 200) {
          this.loadingPan = false
          this.panUploaded = true
          this.showPanUpload = false
          // this.candidateMetadata.panNumber = res.data.data.parse.panNumber
          this.candidateMetadata = res.data.data.metadata
          CandidateService.getCandidateDocuments( this.id).then(res => {
            if(res.status === 200) {
              this.candidateData.documents = res.data.data.documents
              this.cleanupReplacedInfraDoc(oldFile, 'pan')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Uploaded Successfully",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Upload Failed!!! Please try again!",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          })
        } else {
          this.loadingPan = false
          this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.status + "!!! " + res.data.message,
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
        }
      })
    },
    uploadPhoto() {
     console.log('in upload Docs')
      const oldFile = this.getInfraDocKey('photo')
      const formData = new FormData();
      this.loadingPhoto = true
      formData.append('photoFile', this.documents.passportPhoto)
      formData.append('id', this.id)
      this.appendInfraDocReplaceFields(formData, oldFile)

      CandidateService.uploadInfraCanPhoto(formData).then(res => {
        console.log('in called api:', res)
        if(res.status === 200) {
          this.loadingPhoto = false
          this.photoUploaded = true
          this.showPhotoUpload = false
          CandidateService.getCandidateDocuments( this.id).then(res => {
            if(res.status === 200) {
              this.candidateData.documents = res.data.data.documents
              this.cleanupReplacedInfraDoc(oldFile, 'photo')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Uploaded Successfully",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Upload Failed!!! Please try again!",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          })
        }
      })
    },
    uploadCertificate() {
     console.log('in upload Docs')
      const oldFile = this.getInfraDocKey('skillCertificate')
      const formData = new FormData();
      this.loadingCertificate = true
      formData.append('certificateFile', this.documents.skillCertificate)
      formData.append('id', this.id)
      this.appendInfraDocReplaceFields(formData, oldFile)

      CandidateService.uploadInfraCanCertificate(formData).then(res => {
        console.log('in called api:', res)
        if(res.status === 200) {
          this.loadingCertificate = false
          this.certificateUploaded = true
          this.showCertificateUpload = false
          CandidateService.getCandidateDocuments( this.id).then(res => {
            if(res.status === 200) {
              this.candidateData.documents = res.data.data.documents
              this.cleanupReplacedInfraDoc(oldFile, 'skillCertificate')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Uploaded Successfully",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "File Upload Failed!!! Please try again!",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            }
          })
        }
      })
    },
    uploadBank() {
     console.log('in upload Docs')
      const oldFile = this.getInfraDocKey('bankProof')
      const formData = new FormData();
      this.loadingBankDoc = true
      formData.append('bankFile', this.documents.bankProof)
      formData.append('id', this.id)
      this.appendInfraDocReplaceFields(formData, oldFile)

      CandidateService.uploadInfraCanBank(formData).then(res => {
        console.log('in called api:', res)
        if(res.status === 200) {
          this.loadingBankDoc = false
          this.bankUploaded = true
          this.showBankUpload = false
          CandidateService.getCandidateDocuments(this.id).then(res => {
            if(res.status === 200) {
              console.log('candidate docs bank: ',res.data)
              this.candidateData.documents = res.data.data.documents
              this.cleanupReplacedInfraDoc(oldFile, 'bankProof')
            }
          })
        }
      })
    },
    reUploadAadhaar() {
      this.showAadhaarUpload = !this.showAadhaarUpload
    },
    reUploadAadhaarFront() {
      this.showAadhaarFrontUpload = !this.showAadhaarFrontUpload
    },
    reUploadAadhaarBack() {
      this.showAadhaarBackUpload = !this.showAadhaarBackUpload
    },
    hasAadhaarUploaded() {
      // Check if either legacy single file OR new front/back files exist
      if (!this.candidateData || !this.candidateData.documents) return false
      
      return (this.candidateData.documents.aadhaar) || 
             (this.candidateData.documents.aadhaar_front && 
              this.candidateData.documents.aadhaar_back)
    },
    reUploadPan() {
      this.showPanUpload = !this.showPanUpload
    },
    reUploadPhoto() {
      this.showPhotoUpload = !this.showPhotoUpload
    },
    reUploadCertificate() {
      this.showCertificateUpload = !this.showCertificateUpload
    },
    reUploadBank() {
      this.showBankUpload = !this.showBankUpload
    },
    previewFile(type) {
      let key = null
      if(type === 'aadhaar') {
        key = this.candidateData.documents.aadhaar.replace("/","%2F")
      }
      if(type === 'aadhaar_front') {
        // Check new format first (aadhaar_front), then fall back to old format (aadhaar)
        if(this.candidateData.documents.aadhaar_front) {
          key = this.candidateData.documents.aadhaar_front.replace("/","%2F")
        } else if(this.candidateData.documents.aadhaar) {
          // Backward compatible: front was stored as 'aadhaar' key
          key = this.candidateData.documents.aadhaar.replace("/","%2F")
        }
      }
      if(type === 'aadhaar_back') {
        // Back is stored as 'aadhaar_back' key
        if(this.candidateData.documents.aadhaar_back) {
          key = this.candidateData.documents.aadhaar_back.replace("/","%2F")
        }
      }
      if(type === 'pan') {
        key = this.candidateData.documents.pan.replace("/","%2F")
      }
      if(type === 'photo') {
        key = this.candidateData.documents.photo.replace("/","%2F")
      }
      if(type === 'skillCertificate') {
        key = this.candidateData.documents.skillCertificate.replace("/","%2F")
      }
      if(type === 'bankProof') {
        key = this.candidateData.documents.bankProof.replace("/","%2F")
      }
      const temp = key.split(".");
      const cStatus = this.candidateJobs.filter(item => item.id === this.jobId )[0]
      this.prevStatus = cStatus ? cStatus.candidateStatus : ''
      const extension = temp[temp.length - 1]; 

      const fileFormat = extension === 'jpg' ? 'image/jpg' : extension === 'jpeg' ? 'image/jpeg' : extension === 'png' ? 'image/png' : extension === 'pdf' ? 'application/pdf' : ''

      JobService.getFileBase64(key)
      .then(res => {
        ////console.log(res)
        const base64 = res.file;
        //var encodedUrl = encodeURIComponent(res.file);
        this.canDocLink = "data:" + fileFormat +";base64," + base64
                  
      });
      // JobService.getFile(key)
      // .then(res => {
      //   this.docDownloadlink = res.file;
      // })
      this.$refs["doc-preview-modal"].show();
    },
    downloadFile(type) {
      this.canDocLink = null
      let key = null
      if(type === 'aadhaar') {
        key = this.candidateData.documents.aadhaar.replace("/","%2F")
      }
      if(type === 'aadhaar_front') {
        // Check new format first (aadhaar_front), then fall back to old format (aadhaar)
        if(this.candidateData.documents.aadhaar_front) {
          key = this.candidateData.documents.aadhaar_front.replace("/","%2F")
        } else if(this.candidateData.documents.aadhaar) {
          // Backward compatible: front was stored as 'aadhaar' key
          key = this.candidateData.documents.aadhaar.replace("/","%2F")
        }
      }
      if(type === 'aadhaar_back') {
        // Back is stored as 'aadhaar_back' key
        if(this.candidateData.documents.aadhaar_back) {
          key = this.candidateData.documents.aadhaar_back.replace("/","%2F")
        }
      }
      if(type === 'pan') {
        key = this.candidateData.documents.pan.replace("/","%2F")
      }
      if(type === 'photo') {
        key = this.candidateData.documents.photo.replace("/","%2F")
      }
      if(type === 'skillCertificate') {
        key = this.candidateData.documents.skillCertificate.replace("/","%2F")
      }
      if(type === 'bankProof') {
        key = this.candidateData.documents.bankProof.replace("/","%2F")
      }
      const temp = key.split(".");
      const cStatus = this.candidateJobs.filter(item => item.id === this.jobId )[0]
      this.prevStatus = cStatus ? cStatus.candidateStatus : ''
      const extension = temp[temp.length - 1]; 

      const fileFormat = extension === 'jpg' ? 'image/jpg' : extension === 'jpeg' ? 'image/jpeg' : extension === 'png' ? 'image/png' : extension === 'pdf' ? 'application/pdf' : ''
      
      JobService.getFileBase64(key)
      .then(res => {
        ////console.log(res)
        const base64 = res.file;
        //var encodedUrl = encodeURIComponent(res.file);
        this.canDocLink = "data:" + fileFormat +";base64," + base64
        const a = document.createElement('a')
        a.href = this.canDocLink 
        a.download = `${key}` // File name Here
        a.click()
      });
      
    },
    
    downloadCV() {
      // Prevent default behavior
      event.preventDefault();
      
      // Get the file key from the candidate's CV path
      const key = this.candidateData.cv_path.replace("/", "%2F");
      
      // Get the file extension to determine the file type
      const temp = key.split(".");
      const extension = temp[temp.length - 1];
      
      // Determine the file format based on extension
      const fileFormat = extension === 'pdf' ? 'application/pdf' : 
                         extension === 'doc' ? 'application/msword' : 
                         extension === 'docx' ? 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : 
                         'application/octet-stream';
      
      // Use getFileBase64 to get the file content as base64
      JobService.getFileBase64(key)
        .then(res => {
          if (res && res.file) {
            // Create a data URL from the base64 content
            const dataUrl = `data:${fileFormat};base64,${res.file}`;
            
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = dataUrl;
            link.setAttribute('download', `${this.candidateData.first_name}_${this.candidateData.last_name}_CV.${extension}`);
            
            // Append to body, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            console.error('Failed to get file content');
            this.$bvToast.toast('Failed to download CV', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch(error => {
          console.error('Error downloading CV:', error);
          this.$bvToast.toast('Failed to download CV', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        });
    },
    downloadCandidateMetadata() {
      this.metadataDownload = []

      const data = {
        "Employee Number": this.candidateData.candidate_id,
        "Name": this.candidateMetadata.aadhaarName || (this.candidateData.first_name + ' ' + this.candidateData.last_name),
        "Joining Date": this.formatDatePayroll(this.candidateMetadata.doj),
        "Date Of Birth": this.formatDatePayroll(this.candidateData.dob || '1900-01-01'),
        "Employee Status": this.candidateMetadata.employeeStatus || "",
        "Gender": this.candidateData.gender === 'Male' ? 'M' : this.candidateData.gender === 'Female' ? 'F' : '',
        "Email Address": this.candidateData.email,
        "Pan Number": this.candidateMetadata.panNumber,
        "Blood Group": this.candidateMetadata.bloodGroup || "",
        "Manager's Employee No": this.candidateMetadata.managerEmpNo || "",
        "Emergency Contact No": this.candidateMetadata.emergencyContactNo || null,
        "Bank Account Nuumber": this.candidateMetadata.accountNumber,
        "IFSC Code": this.candidateMetadata.ifscCode,
        "Bank Account Type": this.candidateMetadata.accountType || "",
        "Bank Name": this.candidateMetadata.bankName || "",
        "Branch Name": this.candidateMetadata.branchName || "",
        "Payment Mode": this.candidateMetadata.paymentMode || "Bank Transfer",
        "ESI Number": this.candidateMetadata.esiNumber || "",
        "Is employee covered under LWF?": this.candidateMetadata.lwfCovered || "",
        "Name (As on Aadhaar Card)": this.candidateMetadata.aadhaarName || (this.candidateData.first_name + ' ' + this.candidateData.last_name),
        "Aadhaar Card Number": this.candidateMetadata.aadhaarNumber,
        "Universal Account Number": this.candidateMetadata.uanNumber || "",
        "Mobile Number": this.candidateData.contact_no,
        "Country Of Origin": this.candidateMetadata.countryOfOrigin || "India",
        "Division": this.candidateMetadata.division || "",
        "Grade": this.candidateMetadata.grade || "",
        "Designation": this.candidateMetadata.title || "",
        "Location": this.candidateMetadata.projectState || this.candidateData.curr_location || "",
        "Department": this.candidateMetadata.projectName || "",
        "Company": this.candidateMetadata.company || "",
        "Cost Center": this.candidateMetadata.projectName + ' - ' + (this.candidateMetadata.projectState || this.candidateData.curr_location || "") || ""
      }
      this.metadataDownload.push(data)

      const worksheetData = this.metadataDownload.map((item) => {
        // Exclude any Vue.js observer properties
            const { __ob__, ...exportItem } = item;
            return exportItem;
        });

        // Create a worksheet
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);

        // Create a workbook and add the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Employee Onboarding');

        // Generate a buffer
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Create a Blob from the buffer
        const blob = new Blob([wbout], { type: 'application/octet-stream' });

        const dateNow = new Date()
        // Convert Blob to File
        const file = new File([blob], `Employee_Onboarding_${this.candidateData.candidate_id}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Use FileSaver to save the file
        saveAs(blob, `Employee_Onboarding_${this.candidateData.candidate_id}.xlsx`);

        return file;

    },
    payrollFile() {
      this.metadataDownload = []

      const data = {
        "Employee ID": this.candidateData.candidate_id,
        "Name": this.candidateMetadata.aadhaarName || this.candidateData.first_name + ' ' + this.candidateData.last_name,
        "Email": this.candidateData.email,
        "Date of Hiring": this.formatDatePayroll(this.candidateMetadata.doj),
        "Professional Tax Location (State)": this.candidateMetadata.projectState,
        "Title": this.candidateMetadata.title,
        "Department": this.candidateMetadata.projectName,
        "Annual CTC": this.offeredCTC,
        "PAN": this.candidateMetadata.panNumber,
        "Provident Fund (Y/N)": "N",
        "PF UAN": null,
        "ESIC Number": null,
        "Taxable salary paid in current F.Y. till now by curent employer outside XPayroll *" : null,
        "Exemptions in current F.Y. till now * (HRA exemption etc. by current employer)": null,
        "TDS deducted in current F.Y. till now *( Amount already deducted and paid for TDS)": null,
        "Past Taxable Salary(Amount paid to the employee by previous employer(s))": null,
        "Past TDS(Amount already deducted and paid for TDS by past employer(s))": null,
        "Phone Number": this.candidateData.contact_no,
        "Gender (M/F/Other)": this.candidateData.gender === 'Male' ? 'M' : this.candidateData.gender === 'Female' ? 'F' : '',
        "Date of Birth (dd/mm/yyyy)": this.formatDatePayroll(this.candidateData.dob || '1900-01-01'),
        "Bank Account Number": this.candidateMetadata.accountNumber,
        "Bank IFSC Code": this.candidateMetadata.ifscCode,
        "Aadhaar Number": this.candidateMetadata.aadhaarNumber
      }
      this.metadataDownload.push(data)

      const worksheetData = this.metadataDownload.map((item) => {
        // Exclude any Vue.js observer properties
            const { __ob__, ...exportItem } = item;
            return exportItem;
        });

        // Create a worksheet
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);

        // Create a workbook and add the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Employee Onboarding');

        // Generate a buffer
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Create a Blob from the buffer
        const blob = new Blob([wbout], { type: 'application/octet-stream' });

        const dateNow = new Date()
        // Convert Blob to File
        const file = new File([blob], `Employee_Onboarding_${this.candidateData.candidate_id}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Use FileSaver to save the file
        // saveAs(blob, `Employee_Onboarding_${this.candidateData.candidate_id}.xlsx`);

        return file;

    },
    
    formatDatePayroll(dateStr) {
      console.log(dateStr, this.candidateData.dob, this.joiningDate)
      let [year, month, day] = dateStr.split("-");
      return `${day}/${month}/${year}`;
    },
    // computeDocumentDone() {
    //   console.log('in compute', this.prevStatus)
    //   if(this.prevStatus === 'Confirmed') {
    //     console.log('in compute if loop')
    //     if(this.candidateData.documents.aadhaar  && this.candidateData.documents.pan && this.candidateData.documents.photo && (this.candidateData.documents.skillCertificate || !this.skillCertificateAvailable) && this.candidateData.documents.bankProof) {
    //       this.statusCSelected = 'Document Submitted'
    //       this.updateCandidateStatus()
    //       this.prevStatus = this.statusCSelected
    //     }
    //   }
    // },
    // checkAllDocSubmitted() {
    //   if(this.candidateData.documents.aadhaar  && this.candidateData.documents.pan && this.candidateData.documents.photo && (this.candidateData.documents.skillCertificate || !this.skillCertificateAvailable) && this.candidateData.documents.bankProof) {
    //     this.statusCSelected = 'Document Submitted'
    //     this.updateCandidateStatus()
    //     this.prevStatus = this.statusCSelected
    //   }
    // },
    setContractStartDate() {
      if(this.positionType === 'Contractual' && this.payroll === 'Sattva Payroll' && this.vertical === 'Service Industry' && this.category === 'White Collar') {
        this.contractStartDate = this.joiningDate
      } 
    },
    isValidJson(str) {
      try {
        JSON.parse(str)
        return true
      } catch (err) {
        return false
      }
    },
    toggleNoteInput() {
      this.showNoteInput = !this.showNoteInput;
      if (!this.showNoteInput) {
        // Clear the note input when hiding
        this.newNote = '';
      }
    },
    addNote() {
      if (!this.newNote.trim()) return;
      
      const note = {
        content: this.newNote,
        addedBy: `${JSON.parse(localStorage.getItem('userData')).first_name} ${JSON.parse(localStorage.getItem('userData')).last_name}`,
        addedOn: new Date().toISOString()
      };
      
      this.notes.unshift(note);
      this.newNote = '';
      this.showNoteInput = false; // Hide the input after adding note
      
      this.$bvToast.toast('Note added successfully', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    formatNoteDate(date) {
      if (!date) return '';
      
      const options = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      
      return new Date(date).toLocaleString('en-US', options);
    },
    formatKey(key) {
      // Convert snake_case or camelCase to Title Case with spaces
      return key
        .replace(/_/g, ' ')
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    },

    // Payroll Modal Methods
    async openPayrollModal() {
      // Check payroll approval status
      try {
        const statusResponse = await CandidateService.getPayrollApprovalStatus(this.candidateData.id);
        if (statusResponse.status === 'OK') {
          this.payrollApprovalStatus = statusResponse.data.status;
        }
      } catch (error) {
        console.error('Error fetching payroll approval status:', error);
        this.payrollApprovalStatus = null;
      }
      
      // Pre-populate form with candidate metadata
      this.payrollForm = {
        project: this.candidateMetadata.projectName || null,
        location: this.candidateMetadata.projectLocation || this.candidateData.curr_location || null,
        joiningDate: this.candidateMetadata.doj || null,
        offeredGross: null,
        accountNumberChecked: false,
        ifscCodeChecked: false,
        panNumberChecked: false,
        offerLetter: null,
        salaryModel: null,
        benefitsIncluded: [],
        submitting: false,
        reenterAccountNumber: '',
        accountNumberMismatch: false,
        reenterIfscCode: '',
        ifscCodeMismatch: false,
        reenterPanNumber: '',
        panNumberMismatch: false
      }
      
      this.$bvModal.show('payroll-modal')
    },

    async submitPayrollData(bvModalEvent) {
      // Prevent modal from closing if validation fails
      bvModalEvent.preventDefault()
      
      // Validate required fields
      if (!this.payrollForm.project) {
        this.$bvToast.toast('Please select a project', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }
      
      if (!this.payrollForm.location) {
        this.$bvToast.toast('Please select a location', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }
      
      if (!this.payrollForm.joiningDate) {
        this.$bvToast.toast('Please select joining date', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }
      
      if (!this.payrollForm.offeredGross) {
        this.$bvToast.toast('Please enter offered gross amount', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      // Validate Smart Meter project fields
      if (this.isSmartMeterProject && !this.payrollForm.salaryModel) {
        this.$bvToast.toast('Please select a salary model', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (this.isSmartMeterProject && (this.payrollForm.salaryModel === 'proRata' || this.payrollForm.salaryModel === 'fixed') && (!this.payrollForm.benefitsIncluded || this.payrollForm.benefitsIncluded.length === 0)) {
        this.$bvToast.toast('Please select at least one benefit for Pro Rata or Fixed Salary model', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      // Validate re-entry fields
      if (!this.payrollForm.reenterAccountNumber) {
        this.$bvToast.toast('Please re-enter the account number', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (!this.payrollForm.reenterIfscCode) {
        this.$bvToast.toast('Please re-enter the IFSC code', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (!this.payrollForm.reenterPanNumber) {
        this.$bvToast.toast('Please re-enter the PAN number', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      // Check for mismatches
      if (this.payrollForm.accountNumberMismatch) {
        this.$bvToast.toast('Account number does not match the original value', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (this.payrollForm.ifscCodeMismatch) {
        this.$bvToast.toast('IFSC code does not match the original value', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (this.payrollForm.panNumberMismatch) {
        this.$bvToast.toast('PAN number does not match the original value', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        })
        return
      }

      this.payrollForm.submitting = true

      try {
        // Create FormData for file uploads
        const formData = new FormData()
        
        // Add candidate metadata from downloadCandidateMetadata
        const candidateMetadata = {
          "Employee Number": this.candidateData.candidate_id,
          "Name": this.candidateMetadata.aadhaarName || (this.candidateData.first_name + ' ' + this.candidateData.last_name),
          "Joining Date": this.formatDatePayroll(this.payrollForm.joiningDate),
          "Date Of Birth": this.formatDatePayroll(this.candidateData.dob || '1900-01-01'),
          "Employee Status": this.candidateMetadata.employeeStatus || "",
          "Gender": this.candidateData.gender === 'Male' ? 'M' : this.candidateData.gender === 'Female' ? 'F' : '',
          "Email Address": this.candidateData.email,
          "Pan Number": this.candidateMetadata.panNumber,
          "Blood Group": this.candidateMetadata.bloodGroup || "",
          "Manager's Employee No": this.candidateMetadata.managerEmpNo || "",
          "Emergency Contact No": this.candidateMetadata.emergencyContactNo || null,
          "Bank Account Number": this.candidateMetadata.accountNumber,
          "IFSC Code": this.candidateMetadata.ifscCode,
          "Bank Account Type": this.candidateMetadata.accountType || "",
          "Bank Name": this.candidateMetadata.bankName || "",
          "Branch Name": this.candidateMetadata.branchName || "",
          "Payment Mode": this.candidateMetadata.paymentMode || "Bank Transfer",
          "ESI Number": this.candidateMetadata.esiNumber || "",
          "Is employee covered under LWF?": this.candidateMetadata.lwfCovered || "",
          "Name (As on Aadhaar Card)": this.candidateMetadata.aadhaarName || (this.candidateData.first_name + ' ' + this.candidateData.last_name),
          "Aadhaar Card Number": this.candidateMetadata.aadhaarNumber,
          "Universal Account Number": this.candidateMetadata.uanNumber || "",
          "Mobile Number": this.candidateData.contact_no,
          "Country Of Origin": this.candidateMetadata.countryOfOrigin || "India",
          "Division": this.candidateMetadata.division || "",
          "Grade": this.candidateMetadata.grade || "",
          "Designation": this.candidateMetadata.title || "",
          "Location": this.payrollForm.location,
          "Department": this.payrollForm.project,
          "Company": this.candidateMetadata.company || "",
          "Cost Center": this.payrollForm.project + ' - ' + this.payrollForm.location || ""
        }

        // Override with form data
        candidateMetadata["Location"] = this.payrollForm.location
        candidateMetadata["Department"] = this.payrollForm.project
        candidateMetadata["Joining Date"] = this.formatDatePayroll(this.payrollForm.joiningDate)
        candidateMetadata["Offered Gross"] = this.payrollForm.offeredGross

        // Add metadata as JSON string
        formData.append('candidateMetadata', JSON.stringify(candidateMetadata))
        
        // Add form fields
        formData.append('project', this.payrollForm.project)
        formData.append('location', this.payrollForm.location)
        formData.append('joiningDate', this.payrollForm.joiningDate)
        formData.append('offeredGross', this.payrollForm.offeredGross)
        formData.append('accountNumberChecked', this.payrollForm.accountNumberChecked)
        formData.append('ifscCodeChecked', this.payrollForm.ifscCodeChecked)
        formData.append('panNumberChecked', this.payrollForm.panNumberChecked)
        
        // Add Smart Meter specific fields
        if (this.isSmartMeterProject) {
          formData.append('salaryModel', this.payrollForm.salaryModel)
          formData.append('benefitsIncluded', JSON.stringify(this.payrollForm.benefitsIncluded))
        }
        
        // Add offer letter file
        if (this.payrollForm.offerLetter) {
          formData.append('offerLetter', this.payrollForm.offerLetter)
        }
        
        // Add candidate ID
        formData.append('candidateId', this.candidateData.id)
        
        // Call both APIs with the same formData
        let response;
        let approvalResponse;
        
        // Always call the approval service first
        approvalResponse = await CandidateService.submitToPayrollApproval(formData);
        
        // Then call the main payroll service
        response = await CandidateService.submitToPayroll(formData);
        
        if (response.status === 'OK') {
          // Send HR approval email
          try {
            const mailData = {
              candidate_id: this.candidateData.candidate_id,
              name: this.candidateData.first_name + ' ' + this.candidateData.last_name,
              email: this.candidateData.email,
              contact_no: this.candidateData.contact_no,
              project: this.payrollForm.project,
              location: this.payrollForm.location,
              joiningDate: this.formatDatePayroll(this.payrollForm.joiningDate),
              offeredGross: this.payrollForm.offeredGross,
              panNumber: this.candidateMetadata.panNumber,
              aadhaarNumber: this.candidateMetadata.aadhaarNumber,
              accountNumber: this.candidateMetadata.accountNumber,
              ifscCode: this.candidateMetadata.ifscCode,
              rec_name: this.userData.name,
              rec_email: this.userData.email,
              submissionDate: new Date().toLocaleDateString('en-IN'),
              // Document upload status
              aadhaarUploaded: this.candidateData.aadhaar_card,
              panUploaded: this.candidateData.pan_card,
              photoUploaded: this.candidateData.photo,
              certificateUploaded: this.candidateData.skill_certificate,
              bankUploaded: this.candidateData.bank_proof,
              offerLetter: this.payrollForm.offerLetter ? true : false
            }
            
            const hrApprovalMail = emailTemplates.payrollHRApprovalMail(mailData)
            
            // Send email using the same service as other emails
            const emailResponse = await this.$http.post('/api/email/send', hrApprovalMail)
            
            if (emailResponse.data.success) {
              console.log('HR approval email sent successfully')
            } else {
              console.error('Failed to send HR approval email:', emailResponse.data.message)
            }
          } catch (emailError) {
            console.error('Error sending HR approval email:', emailError)
            // Don't fail the entire submission if email fails
          }
          
          const successMessage = this.shouldCallApprovalService 
            ? 'Payroll submission sent for HR approval' 
            : 'Payroll approved and employee onboarded successfully';
          
          this.$bvToast.toast(successMessage, {
            title: 'Success',
            variant: 'success',
            solid: true
          })
          
          // Close modal and reset form
          this.$bvModal.hide('payroll-modal')
          this.resetPayrollForm()
        } else {
          throw new Error(response.message || 'Failed to submit payroll data')
        }
        
      } catch (error) {
        console.error('Error submitting payroll data:', error)
        this.$bvToast.toast(error.message || 'Error submitting payroll data', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.payrollForm.submitting = false
      }
    },

    resetPayrollForm() {
      this.payrollForm = {
        project: null,
        location: null,
        joiningDate: null,
        offeredGross: null,
        accountNumberChecked: false,
        ifscCodeChecked: false,
        panNumberChecked: false,
        offerLetter: null,
        salaryModel: null,
        benefitsIncluded: [],
        submitting: false,
        reenterAccountNumber: '',
        accountNumberMismatch: false,
        reenterIfscCode: '',
        ifscCodeMismatch: false,
        reenterPanNumber: '',
        panNumberMismatch: false
      }
      // Reset main form reenter fields as well
      this.reenterUanNumber = '';
    },
    // previewOfferLetter() {

    // }
    validatePanNumber() {
      const panRegex = /^[A-Z]{5}\d{4}[A-Z]$/;
      this.panNumberFormatError = !panRegex.test(this.candidateMetadata.panNumber);
    },
    validateReenterPanNumber() {
      this.panNumberMismatchError = this.reenterPanNumber !== this.candidateMetadata.panNumber;
      this.reenterPanNumberFormatError = !/^[A-Z]{5}\d{4}[A-Z]$/.test(this.reenterPanNumber);
      this.panNumbersMatch = !this.panNumberMismatchError && !this.reenterPanNumberFormatError;
    },
    validateUanNumber() {
      const uanRegex = /^\d{12}$/;
      this.uanNumberFormatError = !uanRegex.test(this.candidateMetadata.uanNumber);
    },
    validateReenterUanNumber() {
      this.uanNumberMismatchError = this.reenterUanNumber !== this.candidateMetadata.uanNumber;
      this.reenterUanNumberFormatError = !/^\d{12}$/.test(this.reenterUanNumber);
      this.uanNumbersMatch = !this.uanNumberMismatchError && !this.reenterUanNumberFormatError;
    },
    allowOnlyNumbers(event) {
      // Allow only numeric keys (0-9)
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Only numbers are allowed in UAN field",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
    },
    validateAccountNumber() {
      const accountRegex = /^\d+$/;
      this.accountNumberFormatError = !accountRegex.test(this.candidateMetadata.accountNumber);
    },
    validateReenterAccountNumber() {
      this.accountNumberMismatchError = this.reenterAccountNumber !== this.candidateMetadata.accountNumber;
      this.reenterAccountNumberFormatError = !/^\d+$/.test(this.reenterAccountNumber);
      this.accountNumbersMatch = !this.accountNumberMismatchError && !this.reenterAccountNumberFormatError;
    },
    validateIfscCode() {
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      this.ifscCodeFormatError = !ifscRegex.test(this.candidateMetadata.ifscCode);
    },
    validateReenterIfscCode() {
      this.ifscCodeMismatchError = this.reenterIfscCode !== this.candidateMetadata.ifscCode;
      this.reenterIfscCodeFormatError = !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(this.reenterIfscCode);
      this.ifscCodesMatch = !this.ifscCodeMismatchError && !this.reenterIfscCodeFormatError;
    },
    preventPaste(event) {
      event.preventDefault();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copy-paste is not allowed for security reasons. Please type manually.",
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    preventCopy(event) {
      event.preventDefault();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copying is not allowed for security reasons.",
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    preventCut(event) {
      event.preventDefault();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Cut operation is not allowed for security reasons.",
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    preventContextMenu(event) {
      event.preventDefault();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Right-click menu is disabled for security reasons.",
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    isStageVisible(stage) {
      // Stage 1: Tagging - Always visible when OfferProcess is initiated
      if (stage === 'tagging') return true;
      
      // Stage 8: HR Discussion - Always visible from the beginning
      if (stage === 'hrDiscussion') return true;
      
      // Helper function to check if candidate's business is KYC F&A
      const isKYCFABusiness = () => {
        if (!this.candidateJobData || !this.candidateJobData.extra_details) {
          return false;
        }
        
        try {
          const extraDetails = typeof this.candidateJobData.extra_details === 'string' 
            ? JSON.parse(this.candidateJobData.extra_details) 
            : this.candidateJobData.extra_details;
          
          return extraDetails && extraDetails.business === 'KYC F&A';
        } catch (error) {
          console.error('Error parsing extra_details for business check:', error);
          return false;
        }
      };
      
      // Check if tagging is properly completed (Tagged + ReqId)
      const isTaggingCompleted = () => {
        const taggingStatus = this.getOfferProcessStatus('tagging');
        const taggingReqId = this.offerProcess.tagging.reqId;
        return taggingStatus === 'Tagged' && taggingReqId && taggingReqId.trim() !== '';
      };
      
      // If tagging is not completed (Pending or no ReqId), only show tagging and HR discussion
      if (!isTaggingCompleted()) {
        return stage === 'tagging' || stage === 'hrDiscussion';
      }
      
      // Stage 2: Early KGS BGV - Visible only if Tagging is completed AND business is KYC F&A
      if (stage === 'earlyKgsBGV') {
        return isTaggingCompleted() && isKYCFABusiness();
      }
      
      // Stage 3: Job Application - Visible only if Tagging is Tagged AND ReqId is provided
      if (stage === 'jobApplication') {
        return isTaggingCompleted();
      }
      
      // Stage 4: CAF - Visible only if Tagging is Tagged AND ReqId is provided AND Job Application is Completed
      if (stage === 'caf') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        return isTaggingCompleted() && jobApplicationStatus === 'Completed';
      }
      
      // Stage 5: Documentation - Visible only if all above + CAF is Completed
      if (stage === 'documentation') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        return isTaggingCompleted() && jobApplicationStatus === 'Completed' && cafStatus === 'Completed';
      }
      
      // Stage 6: TAF - Visible only if all above + Documentation is Completed
      if (stage === 'taf') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        const documentationStatus = this.getOfferProcessStatus('documentation');
        return isTaggingCompleted() && jobApplicationStatus === 'Completed' && cafStatus === 'Completed' && documentationStatus === 'Completed';
      }
      
      // Stage 7: HAF - Visible only if all above + TAF is Completed
      if (stage === 'haf') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        const documentationStatus = this.getOfferProcessStatus('documentation');
        const tafStatus = this.getOfferProcessStatus('taf');
        return isTaggingCompleted() && jobApplicationStatus === 'Completed' && cafStatus === 'Completed' && documentationStatus === 'Completed' && tafStatus === 'Completed';
      }
      
      // Stage 9: Fitment - Visible only if all above + HR Discussion is Completed
      if (stage === 'fitment') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        const documentationStatus = this.getOfferProcessStatus('documentation');
        const tafStatus = this.getOfferProcessStatus('taf');
        const hafStatus = this.getOfferProcessStatus('haf');
        const hrDiscussionStatus = this.getOfferProcessStatus('hrDiscussion');
        return isTaggingCompleted() && 
               jobApplicationStatus === 'Completed' && 
               cafStatus === 'Completed' && 
               documentationStatus === 'Completed' && 
               tafStatus === 'Completed' && 
               hafStatus === 'Completed' && 
               (hrDiscussionStatus === 'Completed' || hrDiscussionStatus === 'Rejected');
      }
      
      // Stage 10: OfferDesk - Visible only if all above + Fitment is Completed
      if (stage === 'offerDesk') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        const documentationStatus = this.getOfferProcessStatus('documentation');
        const tafStatus = this.getOfferProcessStatus('taf');
        const hafStatus = this.getOfferProcessStatus('haf');
        const hrDiscussionStatus = this.getOfferProcessStatus('hrDiscussion');
        const fitmentStatus = this.getOfferProcessStatus('fitment');
        return isTaggingCompleted() && 
               jobApplicationStatus === 'Completed' && 
               cafStatus === 'Completed' && 
               documentationStatus === 'Completed' && 
               tafStatus === 'Completed' && 
               hafStatus === 'Completed' && 
               (hrDiscussionStatus === 'Completed' || hrDiscussionStatus === 'Rejected') && 
               fitmentStatus === 'Completed';
      }
      
      // Stage 11: KGS BGV - Visible only if all above + OfferDesk is Extended
      if (stage === 'kgsBGV') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        const documentationStatus = this.getOfferProcessStatus('documentation');
        const tafStatus = this.getOfferProcessStatus('taf');
        const hafStatus = this.getOfferProcessStatus('haf');
        const hrDiscussionStatus = this.getOfferProcessStatus('hrDiscussion');
        const fitmentStatus = this.getOfferProcessStatus('fitment');
        const offerDeskStatus = this.getOfferProcessStatus('offerDesk');
        return isTaggingCompleted() && 
               jobApplicationStatus === 'Completed' && 
               cafStatus === 'Completed' && 
               documentationStatus === 'Completed' && 
               tafStatus === 'Completed' && 
               hafStatus === 'Completed' && 
               (hrDiscussionStatus === 'Completed' || hrDiscussionStatus === 'Rejected') && 
               fitmentStatus === 'Completed' && 
               offerDeskStatus === 'Extended';
      }
      
      // Stage 12: Offer Accepted - Visible only if all above + KGS BGV is Initiated, InProcess With Client, Pending With Candidate, or Cleared
      if (stage === 'offerAccepted') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        const documentationStatus = this.getOfferProcessStatus('documentation');
        const tafStatus = this.getOfferProcessStatus('taf');
        const hafStatus = this.getOfferProcessStatus('haf');
        const hrDiscussionStatus = this.getOfferProcessStatus('hrDiscussion');
        const fitmentStatus = this.getOfferProcessStatus('fitment');
        const offerDeskStatus = this.getOfferProcessStatus('offerDesk');
        const kgsBGVStatus = this.getOfferProcessStatus('kgsBGV');
        
        // KGS BGV should be in any of these states: Initiated, InProcess With Client, Pending With Candidate, or Cleared
        const validKGSBGVStatuses = ['Initiated', 'InProcess With Client', 'Pending With Candidate', 'Cleared'];
        
        return isTaggingCompleted() && 
               jobApplicationStatus === 'Completed' && 
               cafStatus === 'Completed' && 
               documentationStatus === 'Completed' && 
               tafStatus === 'Completed' && 
               hafStatus === 'Completed' && 
               (hrDiscussionStatus === 'Completed' || hrDiscussionStatus === 'Rejected') && 
               fitmentStatus === 'Completed' && 
               offerDeskStatus === 'Extended' && 
               validKGSBGVStatuses.includes(kgsBGVStatus);
      }
      
      // Stage 13: Client BGV - Visible only if all above + Offer Accepted is Yes + Client BGV is explicitly required
      if (stage === 'clientBGV') {
        const jobApplicationStatus = this.getOfferProcessStatus('jobApplication');
        const cafStatus = this.getOfferProcessStatus('caf');
        const documentationStatus = this.getOfferProcessStatus('documentation');
        const tafStatus = this.getOfferProcessStatus('taf');
        const hafStatus = this.getOfferProcessStatus('haf');
        const hrDiscussionStatus = this.getOfferProcessStatus('hrDiscussion');
        const fitmentStatus = this.getOfferProcessStatus('fitment');
        const offerDeskStatus = this.getOfferProcessStatus('offerDesk');
        const kgsBGVStatus = this.getOfferProcessStatus('kgsBGV');
        const offerAcceptedStatus = this.getOfferProcessStatus('offerAccepted');
        const clientBGVRequired = this.offerProcess.offerAccepted.clientBGVRequired;
        
        return isTaggingCompleted() && 
               jobApplicationStatus === 'Completed' && 
               cafStatus === 'Completed' && 
               documentationStatus === 'Completed' && 
               tafStatus === 'Completed' && 
               hafStatus === 'Completed' && 
               (hrDiscussionStatus === 'Completed' || hrDiscussionStatus === 'Rejected') && 
               fitmentStatus === 'Completed' && 
               offerDeskStatus === 'Extended' && 
               kgsBGVStatus === 'Initiated' && 
               offerAcceptedStatus === 'Yes' && 
               clientBGVRequired === true;
      }
      

      
      // BGV stage - Special handling for final stage
      if (stage === 'bgv') {
        const kgsBGVStatus = this.getOfferProcessStatus('kgsBGV');
        // Check if KGS BGV is completed (Cleared or Failed)
        if (kgsBGVStatus !== 'Cleared' && kgsBGVStatus !== 'Failed') {
          return false;
        }
        
        // Also check if candidate status allows BGV
        return this.candidateJobData.candidateStatus === 'Offered' || 
               this.candidateJobData.candidateStatus === 'BGV' || 
               this.candidateJobData.candidateStatus === 'Joined';
      }
      
      return false;
    },
    
    // KPMG RPO Offer Process Methods
    getOfferProcessStatus(stage) {
      // Only check offerProcess if client is KPMG RPO and available in route query
      if (!this.client || this.client !== 'KPMG RPO' || !this.$route.query.client) {
        return 'Pending';
      }
      
      if (this.candidateJobData.offerProcess && this.candidateJobData.offerProcess[stage]) {
        return this.candidateJobData.offerProcess[stage].status;
      }
      return this.offerProcess[stage].status;
    },
    
    updateOfferProcess() {
      // Only update if KPMG RPO is enabled
      if (!this.isKPMGRPOEnabled) {
        return;
      }
      
      // Handle Offer Accepted status updates
      const offerAcceptedStatus = this.offerProcess.offerAccepted.status;
      
      if (offerAcceptedStatus === 'Yes') {
        // Update candidate status to Offer Accepted regardless of Client BGV requirement
        this.statusCSelected = 'Offer Accepted';
        this.updateCandidateStatus();
        
        // Send appropriate notifications based on Client BGV requirement
        if (this.offerProcess.offerAccepted.clientBGVRequired === true) {
          // Client BGV is required - send notification about Client BGV stage
          this.$bvToast.toast('Status updated to Offer Accepted. Client BGV stage is now available.', {
            title: 'Success',
            variant: 'success',
            solid: true
          });
        } else {
          // Client BGV is not required - notify recruiter to get offer details
          this.notifyRecruiterForDetails();
        }
      } else if (offerAcceptedStatus === 'No') {
        // Update candidate status to OfferDrop
        if (this.offerProcess.offerAccepted.dropReason) {
          this.statusCSelected = 'OfferDrop';
          this.dropReason = this.offerProcess.offerAccepted.dropReason;
          this.updateCandidateStatus();
        } else {
          this.$bvToast.toast('Please select a drop reason for offer rejection.', {
            title: 'Warning',
            variant: 'warning',
            solid: true
          });
          return; // Don't proceed with update
        }
      } else if (offerAcceptedStatus === 'Re-release') {
        // Reset Fitment to Raised and send notification
        this.offerProcess.fitment.status = 'Raised';
        this.updateStageMetadata('fitment');
        
        // Send email notification
        this.sendReReleaseNotification();
        
        this.$bvToast.toast('Offer re-released! Fitment has been reset to Raised. Email notification sent.', {
          title: 'Info',
          variant: 'info',
          solid: true
        });
      }
      
      // Save offer process data to candidate job
      if (this.candidateJobData && this.candidateJobData.id) {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
        
        const payload = {
          candidateStatus: this.candidateJobData.candidateStatus, // Keep current status
          updatedBy: user,
          offerProcess: JSON.stringify(this.offerProcess)
        };
        
        CandidateService.updateCandidateStatus(this.id, this.jobId, payload).then(
          response => {
            if (response.status === 'OK') {
              this.$bvToast.toast('Offer process updated successfully', {
                title: 'Success',
                variant: 'success',
                solid: true
              });
              
              // Update local data
              this.candidateJobData.offerProcess = this.offerProcess;
              
              // Check for HR Discussion rejection
              if (this.offerProcess.hrDiscussion.status === 'Rejected') {
                this.checkHRDiscussionRejection();
              }
              
              // Check for BGV failure
              if (this.offerProcess.bgv.status === 'Failed') {
                this.checkBGGFailure();
              }
            }
          },
          error => {
            console.error('Error updating offer process:', error);
            this.$bvToast.toast('Error updating offer process', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
          }
        );
      }
    },
    
    loadOfferProcessData() {
      // Only load if KPMG RPO is enabled
      if (!this.isKPMGRPOEnabled && !this.isRelianceRPOEnabled) {
        return;
      }
      
      // Load offer process data from candidate job
      if (this.candidateJobData && this.candidateJobData.offerProcess) {
        try {
          const savedData = typeof this.candidateJobData.offerProcess === 'string' 
            ? JSON.parse(this.candidateJobData.offerProcess) 
            : this.candidateJobData.offerProcess;
          
          this.offerProcess = {
            ...this.offerProcess,
            ...savedData
          };
        } catch (error) {
          console.error('Error parsing offer process data:', error);
        }
      }
    },
    
    loadBusinessAndPOCOptions() {
      // Check if user has permission to access KPMG RPO dropdown data
      if (!this.$can('read', 'post_selection_process') && !this.$can('manage', 'post_selection_process')) {
        console.warn('User does not have permission to access KPMG RPO dropdown data');
        this.$bvToast.toast('You do not have permission to access KPMG RPO dropdown data', {
          title: 'Permission Denied',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      // Load business options
      adminConfigService.getClientDropdownList(this.client).then(res => {
        if(res.status === 200) {
          console.log('in kpmg rpo dropdown list', res.data.data)
          this.businessOptions = res.data.data.businessList || 'Other'
          this.pocOptions = res.data.data.pocList || 'Other'
          this.levelOptions = res.data.data.levelList || 'Other'
        }
      }).catch(error => {
        console.error('Error loading business options:', error);
        this.$bvToast.toast('Error loading KPMG RPO dropdown data', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      });
      
      // Load POC options
      // adminConfigService.getPOCList().then(res => {
      //   if (res.data && res.data.data) {
      //     this.pocOptions = res.data.data.map(poc => ({
      //       value: poc.id,
      //       text: poc.name
      //     }));
      //   }
      // }).catch(error => {
      //   console.error('Error loading POC options:', error);
      // });
    },
    
    checkHRDiscussionRejection() {
      // If HR Discussion is rejected, automatically set status to NotOffered
      if (this.offerProcess.hrDiscussion.status === 'Rejected') {
        this.statusCSelected = 'NotOffered';
        this.updateCandidateStatus();
      }
    },
    
    checkBGGFailure() {
      // If BGV is failed, automatically set status to NotOffered
      if (this.offerProcess.bgv.status === 'Failed') {
        this.statusCSelected = 'NotOffered';
        this.updateCandidateStatus();
      }
    },
    
    // KPMG RPO Modal Methods
    openKPMGOfferProcessModal() {
      // Only open if KPMG RPO is enabled
      if (!this.isKPMGRPOEnabled) {
        this.$bvToast.toast('KPMG RPO features are not available for this client', {
          title: 'Warning',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      // Load existing offer process data
      this.loadOfferProcessData();
      
      // Load business and POC options
      
      
      // Force progress calculation
      this.$nextTick(() => {
        console.log('Modal opened - Progress calculation:');
        console.log('Completed stages:', this.completedStagesCount);
        console.log('Total stages:', this.totalStagesCount);
        console.log('Progress percentage:', this.progressPercentage);
      });
      
      this.$refs["modal-kpmg-offer-process"].show();
    },
    openRelianceRPOOfferProcessModal() {
      // Only open if Reliance RPO is enabled
      if (!this.isRelianceRPOEnabled) {
        this.$bvToast.toast('Reliance RPO features are not available for this client', {
          title: 'Warning',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      // Load existing Reliance offer process data
      this.loadRelianceOfferProcessData();
      
      // Force progress calculation
      this.$nextTick(() => {
        console.log('Reliance Modal opened - Progress calculation:');
        console.log('Completed stages:', this.relianceCompletedStagesCount);
        console.log('Total stages:', this.relianceTotalStagesCount);
        console.log('Progress percentage:', this.relianceProgressPercentage);
      });
      
      this.$refs["modal-reliance-rpo-offer-process"].show();
    },
    

    
    saveKPMGOfferProcess() {
      // Only save if KPMG RPO is enabled
      if (!this.isKPMGRPOEnabled) {
        this.$bvToast.toast('KPMG RPO features are not available for this client', {
          title: 'Warning',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      // Check for BGV failures and validate drop reasons
      const kgsBGVFailed = this.offerProcess.kgsBGV.status === 'Failed';
      const clientBGVFailed = this.offerProcess.clientBGV.status === 'Failed';
      
      if (kgsBGVFailed && !this.offerProcess.kgsBGV.dropReason) {
        this.$bvToast.toast('Please select a drop reason for KGS BGV failure.', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }
      
      if (clientBGVFailed && !this.offerProcess.clientBGV.dropReason) {
        this.$bvToast.toast('Please select a drop reason for Client BGV failure.', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }
      
      // Set flag to indicate this is a KPMG Offer Process update
      this.isKPMGOfferProcessUpdate = true;
      
      // If any BGV stage failed, update candidate status to NotOffered
      if (kgsBGVFailed || clientBGVFailed) {
        this.statusCSelected = 'NotOffered';
        this.dropReason = kgsBGVFailed ? this.offerProcess.kgsBGV.dropReason : this.offerProcess.clientBGV.dropReason;
        
        // Update candidate status with drop reason
        this.updateCandidateStatus();
      } else {
        // Save offer process data without changing status
        this.updateOfferProcess();
      }
      
      this.$refs["modal-kpmg-offer-process"].hide();
    },
    

    
    onStageStatusChange(stageName) {
      // Update metadata for the stage that changed
      if (stageName) {
        this.updateStageMetadata(stageName);
      }
      
      // Handle special logic for offerAccepted stage
      if (stageName === 'offerAccepted') {
        this.handleOfferAcceptedChange();
      }
      
      // Debug progress calculation
      console.log('Stage changed:', stageName);
      console.log('Completed stages:', this.completedStagesCount);
      console.log('Total stages:', this.totalStagesCount);
      console.log('Progress percentage:', this.progressPercentage);
      
      // Force Vue to re-evaluate the isStageVisible computed properties
      this.$forceUpdate();
    },
    
    handleOfferAcceptedChange() {
      const offerAcceptedStatus = this.offerProcess.offerAccepted.status;
      
      if (offerAcceptedStatus === 'Yes') {
        // Offer Accepted is Yes - check if Client BGV is required
        this.checkClientBGVRequirement();
      } else if (offerAcceptedStatus === 'No') {
        // Offer Accepted is No - show drop reason selection
        if (!this.offerProcess.offerAccepted.dropReason) {
          this.$bvToast.toast('Please select a drop reason for offer rejection.', {
          title: 'Warning',
          variant: 'warning',
          solid: true
        });
        }
      } else if (offerAcceptedStatus === 'Re-release') {
        // Offer Accepted is Re-release - prepare for re-release
        this.$bvToast.toast('Offer re-release selected. Click OK to confirm and reset Fitment to Raised.', {
          title: 'Info',
          variant: 'info',
          solid: true
        });
      }
      
      // Reset clientBGVRequired flag when status changes
      if (offerAcceptedStatus !== 'Yes') {
        this.offerProcess.offerAccepted.clientBGVRequired = null;
      }
    },
    
    // Reliance RPO Offer Process Methods
    saveRelianceOfferProcess() {
      // Only save if Reliance RPO is enabled
      if (!this.isRelianceRPOEnabled) {
        this.$bvToast.toast('Reliance RPO features are not available for this client', {
          title: 'Warning',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      // Update timestamps for changed stages
      const user = JSON.parse(localStorage.getItem('userData'));
      const username = `${user.emp_id} - ${user.first_name} ${user.last_name}`;
      const updatedBy = `[{"title" : "${user.first_name} ${user.last_name}", "emp_id": "${user.emp_id}"}]`;
      const now = new Date().toISOString();
      
      // Update each stage's metadata
      ['documentation', 'confirmation', 'medical'].forEach(stageName => {
        if (!this.relianceOfferProcess[stageName].createdAt) {
          this.relianceOfferProcess[stageName].createdAt = now;
          this.relianceOfferProcess[stageName].createdBy = username;
        }
        this.relianceOfferProcess[stageName].updatedAt = now;
        this.relianceOfferProcess[stageName].updatedBy = username;
      });
      
      // Prepare payload for API call
      const payload = {
        candidateStatus: this.candidateJobData.candidateStatus, // Keep current status
        updatedBy: updatedBy,
        offerProcess: this.relianceOfferProcess
      };
      
      CandidateService.updateCandidateStatus(this.id, this.jobId, payload).then(
        response => {
          if (response.status === 'OK') {
            this.$bvToast.toast('Reliance offer process updated successfully', {
              title: 'Success',
              variant: 'success',
              solid: true
            });
            
            // Update local data
            this.candidateJobData.relianceOfferProcess = this.relianceOfferProcess;
          }
        },
        error => {
          console.error('Error updating Reliance offer process:', error);
          this.$bvToast.toast('Error updating Reliance offer process', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      );
      
      this.$refs["modal-reliance-rpo-offer-process"].hide();
    },
    
    loadRelianceOfferProcessData() {
      // Only load if Reliance RPO is enabled
      if (!this.isRelianceRPOEnabled) {
        return;
      }
      
      // Load existing offer process data from candidateJobData
      if (this.candidateJobData && this.candidateJobData.relianceOfferProcess) {
        try {
          const savedData = typeof this.candidateJobData.relianceOfferProcess === 'string' 
            ? JSON.parse(this.candidateJobData.relianceOfferProcess) 
            : this.candidateJobData.relianceOfferProcess;
          
          this.relianceOfferProcess = {
            ...this.relianceOfferProcess,
            ...savedData
          };
        } catch (error) {
          console.error('Error parsing Reliance offer process data:', error);
        }
      }
    },
    
    onRelianceStageStatusChange(stageName) {
      // Update timestamp when stage status changes
      const user = JSON.parse(localStorage.getItem('userData'));
      const username = `${user.emp_id} - ${user.first_name} ${user.last_name}`;
      const now = new Date().toISOString();
      
      if (!this.relianceOfferProcess[stageName].createdAt) {
        this.relianceOfferProcess[stageName].createdAt = now;
        this.relianceOfferProcess[stageName].createdBy = username;
      }
      this.relianceOfferProcess[stageName].updatedAt = now;
      this.relianceOfferProcess[stageName].updatedBy = username;
      
      // Debug progress calculation
      console.log('Reliance Stage changed:', stageName);
      console.log('Completed stages:', this.relianceCompletedStagesCount);
      console.log('Total stages:', this.relianceTotalStagesCount);
      console.log('Progress percentage:', this.relianceProgressPercentage);
      
      // Force Vue to re-evaluate computed properties
      this.$forceUpdate();
    },
    
    openRelianceCommentModal(stageName) {
      this.currentCommentStage = stageName;
      this.currentCommentText = '';
      this.currentCommentType = 'reliance'; // Flag to identify Reliance comments
      this.$refs['comment-modal'].show();
    },
    
    toggleRelianceComments(stageName) {
      this.showAllRelianceComments[stageName] = !this.showAllRelianceComments[stageName];
    },
    
    saveRelianceComment() {
      if (!this.currentCommentText || !this.currentCommentText.trim()) {
        this.$bvToast.toast('Please enter a comment', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      const user = JSON.parse(localStorage.getItem('userData'));
      const username = `${user.emp_id} - ${user.first_name} ${user.last_name}`;
      
      const comment = {
        id: Date.now(),
        text: this.currentCommentText.trim(),
        user: username,
        timestamp: new Date().toISOString()
      };
      
      // Add comment to the appropriate stage
      if (!this.relianceOfferProcess[this.currentCommentStage].comments) {
        this.relianceOfferProcess[this.currentCommentStage].comments = [];
      }
      this.relianceOfferProcess[this.currentCommentStage].comments.push(comment);
      
      // Clear and close modal
      this.currentCommentText = '';
      this.$refs['comment-modal'].hide();
      
      this.$bvToast.toast('Comment added successfully', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    
    sendReReleaseNotification() {
      // Get recruiter details
      const rec_email = this.candidateJobData.recruiter_email;
      const rec_name = this.candidateJobData.recruiter_name;
      const tl_email = this.candidateJobData.team_lead_email;
      
      if (rec_email) {
        const mailData = {
          can_email: this.candidateData.email,
          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
          can_contact: this.candidateData.contact_no,
          can_id: this.candidateData.candidate_id,
          position_name: this.position_name,
          job_id: this.jobCode,
          client: this.client,
          rec_email: rec_email,
          rec_name: rec_name,
          tl_email: tl_email
        };
        
        // Send email using email templates
        const mail = emailTemplates.kpmgOfferReReleaseNotification(mailData);
        
        if (mail && process.env.NODE_ENV === "production") {
          mailService.mail(mail).then(res => {
            console.log('Re-release notification email sent:', res);
          }).catch(err => {
            console.error('Error sending re-release notification email:', err);
          });
        }
      }
    },
    
    getTeamLeadEmail() {
      // This would typically get the team lead email from user data or API
      // For now, return a placeholder
      return 'teamlead@example.com';
    },
    
    checkClientBGVRequirement() {
      // Show a confirmation dialog to ask if Client BGV is required
      this.$bvModal.msgBoxConfirm('Is Client BGV required for this candidate?', {
        title: 'Client BGV Requirement',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes, Required',
        cancelTitle: 'No, Not Required',
        footerClass: 'p-2',
        hideHeaderClose: true,
        noCloseOnBackdrop: true,
        centered: true
      }).then(value => {
        if (value) {
          // Client BGV is required - set flag and confirm the Yes status
          this.offerProcess.offerAccepted.clientBGVRequired = true;
          this.offerProcess.offerAccepted.status = 'Yes';
          this.$bvToast.toast('Client BGV is required. Click OK to confirm and update status to Offer Accepted.', {
            title: 'Success',
            variant: 'success',
            solid: true
          });
        } else {
          // Client BGV is not required - set flag and confirm the Yes status
          this.offerProcess.offerAccepted.clientBGVRequired = false;
          this.offerProcess.offerAccepted.status = 'Yes';
          this.$bvToast.toast('Client BGV not required. Click OK to confirm and update status to Offer Accepted.', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      }
      }).catch(() => {
        // If user cancels or closes modal, reset the status back to Pending
        this.offerProcess.offerAccepted.status = 'Pending';
        this.offerProcess.offerAccepted.clientBGVRequired = null;
      });
    },
    
    notifyRecruiterForDetails() {
      // Send email notification to recruiter with candidate view link
      this.sendRecruiterNotification();
      
      this.$bvToast.toast('Recruiter has been notified to get offer details. Status updated to Offer Accepted.', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    
    sendRecruiterNotification() {
      // Get recruiter details
      const rec_email = this.candidateJobData.recruiter_email;
      const rec_name = this.candidateJobData.recruiter_name;
      const tl_email = this.candidateJobData.team_lead_email;
      
      if (rec_email) {
        const mailData = {
          can_email: this.candidateData.email,
          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
          can_contact: this.candidateData.contact_no,
          can_id: this.candidateData.candidate_id,
          position_name: this.position_name,
          job_id: this.jobCode,
          client: this.client,
          rec_email: rec_email,
          rec_name: rec_name,
          tl_email: tl_email,
          candidate_view_link: `${window.location.origin}/apps/candidates-view/${this.id}/${this.jobId}?job_id=${this.jobCode}&position_name=${this.position_name}&client=${this.client}`
        };
        
        // Send email using email templates
        const mail = emailTemplates.kpmgRecruiterNotificationForOfferDetails(mailData);
        
        if (mail && process.env.NODE_ENV === "production") {
          mailService.mail(mail).then(res => {
            console.log('Recruiter notification email sent:', res);
          }).catch(err => {
            console.error('Error sending recruiter notification email:', err);
          });
        }
      }
    },
    //     variant: 'success',
    //     solid: true
    //   });
    // },
    
    sendRecruiterNotification() {
      // This would typically call an API to send email notification
      // For now, we'll just log it
      console.log('Sending recruiter notification email...');
      
      // TODO: Implement email notification API call
      // EmailService.sendRecruiterNotification({
      //   candidateId: this.candidateData.id,
      //   candidateName: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
      //   jobId: this.jobId,
      //   positionName: this.position_name,
      //   recruiterEmail: this.recruiter,
      //   teamLeadEmail: this.getTeamLeadEmail(),
      //   candidateViewLink: `${window.location.origin}/apps/candidates/view/${this.candidateData.id}/${this.jobId}`
      // });
    },
    
    updateStageMetadata(stageName) {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const username = `${userData.first_name} ${userData.last_name}`;
      const currentTime = new Date().toISOString();
      
      if (!this.offerProcess[stageName].createdAt) {
        // First time saving this stage
        this.offerProcess[stageName].createdAt = currentTime;
        this.offerProcess[stageName].createdBy = username;
      }
      
      // Always update the updatedAt and updatedBy
      this.offerProcess[stageName].updatedAt = currentTime;
      this.offerProcess[stageName].updatedBy = username;
    },
    
    addStageComment(stageName, comment) {
      if (!comment || comment.trim() === '') return;
      
      const userData = JSON.parse(localStorage.getItem("userData"));
      const username = `${userData.first_name} ${userData.last_name}`;
      const currentTime = new Date().toISOString();
      
      const newComment = {
        id: Date.now(),
        text: comment.trim(),
        timestamp: currentTime,
        user: username
      };
      
      if (!this.offerProcess[stageName].comments) {
        this.offerProcess[stageName].comments = [];
      }
      
      this.offerProcess[stageName].comments.push(newComment);
      
      // Clear the comment input
      this.$nextTick(() => {
        if (this.$refs[`comment-${stageName}`] && this.$refs[`comment-${stageName}`][0]) {
          this.$refs[`comment-${stageName}`][0].value = '';
        }
      });
    },
    
    openCommentModal(stageName) {
      this.currentCommentStage = stageName;
      this.currentCommentText = '';
      this.$refs['comment-modal'].show();
    },
    
    saveComment() {
      if (!this.currentCommentText || this.currentCommentText.trim() === '') {
        this.$bvToast.toast('Please enter a comment', {
          title: 'Warning',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      // Check if this is a Reliance comment
      if (this.currentCommentType === 'reliance') {
        this.saveRelianceComment();
        return;
      }
      
      this.addStageComment(this.currentCommentStage, this.currentCommentText);
      this.$refs['comment-modal'].hide();
      this.currentCommentText = '';
    },
    
    toggleComments(stageName) {
      this.showAllComments[stageName] = !this.showAllComments[stageName];
    },

    notifyReRelease() {
      // Get recruiter details
      const rec_email = this.candidateJobData.recruiter_email;
      const rec_name = this.candidateJobData.recruiter_name;
      const tl_email = this.candidateJobData.team_lead_email;
      
      if (rec_email) {
        const mailData = {
          can_email: this.candidateData.email,
          can_fname: `${this.candidateData.first_name} ${this.candidateData.last_name}`,
          can_contact: this.candidateData.contact_no,
          can_id: this.candidateData.candidate_id,
          position_name: this.position_name,
          job_id: this.jobCode,
          client: this.client,
          location: this.locations,
          rec_email: rec_email,
          rec_name: rec_name,
          tl_email: tl_email
        };
        
        let mail = emailTemplates.kpmgOfferReReleaseNotification(mailData);
        
        if (mail && process.env.NODE_ENV === "production") {
          mailService.mail(mail).then(res => {
            console.log('Re-release notification email sent:', res);
          }).catch(err => {
            console.error('Error sending re-release notification email:', err);
          });
        }
      }
      
      // Notify through email about re-release
      this.$bvToast.toast('Fitment has been reset to Raised. Email notification sent.', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },


  },
  

  
  watch: {
    offerProcess: {
      handler() {
        // Force re-computation of progress when offer process changes
        this.$forceUpdate();
      },
      deep: true
    },
    displayedCandidateTimeline() {
      this.measureCandidateTimelineOverflow()
    },
    expandedTimelineRuns: {
      handler() {
        this.measureCandidateTimelineOverflow()
      },
      deep: true,
    },
  },
  
  mounted() {
      // Hide the context menu when clicking elsewhere

      adminConfigService.getProjectDropdownList().then(res=>{
        this.projectLocationOptions = res.data.data.locationList
        this.projectOptions = res.data.data.projectList
        this.projectStateOptions = res.data.data.stateList
        
      })
      if(this.isKPMGRPOEnabled || this.client === 'KPMG RPO'){
      this.loadBusinessAndPOCOptions();
      }
      this.loadExotelConfig();
      this.measureCandidateTimelineOverflow()
      window.addEventListener('resize', this.measureCandidateTimelineOverflow)
    },
  beforeDestroy() {
    window.removeEventListener('resize', this.measureCandidateTimelineOverflow)
  },
  computed: {
    displayedCandidateTimeline() {
      const history = this.candidateTimelineEvents || []
      const jobs = this.mapJobsToTimelineEntries(this.candidateJobs)
      if (!history.length) return this.groupTimelineByJob(jobs)
      const jobsByKey = {}
      jobs.forEach(job => {
        jobsByKey[job.jobKey] = job
      })
      const activityByJob = {}
      const statusEvents = []
      history.forEach(event => {
        if (event.hasOwnStatus) {
          statusEvents.push(event)
          return
        }
        const keys = [event.jobKey, event.jobCode].filter(Boolean)
        if (!keys.length) keys.push('job')
        keys.forEach(key => {
          if (!activityByJob[key]) activityByJob[key] = []
          if (activityByJob[key].indexOf(event) === -1) activityByJob[key].push(event)
        })
      })
      const assignmentApplied = {}
      const merged = statusEvents.map(event => {
        const job = jobsByKey[event.jobKey]
        if (!job) return event
        const sameStatus = this.timelineStatusesMatch(event.status, job.status)
        const isLatestSameStatus = sameStatus && !assignmentApplied[event.jobKey]
        if (sameStatus) assignmentApplied[event.jobKey] = true
        return Object.assign({}, event, {
          sourcerName: event.sourcerName || job.sourcerName,
          recruiterName: event.recruiterName || job.recruiterName,
          clientName: event.clientName || job.clientName,
          actorName: event.actorName || job.actorName,
          source: event.source || job.source,
          comment: event.comment || (isLatestSameStatus ? job.comment : ''),
          reason: event.reason || (isLatestSameStatus ? job.reason : ''),
          raw: Object.assign({}, job.raw, event.raw),
        })
      })
      const jobsWithActivity = jobs.map(job => {
        const acts = activityByJob[job.jobKey] || activityByJob[job.jobCode] || []
        if (!acts.length) return job
        const latest = acts[0]
        const updates = acts.slice(1).map((entry, updateIndex) => (
          this.diffCollapsedTimelineFields(entry, acts[updateIndex])
        ))
        return Object.assign({}, job, {
          comment: this.sanitizeTimelineText(job.comment) || latest.comment,
          reason: this.sanitizeTimelineText(job.reason) || latest.reason,
          time: latest.time || job.time,
          updateCount: acts.length,
          updates,
        })
      })
      return this.groupTimelineByJob(jobsWithActivity.concat(merged))
    },
    isAssignMode() {
      return !!this.$route.query.assign
    },
    isEarlyStatus() {
      const status = this.candidateJobData?.candidateStatus || ''
      return [
        'UploadedBySourcer', 'UploadedByRecruiter', 'AssignedByMassMail',
        'AssignedByATSSourcer', 'AssignedByATSMassMailer',
        'Not Answered', 'Not Reachable', 'Wrong Number', 'Call Back',
        'Not Interested', 'Not Relevant', 'Duplicate',
      ].includes(status)
    },
    isSattvaHumanClient() {
      return this.client === 'Sattva Human Pvt Ltd'
    },
    isSattvaRestrictedRole() {
      return (
        this.$can('read', 'talent_acquisition') ||
        this.$can('read', 'account_manager') ||
        this.$can('read', 'program_manager') ||
        this.$can('read', 'mis')
      )
    },
    canShowResume() {
      if (!this.isSattvaHumanClient || !this.isSattvaRestrictedRole) return true
      return !!this.prevStatus && !this.isEarlyStatus
    },
    isRecruiterForCandidate() {
      if (!this.jobId || !this.candidateJobData) return true
      if (this.$can('read', 'admin') || this.$can('read', 'master') || this.$can('read', 'hr_head')) return true
      const empId = this.emp_id || JSON.parse(localStorage.getItem('userData') || '{}').emp_id || ''
      if (!empId) return true
      const rec = this.candidateJobData.recruiter
      const mgr = this.candidateJobData.mgr_id
      const am = (() => { try { return JSON.parse(this.candidateJobData.account_mgr)[0]?.emp_id } catch { return null } })()
      return String(rec) === String(empId) || String(mgr) === String(empId) || (am && String(am) === String(empId))
    },
    formatDate() {
      return moment(this.candidateData.createdAt).format("DD MMM YYYY HH:mm:ss")
    },
    displayedNotes() {
      // Sort notes by date in descending order
      const sortedNotes = [...this.notes].sort((a, b) => 
        new Date(b.addedOn) - new Date(a.addedOn)
      );
      
      // Return all notes if showAllNotes is true, otherwise return top 3
      return this.showAllNotes ? sortedNotes : sortedNotes.slice(0, 1);
    },
    isSmartMeterProject() {
      return this.payrollForm.project && this.payrollForm.project.includes('Smart Meter');
    },
    isHRHead() {
      return this.userRole === 'HR-DIRECTOR' || this.userRole === 'HR';
    },
    isHRCoordinator() {
      return this.userRole === 'HR-COORDINATOR';
    },
    payrollButtonText() {
      if (this.isHRHead && this.payrollApprovalStatus === 'pending') {
        return 'Approve & Onboard';
      } else if (this.isHRCoordinator && this.payrollApprovalStatus === null) {
        return 'Submit to HR Approval';
      } else {
        return 'Submit to Payroll';
      }
    },
    shouldCallApprovalService() {
      return this.isHRCoordinator && this.payrollApprovalStatus === null;
    },
    isPOCAssigned() {
      // Check if a POC is assigned to this candidate in extra_details
      if (!this.candidateJobData.extra_details) {
        return false;
      }
      
      try {
        const extraDetails = typeof this.candidateJobData.extra_details === 'string' 
          ? JSON.parse(this.candidateJobData.extra_details) 
          : this.candidateJobData.extra_details;
        
        return extraDetails && extraDetails.poc && extraDetails.poc.trim() !== '';
      } catch (error) {
        console.error('Error parsing extra_details for POC check:', error);
        return false;
      }
    },
    
    // Check if KPMG RPO Offer Process should be in read-only mode
    isKPMGOfferProcessReadOnly() {
      const readOnlyStatuses = ['Joined', 'NotOffered', 'OfferDrop', 'Attrition', 'Duplicate', 'Early Attrition'];
      return readOnlyStatuses.includes(this.candidateJobData?.candidateStatus);
    },
    isInfraIndustryValidationFailed() {
      // Check if this is Infra Industry with validation requirements
      const isInfraIndustry = this.statusCSelected === 'Offered' && 
        (this.positionType === 'Contractual' || this.positionType === 'Cost Plus') && 
        this.payroll === 'Sattva Payroll' && 
        this.vertical === 'Infra Industry';
      
      if (!isInfraIndustry) {
        return false;
      }
      
      // Check for validation failures
      return this.panNumberFormatError || 
             this.panNumberMismatchError || 
             this.reenterPanNumberFormatError ||
             this.uanNumberFormatError ||
             this.uanNumberMismatchError ||
             this.reenterUanNumberFormatError ||
             this.accountNumberFormatError ||
             this.accountNumberMismatchError ||
             this.reenterAccountNumberFormatError ||
             this.ifscCodeFormatError ||
             this.ifscCodeMismatchError ||
             this.reenterIfscCodeFormatError ||
             !this.candidateMetadata.aadhaarNumber ||
             !this.candidateMetadata.panNumber ||
             !this.reenterPanNumber ||
             !this.candidateMetadata.uanNumber ||
             !this.reenterUanNumber ||
             !this.candidateMetadata.accountNumber ||
             !this.reenterAccountNumber ||
             !this.candidateMetadata.ifscCode ||
             !this.reenterIfscCode ||
             !this.candidateMetadata.title ||
             !this.candidateMetadata.projectName ||
             !this.candidateMetadata.projectLocation ||
             !this.candidateMetadata.projectState ||
             !this.offeredDate ||
             !this.joiningDate ||
             !this.offeredCTC ||
             this.offeredCTC < 9999;
    },
    
    // KPMG RPO Progress Tracking
    completedStagesCount() {
      let count = 0;
      
      // Debug: Log the offer process data
      console.log('Offer Process Data:', this.offerProcess);
      console.log('Candidate Job Data:', this.candidateJobData);
      
      // Tagging stage - 10% (requires both status and Req ID)
      const taggingStatus = this.getOfferProcessStatus('tagging');
      const taggingReqId = this.offerProcess.tagging.reqId;
      console.log('Tagging Status:', taggingStatus, 'ReqId:', taggingReqId);
      
      if (taggingStatus === 'Tagged' && 
          taggingReqId && 
          taggingReqId.trim() !== '') {
        count += 1;
        console.log('Tagging completed, count:', count);
      }
      
      // Early KGS BGV stage - 10% (only for KYC F&A business)
      const earlyKgsBGVStatus = this.getOfferProcessStatus('earlyKgsBGV');
      console.log('Early KGS BGV Status:', earlyKgsBGVStatus);
      
      // Check if candidate's business is KYC F&A
      const isKYCFABusiness = () => {
        if (!this.candidateJobData || !this.candidateJobData.extra_details) {
          return false;
        }
        
        try {
          const extraDetails = typeof this.candidateJobData.extra_details === 'string' 
            ? JSON.parse(this.candidateJobData.extra_details) 
            : this.candidateJobData.extra_details;
          
          return extraDetails && extraDetails.business === 'KYC F&A';
        } catch (error) {
          console.error('Error parsing extra_details for business check:', error);
          return false;
        }
      };
      
      if (isKYCFABusiness() && (earlyKgsBGVStatus === 'Cleared' || earlyKgsBGVStatus === 'Failed')) {
        count += 1;
        console.log('Early KGS BGV completed, count:', count);
      }
      
      // Job Application stage - 10%
      const jobAppStatus = this.getOfferProcessStatus('jobApplication');
      console.log('Job App Status:', jobAppStatus);
      if (jobAppStatus === 'Completed') {
        count += 1;
        console.log('Job App completed, count:', count);
      }
      
      // CAF stage - 10%
      const cafStatus = this.getOfferProcessStatus('caf');
      console.log('CAF Status:', cafStatus);
      if (cafStatus === 'Completed') {
        count += 1;
        console.log('CAF completed, count:', count);
      }
      
      // Documentation stage - 10%
      const docStatus = this.getOfferProcessStatus('documentation');
      console.log('Doc Status:', docStatus);
      if (docStatus === 'Completed') {
        count += 1;
        console.log('Doc completed, count:', count);
      }
      
      // TAF stage - 10%
      const tafStatus = this.getOfferProcessStatus('taf');
      console.log('TAF Status:', tafStatus);
      if (tafStatus === 'Completed') {
        count += 1;
        console.log('TAF completed, count:', count);
      }
      
      // HAF stage - 10%
      const hafStatus = this.getOfferProcessStatus('haf');
      console.log('HAF Status:', hafStatus);
      if (hafStatus === 'Completed') {
        count += 1;
        console.log('HAF completed, count:', count);
      }
      
      // HR Discussion stage - 10%
      const hrStatus = this.getOfferProcessStatus('hrDiscussion');
      console.log('HR Status:', hrStatus);
      if (hrStatus === 'Completed' || hrStatus === 'Rejected') {
        count += 1;
        console.log('HR completed, count:', count);
      }
      
      // Fitment stage - 10%
      const fitmentStatus = this.getOfferProcessStatus('fitment');
      console.log('Fitment Status:', fitmentStatus);
      if (fitmentStatus === 'Completed') {
        count += 1;
        console.log('Fitment completed, count:', count);
      }
      
      // OfferDesk stage - 10%
      const offerDeskStatus = this.getOfferProcessStatus('offerDesk');
      console.log('OfferDesk Status:', offerDeskStatus);
      if (offerDeskStatus === 'Extended') {
        count += 1;
        console.log('OfferDesk completed, count:', count);
      }
      const kgsBGVStatus = this.getOfferProcessStatus('kgsBGV');
      console.log('KGS BGV Status:', kgsBGVStatus);
      if (kgsBGVStatus === 'Initiated') {
        count += 1;
        console.log('KGS BGV completed, count:', count);
      }
      
      // Offer Accepted stage - 11th stage
      const offerAcceptedStatus = this.getOfferProcessStatus('offerAccepted');
      console.log('Offer Accepted Status:', offerAcceptedStatus);
      if (offerAcceptedStatus === 'Yes' || offerAcceptedStatus === 'No' || offerAcceptedStatus === 'Re-release') {
        count += 1;
        console.log('Offer Accepted completed, count:', count);
      }
      
      // Client BGV stage - 12th stage (only if Client BGV is required and completed)
      const clientBGVStatus = this.getOfferProcessStatus('clientBGV');
      const clientBGVRequired = this.offerProcess.offerAccepted.clientBGVRequired;
      console.log('Client BGV Status:', clientBGVStatus, 'Required:', clientBGVRequired);
      if (clientBGVStatus === 'Cleared' && clientBGVRequired === true) {
        count += 1;
        console.log('Client BGV completed, count:', count);
      }
      
      console.log('Final completed count:', count);
      return count;
    },
    
    totalStagesCount() {
      // Check if Client BGV is required
      const clientBGVRequired = this.offerProcess.offerAccepted.clientBGVRequired;
      
      // Check if candidate's business is KYC F&A
      const isKYCFABusiness = () => {
        if (!this.candidateJobData || !this.candidateJobData.extra_details) {
          return false;
        }
        
        try {
          const extraDetails = typeof this.candidateJobData.extra_details === 'string' 
            ? JSON.parse(this.candidateJobData.extra_details) 
            : this.candidateJobData.extra_details;
          
          return extraDetails && extraDetails.business === 'KYC F&A';
        } catch (error) {
          console.error('Error parsing extra_details for business check:', error);
          return false;
        }
      };
      
      let total = 11; // Base stages
      if (isKYCFABusiness()) total += 1; // Add earlyKgsBGV for KYC F&A
      if (clientBGVRequired === true) total += 1; // Add clientBGV if required
      
      console.log('Total stages count:', total, 'Client BGV Required:', clientBGVRequired, 'KYC F&A Business:', isKYCFABusiness());
      return total;
    },
    
    progressPercentage() {
      if (this.totalStagesCount === 0) return 0;
      const percentage = Math.round((this.completedStagesCount / this.totalStagesCount) * 100);
      console.log('Progress percentage:', percentage);
      return percentage;
    },
    
    isKPMGOfferProcessCompleted() {
      // Only check if KPMG RPO is enabled
      if (!this.isKPMGRPOEnabled) {
        return false;
      }
      
      // Tagging stage - requires both status and Req ID
      const taggingComplete = this.getOfferProcessStatus('tagging') === 'Tagged' && 
                              this.offerProcess.tagging.reqId && 
                              this.offerProcess.tagging.reqId.trim() !== '';
      
      // Early KGS BGV stage (only for KYC F&A business)
      const isKYCFABusiness = () => {
        if (!this.candidateJobData || !this.candidateJobData.extra_details) {
          return false;
        }
        
        try {
          const extraDetails = typeof this.candidateJobData.extra_details === 'string' 
            ? JSON.parse(this.candidateJobData.extra_details) 
            : this.candidateJobData.extra_details;
          
          return extraDetails && extraDetails.business === 'KYC F&A';
        } catch (error) {
          console.error('Error parsing extra_details for business check:', error);
          return false;
        }
      };
      
      const earlyKgsBGVComplete = !isKYCFABusiness() || 
                                 (isKYCFABusiness() && (this.getOfferProcessStatus('earlyKgsBGV') === 'Cleared' || 
                                                       this.getOfferProcessStatus('earlyKgsBGV') === 'Failed'));
      
      // Job Application stage
      const jobAppComplete = this.getOfferProcessStatus('jobApplication') === 'Completed';
      
      // CAF stage
      const cafComplete = this.getOfferProcessStatus('caf') === 'Completed';
      
      // Documentation stage
      const docComplete = this.getOfferProcessStatus('documentation') === 'Completed';
      
      // TAF stage
      const tafComplete = this.getOfferProcessStatus('taf') === 'Completed';
      
      // HAF stage
      const hafComplete = this.getOfferProcessStatus('haf') === 'Completed';
      
      // HR Discussion stage
      const hrComplete = this.getOfferProcessStatus('hrDiscussion') === 'Completed' || 
                        this.getOfferProcessStatus('hrDiscussion') === 'Rejected';
      
      // Fitment stage
      const fitmentComplete = this.getOfferProcessStatus('fitment') === 'Completed';
      
      // OfferDesk stage
      const offerDeskComplete = this.getOfferProcessStatus('offerDesk') === 'Extended';
      
      // KGS BGV stage
      const kgsBGVComplete = this.getOfferProcessStatus('kgsBGV') === 'Initiated';
      
      // Offer Accepted stage
      const offerAcceptedComplete = this.getOfferProcessStatus('offerAccepted') === 'Yes' || 
                                   this.getOfferProcessStatus('offerAccepted') === 'No' || 
                                   this.getOfferProcessStatus('offerAccepted') === 'Re-release';
      
      // Client BGV stage (only if required)
      const clientBGVRequired = this.offerProcess.offerAccepted.clientBGVRequired;
      const clientBGVComplete = clientBGVRequired === false || 
                               (clientBGVRequired === true && this.getOfferProcessStatus('clientBGV') === 'Cleared');
      
      return taggingComplete && earlyKgsBGVComplete && jobAppComplete && cafComplete && docComplete && 
             tafComplete && hafComplete && hrComplete && fitmentComplete && 
             offerDeskComplete && kgsBGVComplete && offerAcceptedComplete && clientBGVComplete;
    },
    
    isBGVCompleted() {
      if (!this.isKPMGRPOEnabled) {
        return false;
      }
      const status = this.getOfferProcessStatus('bgv');
      return status === 'Cleared' || status === 'Failed';
    },
    
    isKPMGOfferProcessInProgress() {
      return this.isKPMGRPOEnabled && this.candidateJobData.candidateStatus === 'Shortlisted' && 
             (this.candidateJobData.offerProcess || this.offerProcess);
    },
    
    isBGVInProgress() {
      return this.isKPMGRPOEnabled && this.candidateJobData.candidateStatus === 'Offered' &&
        this.getOfferProcessStatus('bgv') !== 'Pending';
    },
    
    isKPMGRPOEnabled() {
      if(this.client === 'KPMG RPO' && this.$route.query.client) {
        return true
      }
      return false
    },
    isRelianceRPOEnabled() {
      if(this.client === 'Reliance RPO' && this.$route.query.client) {
        return true
      }
      return false
    },
    
    /**
     * Check if interview process exists in extra_details (for Reliance RPO)
     */
    hasInterviewProcess() {
      if (!this.candidateJobData?.extra_details?.interview_process) {
        return false
      }
      return true
    },
    
    /**
     * Check if any interview round has status 'final_select' (for Reliance RPO)
     * This automatically enables "Selected" status
     */
    hasFinalSelect() {
      const process = this.candidateJobData?.extra_details?.interview_process
      if (!process || !process.round_results) {
        // Also check local interviewProcess
        const localResults = this.interviewProcess?.round_results || {}
        for (const roundKey in localResults) {
          const roundData = localResults[roundKey]
          const status = typeof roundData === 'object' ? roundData.status : roundData
          if (status === 'final_select') {
            return true
          }
        }
        return false
      }
      
      const roundResults = process.round_results
      for (const roundKey in roundResults) {
        const roundData = roundResults[roundKey]
        const status = typeof roundData === 'object' ? roundData.status : roundData
        if (status === 'final_select') {
          return true
        }
      }
      
      // Also check local interviewProcess
      const localResults = this.interviewProcess?.round_results || {}
      for (const roundKey in localResults) {
        const roundData = localResults[roundKey]
        const status = typeof roundData === 'object' ? roundData.status : roundData
        if (status === 'final_select') {
          return true
        }
      }
      
      return false
    },
    
    /**
     * Check if the last interview round has status 'select' (for Reliance RPO)
     * This determines if "Selected" status option should be available
     */
    isLastInterviewRoundSelect() {
      const process = this.candidateJobData?.extra_details?.interview_process
      if (!process || !process.rounds || !process.round_results) {
        return false
      }
      
      // Handle both object format (old data) and number format (new data)
      const roundCount = typeof process.rounds === 'object' ? process.rounds.value : process.rounds
      if (!roundCount || isNaN(roundCount)) return false
      
      const lastRoundKey = 'round' + roundCount
      const lastRoundData = process.round_results[lastRoundKey]
      
      if (!lastRoundData) {
        return false
      }
      
      // Handle both object format and string format
      const status = typeof lastRoundData === 'object' ? lastRoundData.status : lastRoundData
      return status === 'select'
    },

    /**
     * True when current last round (by interviewRounds dropdown) has select or final_select.
     * Used to show Selection Date only when all rounds are complete for Reliance RPO.
     */
    isCurrentLastRoundSelectOrFinalSelect() {
      if (!this.hasInterviewProcess || !this.interviewProcess?.round_results) {
        return false
      }
      const totalRounds = Math.max(1, Number(this.interviewRounds) || 1)
      const lastRoundKey = 'round' + totalRounds
      const lastRoundData = this.interviewProcess.round_results[lastRoundKey]
      const status = lastRoundData && typeof lastRoundData === 'object' ? lastRoundData.status : null
      return status === 'select' || status === 'final_select'
    },
    
    isPOCForKPMGOfferProcess() {
      
      const user = JSON.parse(localStorage.getItem('userData'));
      const username = `${user.emp_id} - ${user.first_name} ${user.last_name}`;
      
      // Check if user is a PRIMARY or BKP POC from pocOptions
      const userPOC = this.pocOptions ? this.pocOptions.find(poc => 
        poc.title.includes(user.emp_id)
      ) : null;
      console.log('primary or bkp POC', userPOC, this.pocOptions)
      const isPrimaryOrBKPPOC = userPOC && (userPOC.abbrev === 'PRIMARY' || userPOC.abbrev === 'BKP');
      
      // Only check extra_details.poc if candidateJobData and extra_details exist (KPMG RPO candidates only)
      let hasPOCAccess = false;
      
      if (this.candidateJobData && this.candidateJobData.extra_details) {
        try {
          let extraDetails = this.candidateJobData.extra_details;
          
          // Parse if it's a string
          if (typeof extraDetails === 'string') {
            extraDetails = JSON.parse(extraDetails);
          }
          
          // Check if poc key exists and matches username
          hasPOCAccess = extraDetails && extraDetails.poc && extraDetails.poc === username;
          console.log('hasPOCAccess', hasPOCAccess)
        } catch (error) {
          console.error('Error parsing extra_details:', error);
          hasPOCAccess = false;
        }
      }
      
      return this.client === 'KPMG RPO' && this.$route.query.client && 
             (hasPOCAccess || isPrimaryOrBKPPOC || this.$can('manage','post_selection_process'));
    },
    
    // Reliance RPO Progress Tracking
    relianceCompletedStagesCount() {
      let count = 0;
      
      // Documentation stage
      if (this.relianceOfferProcess.documentation.status === 'Completed') {
        count += 1;
      }
      
      // Confirmation stage
      if (this.relianceOfferProcess.confirmation.status === 'Confirmed') {
        count += 1;
      }
      
      // Medical stage
      if (this.relianceOfferProcess.medical.status === 'Fit') {
        count += 1;
      }
      
      return count;
    },
    
    relianceTotalStagesCount() {
      return 3;
    },
    
    relianceProgressPercentage() {
      return Math.round((this.relianceCompletedStagesCount / this.relianceTotalStagesCount) * 100);
    },
    
    isRelianceOfferProcessCompleted() {
      // Check from candidateJobData.offerProcess first (database data)
      if (this.candidateJobData && this.candidateJobData.offerProcess) {
        try {
          const op = typeof this.candidateJobData.offerProcess === 'string' 
            ? JSON.parse(this.candidateJobData.offerProcess) 
            : this.candidateJobData.offerProcess;
          
          // Check if this is Reliance format (has documentation, confirmation, medical)
          if (op.documentation && op.confirmation && op.medical) {
            return op.documentation.status === 'Completed' &&
                   op.confirmation.status === 'Confirmed' &&
                   op.medical.status === 'Fit';
          }
        } catch (error) {
          console.error('Error parsing offerProcess for Reliance completion check:', error);
        }
      }
      
      // Fallback to local data
      return this.relianceCompletedStagesCount === this.relianceTotalStagesCount;
    },
    
    isRelianceOfferProcessReadOnly() {
      // Read only if candidate is in certain final statuses
      const readOnlyStatuses = ['Joined', 'Early Attrition', 'Attrition'];
      return this.candidateJobData && readOnlyStatuses.includes(this.candidateJobData.candidateStatus);
    },
    
    isPOCForRelianceOfferProcess() {
      // const user = JSON.parse(localStorage.getItem('userData'));
      
      // // Check if user is a PRIMARY or BKP POC from pocOptions
      // const userPOC = this.pocOptions ? this.pocOptions.find(poc => 
      //   poc.title && poc.title.includes(user.emp_id)
      // ) : null;
      // const isPrimaryOrBKPPOC = userPOC && (userPOC.abbrev === 'PRIMARY' || userPOC.abbrev === 'BKP');
      
      // // Check if user has POC access from extra_details
      // let hasPOCAccess = false;
      
      // if (this.candidateJobData && this.candidateJobData.extra_details) {
      //   try {
      //     const extraDetails = typeof this.candidateJobData.extra_details === 'string' 
      //       ? JSON.parse(this.candidateJobData.extra_details) 
      //       : this.candidateJobData.extra_details;
          
      //     if (extraDetails && extraDetails.poc) {
      //       hasPOCAccess = extraDetails.poc.includes(user.emp_id);
      //     }
      //   } catch (error) {
      //     console.error('Error parsing extra_details for POC check:', error);
      //   }
      // }
      
      // return this.client === 'Reliance RPO' && this.$route.query.client && 
      //        (hasPOCAccess || isPrimaryOrBKPPOC || this.$can('manage','post_selection_process'));
      return this.$can('manage','reliance_dashboard');
    }
  }
};
</script>

<style lang="scss" scoped>

  .card-body {
    padding: 1rem !important;
  }
  .timeline-item {
    padding-bottom: 15px;
  }
  .text-muted {
    color: #9c9ca8 !important;
  }
  .bitem {
    color: #00ac49 !important;
  }
  .btn {
    padding: 0.45rem 0.55rem !important;
    font-size: 0.88rem;
    line-height: 1.1;
  }
  
  // Call button styles
  .call-btn {
    min-width: 60px;
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    
    .fas.fa-phone {
      margin-right: 4px;
    }
    
    .fas.fa-spin {
      animation: spin 1s linear infinite;
    }
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  // Mask Aadhaar number input
  .aadhaar-masked {
    -webkit-text-security: disc;
    text-security: disc;
  }
  
  // Mask UAN number input
  .uan-masked {
    -webkit-text-security: disc;
    text-security: disc;
  }
  
  // Mask account number input
  .account-number-masked {
    -webkit-text-security: disc;
    text-security: disc;
  }
  
  // Mask PAN number input
  .pan-masked {
    -webkit-text-security: disc;
    text-security: disc;
  }
  
  // Mask IFSC code input
  .ifsc-masked {
    -webkit-text-security: disc;
    text-security: disc;
  }
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/quill.scss';
</style>
<style lang="scss" scoped>
.candidate-timeline-panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.candidate-timeline-scroll {
  max-height: min(420px, 50vh) !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  min-height: 0;
}

.candidate-timeline-scroll.is-expanded {
  max-height: min(70vh, 640px) !important;
}

.candidate-timeline-view-all {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 0.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #00cfe8;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.app-timeline.candidate-app-timeline {
  ::v-deep .timeline-item {
    margin-bottom: 0 !important;
    padding-bottom: 0.85rem !important;
    border-left: 1px solid #ebe9f1 !important;
  }
  ::v-deep .timeline-item:last-child,
  ::v-deep .timeline-item:last-of-type {
    padding-bottom: 0 !important;
    border-left: 1px solid #ebe9f1 !important;
    &:after {
      display: none !important;
    }
  }
}

.timeline-card {
  width: 100%;
  min-width: 0;
}

.timeline-card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.25rem 0.75rem;
  width: 100%;
  margin-bottom: 0.45rem;
}

.timeline-card-title {
  margin: 0;
  color: #2c2c2c;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
}

.timeline-card-time {
  color: #4b4b4b;
  font-size: 14px;
  line-height: 1.4;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
  text-align: right;
}

.timeline-event-time {
  color: #6e6b7b;
  font-size: 12px;
  font-weight: 400;
}

.timeline-card-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem 1.25rem;
  width: 100%;
}

.timeline-card-col {
  min-width: 4.25rem;
}

.timeline-card-dates {
  margin-top: 0.55rem;
}

.timeline-card-label {
  display: block;
  margin-bottom: 0.3rem;
  color: #5e5873;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

.timeline-card-value {
  display: block;
  color: #2c2c2c;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
}

.timeline-card-avatars {
  display: flex;
  align-items: center;
}

.timeline-actor {
  display: inline-flex;
  align-items: center;
  margin-left: 0;
  vertical-align: middle;
}

.timeline-card-avatars ::v-deep .b-avatar,
.timeline-actor ::v-deep .b-avatar,
.timeline-initials {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px;
  padding: 0;
  border-radius: 50%;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
}

.timeline-card-avatars ::v-deep .b-avatar {
  color: #28c76f !important;
}

.timeline-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 207, 232, 0.12);
  color: #28c76f;
}

.timeline-initials-actor {
  background-color: rgba(130, 134, 139, 0.12);
  color: #82868b !important;
}

.timeline-followup-meta,
.timeline-compact-meta,
.timeline-compact-extra,
.timeline-compact-comment {
  font-size: 14px;
  line-height: 1.45;
  color: #4b4b4b;
}

.timeline-status {
  color: #2c2c2c;
  font-size: 14px;
  font-weight: 600;
}

.timeline-followup-meta,
.timeline-compact-meta {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  gap: 0.75rem;
}

.timeline-heading-update {
  margin-top: 0.55rem;
}

.timeline-heading-update-main {
  min-width: 0;
  flex: 1 1 auto;
}

.timeline-heading-update .timeline-compact-comment {
  margin-top: 0;
}

.timeline-followup-main,
.timeline-compact-meta-main {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem 0.65rem;
  min-width: 0;
  flex: 1 1 auto;
}

.timeline-followup-source,
.timeline-compact-badges {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.2rem 0.15rem;
  margin-left: auto;
  flex-shrink: 0;
}

.timeline-compact-badges > * + *::before {
  content: '·';
  margin: 0 0.4rem 0 0.25rem;
  color: #9aa0a6;
  font-weight: 400;
}

.timeline-status-label,
.timeline-prior-label {
  color: #2c2c2c;
  font-weight: 600;
}

.timeline-source-badge {
  display: inline-block;
  padding: 0.05rem 0.4rem;
  border-radius: 999px;
  background: #eef2f3;
  color: #4b4b4b;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.timeline-compact-comment {
  margin-top: 0.4rem;
  color: #4b4b4b;
  white-space: pre-wrap;
  word-break: break-word;
}

.timeline-run-toggle,
.timeline-run-show-all {
  display: inline-flex;
  align-items: center;
  margin-top: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #00cfe8;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.timeline-run-toggle ::v-deep .feather {
  margin-right: 0.25rem;
}

.timeline-run-show-all {
  margin-top: 0.25rem;
}

.timeline-run-updates {
  margin-top: 0.35rem;
  padding-left: 0.75rem;
  border-left: 2px solid rgba(0, 207, 232, 0.28);
}

.timeline-run-update {
  padding: 0.25rem 0;
}

.timeline-run-update + .timeline-run-update {
  border-top: 1px solid #f0eef5;
}

.timeline-content {
  white-space: pre-wrap;
  word-break: break-word;
}

.timeline-custom {
  position: relative;
  padding: 0.5rem 0; // Reduced padding

  &::before {
    content: '';
    position: absolute;
    left: 0.5rem;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #ebe9f1;
  }
}

.timeline-custom .timeline-item {
  position: relative;
  padding-left: 2rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.timeline-dot {
  position: absolute;
  left: 0;
  top: 0.25rem;
  height: 12px;
  width: 12px;
  border-radius: 50%;

  &.bg-info {
    background-color: #00cfe8 !important;
  }

  &.bg-warning {
    background-color: #ff9f43 !important;
  }
}

.timeline-content {
  background: #f8f8f8;
  padding: 0.75rem; // Reduced padding
  border-radius: 0.5rem;
  margin-left: 0.5rem; // Reduced margin
  
  p {
    white-space: pre-wrap;
    word-break: break-word;
  }
}

// KPMG RPO Offer Process Styles
.stage-card {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  
  &.completed {
    border-color: #28a745;
    background-color: #f8fff9;
    
    .card-title {
      color: #28a745;
    }
  }
  
  &.rejected {
    border-color: #dc3545;
    background-color: #fff8f8;
    
    .card-title {
      color: #dc3545;
    }
  }
  
  &.failed {
    border-color: #dc3545;
    background-color: #fff8f8;
    
    .card-title {
      color: #dc3545;
    }
  }
  
  .card-title {
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
  }
  
  .form-group {
    margin-bottom: 0.5rem;
  }
  
  .form-group label {
    font-size: 0.8rem;
    font-weight: 500;
    margin-bottom: 0.25rem;
  }
}

.kpmg-offer-process-container,
.kpmg-bgv-container {
  .bgv-completion-notice {
    background: #f8f9fa;
    padding: 0.75rem;
    border-radius: 0.375rem;
    border: 1px solid #e9ecef;
  }
  // Progress Section
  .progress-section {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 0.5rem;
    border: 1px solid #e9ecef;
    
    .progress-info {
      display: flex;
      flex-direction: column;
      margin-bottom: 0.5rem;
      
      .progress-text {
        font-weight: 500;
        color: #495057;
        margin-bottom: 0.25rem;
      }
      
      .completion-notice {
        font-size: 0.85rem;
        margin-top: 0.25rem;
        
        i {
          margin-right: 0.25rem;
        }
      }
    }
    
    .progress {
      height: 8px;
      border-radius: 4px;
      background-color: #e9ecef;
      
      .progress-bar {
        transition: width 0.3s ease;
      }
    }
  }
  
  // Stages List
  .stages-list {
    .stage-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.75rem 1rem;
      margin-bottom: 0.5rem;
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 0.375rem;
      transition: all 0.2s ease;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      // Stage Info
      .stage-info {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex: 1;
        
        .stage-number {
          font-weight: 600;
          color: #6c757d;
          min-width: 1.5rem;
        }
        
        .stage-name {
          font-weight: 500;
          color: #495057;
          min-width: 120px;
        }
        
        .badge {
          font-size: 0.7rem;
          padding: 0.25rem 0.5rem;
        }
        
        .stage-status {
          display: inline-flex;
          align-items: center;
          gap: 0.15rem;
          font-size: 0.85rem;
          font-weight: 500;
          
          i {
            font-size: 0.9rem;
          }
          
          &.text-success {
            color: #28a745;
          }
          
          &.text-warning {
            color: #ffc107;
          }
          
          &.text-danger {
            color: #dc3545;
          }
          
          &.text-info {
            color: #17a2b8;
          }
          
          &.text-primary {
            color: #007bff;
          }
        }
      }
      
      // Stage Actions
      .stage-actions {
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;
        min-width: 300px;
        justify-content: flex-end;
        
        .form-radio-group {
          display: flex;
          gap: 1rem;
          align-items: center;
          
          .form-radio {
            margin: 0;
            white-space: nowrap;
            
            .form-radio-input {
              margin-right: 0.25rem;
            }
            
            .form-radio-label {
              font-size: 0.85rem;
              margin: 0;
            }
          }
        }
        
        .req-id-input {
          width: 120px;
          font-size: 0.85rem;
        }
        
        .rejection-comment {
          width: 200px;
          font-size: 0.85rem;
          margin-top: 0.5rem;
        }
      }
      
      // Active State
      &.active {
        border-color: #007bff;
        background: #f8f9ff;
        box-shadow: 0 1px 3px rgba(0, 123, 255, 0.1);
      }
      
      // Completed State
      &.completed {
        border-color: #28a745;
        background: #f8fff9;
        
        .stage-name {
          color: #28a745;
        }
      }
      
      // Rejected State (for HR Discussion)
      &.rejected {
        border-color: #dc3545;
        background: #fff8f8;
        
        .stage-name {
          color: #dc3545;
        }
      }
      
      // HR Discussion special styling
      &.hr-discussion {
        border-left: 3px solid #17a2b8;
        background: #f8f9fa;
      }
    }
  }
  
  // Responsive adjustments
  @media (max-width: 768px) {
    .stages-list {
      .stage-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
        
        .stage-info {
          width: 100%;
        }
        
        .stage-actions {
          width: 100%;
          justify-content: flex-start;
          min-width: auto;
          
          .form-radio-group {
            flex-wrap: wrap;
            gap: 0.5rem;
          }
          
          .rejection-comment {
            width: 100%;
          }
        }
      }
    }
  }
  
  // Comments Section Styles
  .comments-section {
    border-top: 1px solid #e9ecef;
    padding-top: 10px;
    margin-top: 10px;
    
    .comments-list {
      max-height: 200px;
      overflow-y: auto;
      border: 1px solid #e9ecef;
      border-radius: 4px;
      padding: 8px;
      background-color: #f8f9fa;
      margin-top: 8px;
      
      .comment-item {
        margin-bottom: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dee2e6;
        
        &:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }
        
        .comment-text {
          margin-top: 4px;
          font-size: 0.9em;
          color: #495057;
        }
      }
    }
  }
  
  // Business and POC Section Styles
  .business-poc-section {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    
    .section-title {
      color: #495057;
      font-weight: 600;
    }
  }

  // Reliance RPO Interview Process – compact summary
  .reliance-rpo-interview-summary {
    background-color: #f8f9fa;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    border: 1px solid #e9ecef;

    .reliance-rpo-summary-line {
      font-size: 0.875rem;
      .badge { font-size: 0.75rem; }
    }
    .reliance-rpo-round-badge {
      font-size: 0.7rem;
      padding: 0.2rem 0.4rem;
    }
    .reliance-rpo-rounds-select {
      display: inline-block;
      min-width: 100px;
    }
    .reliance-rpo-round-date {
      max-width: 140px;
    }
    .reliance-rpo-clear-all-btn {
      font-size: 0.75rem;
    }
  }

  // Reliance RPO compact rounds (one below another, date + status same line)
  .reliance-rpo-rounds-compact {
    padding: 0.25rem 0;
    .reliance-rpo-round-row {
      padding: 0.35rem 0;
      border-bottom: 1px solid #eee;
      &:last-child { border-bottom: none; }
    }
    .reliance-rpo-round-num {
      min-width: 4rem;
      font-size: 0.9rem;
    }
    .reliance-rpo-round-date-inline {
      width: 115px;
      display: inline-block;
      font-size: 0.8rem;
    }
    .reliance-rpo-round-status-badge {
      font-size: 0.7rem;
      padding: 0.15rem 0.4rem;
    }
    .reliance-rpo-radios-inline {
      display: inline-flex;
      flex-wrap: wrap;
      gap: 0 0.5rem;
      .custom-radio { margin-bottom: 0; }
    }
    .reliance-rpo-clear-round-btn {
      font-size: 0.75rem;
      padding: 0.2rem 0.5rem;
    }
  }
}
</style>